import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  timestamptz: any;
  numeric: any;
  geometry: any;
  geography: any;
  timestamp: any;
  uuid: any;
  name: any;
  _float8: any;
  _bool: any;
  _text: any;
  float8: any;
};


/** expression to compare columns of type _bool. All fields are combined with logical 'AND'. */
export type _Bool_Comparison_Exp = {
  _eq?: Maybe<Scalars['_bool']>;
  _gt?: Maybe<Scalars['_bool']>;
  _gte?: Maybe<Scalars['_bool']>;
  _in?: Maybe<Array<Scalars['_bool']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['_bool']>;
  _lte?: Maybe<Scalars['_bool']>;
  _neq?: Maybe<Scalars['_bool']>;
  _nin?: Maybe<Array<Scalars['_bool']>>;
};


/** expression to compare columns of type _float8. All fields are combined with logical 'AND'. */
export type _Float8_Comparison_Exp = {
  _eq?: Maybe<Scalars['_float8']>;
  _gt?: Maybe<Scalars['_float8']>;
  _gte?: Maybe<Scalars['_float8']>;
  _in?: Maybe<Array<Scalars['_float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['_float8']>;
  _lte?: Maybe<Scalars['_float8']>;
  _neq?: Maybe<Scalars['_float8']>;
  _nin?: Maybe<Array<Scalars['_float8']>>;
};


/** expression to compare columns of type _text. All fields are combined with logical 'AND'. */
export type _Text_Comparison_Exp = {
  _eq?: Maybe<Scalars['_text']>;
  _gt?: Maybe<Scalars['_text']>;
  _gte?: Maybe<Scalars['_text']>;
  _in?: Maybe<Array<Scalars['_text']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['_text']>;
  _lte?: Maybe<Scalars['_text']>;
  _neq?: Maybe<Scalars['_text']>;
  _nin?: Maybe<Array<Scalars['_text']>>;
};

/** columns and relationships of "ads" */
export type Ads = {
  __typename?: 'ads';
  ad_description_company?: Maybe<Scalars['String']>;
  ad_description_qualifications?: Maybe<Scalars['String']>;
  ad_description_tasks?: Maybe<Scalars['String']>;
  color_1?: Maybe<Scalars['String']>;
  color_2?: Maybe<Scalars['String']>;
  color_3?: Maybe<Scalars['String']>;
  color_4?: Maybe<Scalars['String']>;
  color_5?: Maybe<Scalars['String']>;
  company_logo_file_id?: Maybe<Scalars['Int']>;
  company_name?: Maybe<Scalars['String']>;
  company_staff_count?: Maybe<Scalars['String']>;
  company_url?: Maybe<Scalars['String']>;
  contact_city?: Maybe<Scalars['String']>;
  contact_country_id?: Maybe<Scalars['Int']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_fax?: Maybe<Scalars['String']>;
  contact_first_name?: Maybe<Scalars['String']>;
  contact_last_name?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  contact_street_and_nr?: Maybe<Scalars['String']>;
  contact_title?: Maybe<Scalars['String']>;
  contact_us_here_url?: Maybe<Scalars['String']>;
  contact_zip?: Maybe<Scalars['String']>;
  /** An object relationship */
  country?: Maybe<Country>;
  created_at: Scalars['timestamptz'];
  created_by_user_id?: Maybe<Scalars['Int']>;
  deleted: Scalars['Boolean'];
  /** An object relationship */
  file?: Maybe<File>;
  /** An object relationship */
  file_storyblok?: Maybe<File_Storyblok>;
  graphcool_id?: Maybe<Scalars['String']>;
  hidden: Scalars['Boolean'];
  id: Scalars['Int'];
  is_advanced?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  jobCategoryByJobCategoryId?: Maybe<Job_Category>;
  /** An object relationship */
  job_category?: Maybe<Job_Category>;
  job_category_id?: Maybe<Scalars['Int']>;
  job_city?: Maybe<Scalars['String']>;
  job_country?: Maybe<Scalars['String']>;
  job_duration?: Maybe<Scalars['String']>;
  job_geo_lang?: Maybe<Scalars['numeric']>;
  job_geo_lat?: Maybe<Scalars['numeric']>;
  job_house_nr?: Maybe<Scalars['String']>;
  job_payment?: Maybe<Scalars['String']>;
  job_region?: Maybe<Scalars['String']>;
  job_start_date?: Maybe<Scalars['String']>;
  job_street?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  job_type_id?: Maybe<Scalars['Int']>;
  job_zip?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['geography']>;
  meta_title?: Maybe<Scalars['String']>;
  /** An array relationship */
  mn_ads_job_category_subs: Array<Mn_Ads_Job_Category_Sub>;
  /** An aggregated array relationship */
  mn_ads_job_category_subs_aggregate: Mn_Ads_Job_Category_Sub_Aggregate;
  offer_upload_id?: Maybe<Scalars['Int']>;
  pdf_only?: Maybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  published_at?: Maybe<Scalars['timestamp']>;
  slug: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
};


/** columns and relationships of "ads" */
export type AdsMn_Ads_Job_Category_SubsArgs = {
  distinct_on?: Maybe<Array<Mn_Ads_Job_Category_Sub_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Mn_Ads_Job_Category_Sub_Order_By>>;
  where?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
};


/** columns and relationships of "ads" */
export type AdsMn_Ads_Job_Category_Subs_AggregateArgs = {
  distinct_on?: Maybe<Array<Mn_Ads_Job_Category_Sub_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Mn_Ads_Job_Category_Sub_Order_By>>;
  where?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
};

/** aggregated selection of "ads" */
export type Ads_Aggregate = {
  __typename?: 'ads_aggregate';
  aggregate?: Maybe<Ads_Aggregate_Fields>;
  nodes: Array<Ads>;
};

/** aggregate fields of "ads" */
export type Ads_Aggregate_Fields = {
  __typename?: 'ads_aggregate_fields';
  avg?: Maybe<Ads_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Ads_Max_Fields>;
  min?: Maybe<Ads_Min_Fields>;
  stddev?: Maybe<Ads_Stddev_Fields>;
  stddev_pop?: Maybe<Ads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ads_Stddev_Samp_Fields>;
  sum?: Maybe<Ads_Sum_Fields>;
  var_pop?: Maybe<Ads_Var_Pop_Fields>;
  var_samp?: Maybe<Ads_Var_Samp_Fields>;
  variance?: Maybe<Ads_Variance_Fields>;
};


/** aggregate fields of "ads" */
export type Ads_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Ads_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ads" */
export type Ads_Aggregate_Order_By = {
  avg?: Maybe<Ads_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Ads_Max_Order_By>;
  min?: Maybe<Ads_Min_Order_By>;
  stddev?: Maybe<Ads_Stddev_Order_By>;
  stddev_pop?: Maybe<Ads_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Ads_Stddev_Samp_Order_By>;
  sum?: Maybe<Ads_Sum_Order_By>;
  var_pop?: Maybe<Ads_Var_Pop_Order_By>;
  var_samp?: Maybe<Ads_Var_Samp_Order_By>;
  variance?: Maybe<Ads_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ads" */
export type Ads_Arr_Rel_Insert_Input = {
  data: Array<Ads_Insert_Input>;
  on_conflict?: Maybe<Ads_On_Conflict>;
};

/** aggregate avg on columns */
export type Ads_Avg_Fields = {
  __typename?: 'ads_avg_fields';
  company_logo_file_id?: Maybe<Scalars['Float']>;
  contact_country_id?: Maybe<Scalars['Float']>;
  created_by_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
  job_geo_lang?: Maybe<Scalars['Float']>;
  job_geo_lat?: Maybe<Scalars['Float']>;
  job_type_id?: Maybe<Scalars['Float']>;
  offer_upload_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ads" */
export type Ads_Avg_Order_By = {
  company_logo_file_id?: Maybe<Order_By>;
  contact_country_id?: Maybe<Order_By>;
  created_by_user_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
  job_geo_lang?: Maybe<Order_By>;
  job_geo_lat?: Maybe<Order_By>;
  job_type_id?: Maybe<Order_By>;
  offer_upload_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ads". All fields are combined with a logical 'AND'. */
export type Ads_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Ads_Bool_Exp>>>;
  _not?: Maybe<Ads_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Ads_Bool_Exp>>>;
  ad_description_company?: Maybe<String_Comparison_Exp>;
  ad_description_qualifications?: Maybe<String_Comparison_Exp>;
  ad_description_tasks?: Maybe<String_Comparison_Exp>;
  color_1?: Maybe<String_Comparison_Exp>;
  color_2?: Maybe<String_Comparison_Exp>;
  color_3?: Maybe<String_Comparison_Exp>;
  color_4?: Maybe<String_Comparison_Exp>;
  color_5?: Maybe<String_Comparison_Exp>;
  company_logo_file_id?: Maybe<Int_Comparison_Exp>;
  company_name?: Maybe<String_Comparison_Exp>;
  company_staff_count?: Maybe<String_Comparison_Exp>;
  company_url?: Maybe<String_Comparison_Exp>;
  contact_city?: Maybe<String_Comparison_Exp>;
  contact_country_id?: Maybe<Int_Comparison_Exp>;
  contact_email?: Maybe<String_Comparison_Exp>;
  contact_fax?: Maybe<String_Comparison_Exp>;
  contact_first_name?: Maybe<String_Comparison_Exp>;
  contact_last_name?: Maybe<String_Comparison_Exp>;
  contact_phone?: Maybe<String_Comparison_Exp>;
  contact_street_and_nr?: Maybe<String_Comparison_Exp>;
  contact_title?: Maybe<String_Comparison_Exp>;
  contact_us_here_url?: Maybe<String_Comparison_Exp>;
  contact_zip?: Maybe<String_Comparison_Exp>;
  country?: Maybe<Country_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: Maybe<Int_Comparison_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  file?: Maybe<File_Bool_Exp>;
  file_storyblok?: Maybe<File_Storyblok_Bool_Exp>;
  graphcool_id?: Maybe<String_Comparison_Exp>;
  hidden?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_advanced?: Maybe<Boolean_Comparison_Exp>;
  jobCategoryByJobCategoryId?: Maybe<Job_Category_Bool_Exp>;
  job_category?: Maybe<Job_Category_Bool_Exp>;
  job_category_id?: Maybe<Int_Comparison_Exp>;
  job_city?: Maybe<String_Comparison_Exp>;
  job_country?: Maybe<String_Comparison_Exp>;
  job_duration?: Maybe<String_Comparison_Exp>;
  job_geo_lang?: Maybe<Numeric_Comparison_Exp>;
  job_geo_lat?: Maybe<Numeric_Comparison_Exp>;
  job_house_nr?: Maybe<String_Comparison_Exp>;
  job_payment?: Maybe<String_Comparison_Exp>;
  job_region?: Maybe<String_Comparison_Exp>;
  job_start_date?: Maybe<String_Comparison_Exp>;
  job_street?: Maybe<String_Comparison_Exp>;
  job_title?: Maybe<String_Comparison_Exp>;
  job_type_id?: Maybe<Int_Comparison_Exp>;
  job_zip?: Maybe<String_Comparison_Exp>;
  location?: Maybe<Geography_Comparison_Exp>;
  meta_title?: Maybe<String_Comparison_Exp>;
  mn_ads_job_category_subs?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
  offer_upload_id?: Maybe<Int_Comparison_Exp>;
  pdf_only?: Maybe<Boolean_Comparison_Exp>;
  published?: Maybe<Boolean_Comparison_Exp>;
  published_at?: Maybe<Timestamp_Comparison_Exp>;
  slug?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "ads" */
export enum Ads_Constraint {
  /** unique or primary key constraint */
  AdsCompanyLogoFileIdKey = 'ads_company_logo_file_id_key',
  /** unique or primary key constraint */
  AdsGraphcoolIdKey = 'ads_graphcool_id_key',
  /** unique or primary key constraint */
  AdsMetaTitleKey = 'ads_meta_title_key',
  /** unique or primary key constraint */
  AdsOfferUploadIdKey = 'ads_offer_upload_id_key',
  /** unique or primary key constraint */
  AdsPkey = 'ads_pkey',
  /** unique or primary key constraint */
  AdsSlugKey = 'ads_slug_key'
}

/** input type for incrementing integer column in table "ads" */
export type Ads_Inc_Input = {
  company_logo_file_id?: Maybe<Scalars['Int']>;
  contact_country_id?: Maybe<Scalars['Int']>;
  created_by_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  job_category_id?: Maybe<Scalars['Int']>;
  job_geo_lang?: Maybe<Scalars['numeric']>;
  job_geo_lat?: Maybe<Scalars['numeric']>;
  job_type_id?: Maybe<Scalars['Int']>;
  offer_upload_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "ads" */
export type Ads_Insert_Input = {
  ad_description_company?: Maybe<Scalars['String']>;
  ad_description_qualifications?: Maybe<Scalars['String']>;
  ad_description_tasks?: Maybe<Scalars['String']>;
  color_1?: Maybe<Scalars['String']>;
  color_2?: Maybe<Scalars['String']>;
  color_3?: Maybe<Scalars['String']>;
  color_4?: Maybe<Scalars['String']>;
  color_5?: Maybe<Scalars['String']>;
  company_logo_file_id?: Maybe<Scalars['Int']>;
  company_name?: Maybe<Scalars['String']>;
  company_staff_count?: Maybe<Scalars['String']>;
  company_url?: Maybe<Scalars['String']>;
  contact_city?: Maybe<Scalars['String']>;
  contact_country_id?: Maybe<Scalars['Int']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_fax?: Maybe<Scalars['String']>;
  contact_first_name?: Maybe<Scalars['String']>;
  contact_last_name?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  contact_street_and_nr?: Maybe<Scalars['String']>;
  contact_title?: Maybe<Scalars['String']>;
  contact_us_here_url?: Maybe<Scalars['String']>;
  contact_zip?: Maybe<Scalars['String']>;
  country?: Maybe<Country_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Boolean']>;
  file?: Maybe<File_Obj_Rel_Insert_Input>;
  file_storyblok?: Maybe<File_Storyblok_Obj_Rel_Insert_Input>;
  graphcool_id?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  is_advanced?: Maybe<Scalars['Boolean']>;
  jobCategoryByJobCategoryId?: Maybe<Job_Category_Obj_Rel_Insert_Input>;
  job_category?: Maybe<Job_Category_Obj_Rel_Insert_Input>;
  job_category_id?: Maybe<Scalars['Int']>;
  job_city?: Maybe<Scalars['String']>;
  job_country?: Maybe<Scalars['String']>;
  job_duration?: Maybe<Scalars['String']>;
  job_geo_lang?: Maybe<Scalars['numeric']>;
  job_geo_lat?: Maybe<Scalars['numeric']>;
  job_house_nr?: Maybe<Scalars['String']>;
  job_payment?: Maybe<Scalars['String']>;
  job_region?: Maybe<Scalars['String']>;
  job_start_date?: Maybe<Scalars['String']>;
  job_street?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  job_type_id?: Maybe<Scalars['Int']>;
  job_zip?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['geography']>;
  meta_title?: Maybe<Scalars['String']>;
  mn_ads_job_category_subs?: Maybe<Mn_Ads_Job_Category_Sub_Arr_Rel_Insert_Input>;
  offer_upload_id?: Maybe<Scalars['Int']>;
  pdf_only?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['timestamp']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ads_Max_Fields = {
  __typename?: 'ads_max_fields';
  ad_description_company?: Maybe<Scalars['String']>;
  ad_description_qualifications?: Maybe<Scalars['String']>;
  ad_description_tasks?: Maybe<Scalars['String']>;
  color_1?: Maybe<Scalars['String']>;
  color_2?: Maybe<Scalars['String']>;
  color_3?: Maybe<Scalars['String']>;
  color_4?: Maybe<Scalars['String']>;
  color_5?: Maybe<Scalars['String']>;
  company_logo_file_id?: Maybe<Scalars['Int']>;
  company_name?: Maybe<Scalars['String']>;
  company_staff_count?: Maybe<Scalars['String']>;
  company_url?: Maybe<Scalars['String']>;
  contact_city?: Maybe<Scalars['String']>;
  contact_country_id?: Maybe<Scalars['Int']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_fax?: Maybe<Scalars['String']>;
  contact_first_name?: Maybe<Scalars['String']>;
  contact_last_name?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  contact_street_and_nr?: Maybe<Scalars['String']>;
  contact_title?: Maybe<Scalars['String']>;
  contact_us_here_url?: Maybe<Scalars['String']>;
  contact_zip?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['Int']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  job_category_id?: Maybe<Scalars['Int']>;
  job_city?: Maybe<Scalars['String']>;
  job_country?: Maybe<Scalars['String']>;
  job_duration?: Maybe<Scalars['String']>;
  job_geo_lang?: Maybe<Scalars['numeric']>;
  job_geo_lat?: Maybe<Scalars['numeric']>;
  job_house_nr?: Maybe<Scalars['String']>;
  job_payment?: Maybe<Scalars['String']>;
  job_region?: Maybe<Scalars['String']>;
  job_start_date?: Maybe<Scalars['String']>;
  job_street?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  job_type_id?: Maybe<Scalars['Int']>;
  job_zip?: Maybe<Scalars['String']>;
  meta_title?: Maybe<Scalars['String']>;
  offer_upload_id?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['timestamp']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ads" */
export type Ads_Max_Order_By = {
  ad_description_company?: Maybe<Order_By>;
  ad_description_qualifications?: Maybe<Order_By>;
  ad_description_tasks?: Maybe<Order_By>;
  color_1?: Maybe<Order_By>;
  color_2?: Maybe<Order_By>;
  color_3?: Maybe<Order_By>;
  color_4?: Maybe<Order_By>;
  color_5?: Maybe<Order_By>;
  company_logo_file_id?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  company_staff_count?: Maybe<Order_By>;
  company_url?: Maybe<Order_By>;
  contact_city?: Maybe<Order_By>;
  contact_country_id?: Maybe<Order_By>;
  contact_email?: Maybe<Order_By>;
  contact_fax?: Maybe<Order_By>;
  contact_first_name?: Maybe<Order_By>;
  contact_last_name?: Maybe<Order_By>;
  contact_phone?: Maybe<Order_By>;
  contact_street_and_nr?: Maybe<Order_By>;
  contact_title?: Maybe<Order_By>;
  contact_us_here_url?: Maybe<Order_By>;
  contact_zip?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_user_id?: Maybe<Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
  job_city?: Maybe<Order_By>;
  job_country?: Maybe<Order_By>;
  job_duration?: Maybe<Order_By>;
  job_geo_lang?: Maybe<Order_By>;
  job_geo_lat?: Maybe<Order_By>;
  job_house_nr?: Maybe<Order_By>;
  job_payment?: Maybe<Order_By>;
  job_region?: Maybe<Order_By>;
  job_start_date?: Maybe<Order_By>;
  job_street?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  job_type_id?: Maybe<Order_By>;
  job_zip?: Maybe<Order_By>;
  meta_title?: Maybe<Order_By>;
  offer_upload_id?: Maybe<Order_By>;
  published_at?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Ads_Min_Fields = {
  __typename?: 'ads_min_fields';
  ad_description_company?: Maybe<Scalars['String']>;
  ad_description_qualifications?: Maybe<Scalars['String']>;
  ad_description_tasks?: Maybe<Scalars['String']>;
  color_1?: Maybe<Scalars['String']>;
  color_2?: Maybe<Scalars['String']>;
  color_3?: Maybe<Scalars['String']>;
  color_4?: Maybe<Scalars['String']>;
  color_5?: Maybe<Scalars['String']>;
  company_logo_file_id?: Maybe<Scalars['Int']>;
  company_name?: Maybe<Scalars['String']>;
  company_staff_count?: Maybe<Scalars['String']>;
  company_url?: Maybe<Scalars['String']>;
  contact_city?: Maybe<Scalars['String']>;
  contact_country_id?: Maybe<Scalars['Int']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_fax?: Maybe<Scalars['String']>;
  contact_first_name?: Maybe<Scalars['String']>;
  contact_last_name?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  contact_street_and_nr?: Maybe<Scalars['String']>;
  contact_title?: Maybe<Scalars['String']>;
  contact_us_here_url?: Maybe<Scalars['String']>;
  contact_zip?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['Int']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  job_category_id?: Maybe<Scalars['Int']>;
  job_city?: Maybe<Scalars['String']>;
  job_country?: Maybe<Scalars['String']>;
  job_duration?: Maybe<Scalars['String']>;
  job_geo_lang?: Maybe<Scalars['numeric']>;
  job_geo_lat?: Maybe<Scalars['numeric']>;
  job_house_nr?: Maybe<Scalars['String']>;
  job_payment?: Maybe<Scalars['String']>;
  job_region?: Maybe<Scalars['String']>;
  job_start_date?: Maybe<Scalars['String']>;
  job_street?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  job_type_id?: Maybe<Scalars['Int']>;
  job_zip?: Maybe<Scalars['String']>;
  meta_title?: Maybe<Scalars['String']>;
  offer_upload_id?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['timestamp']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ads" */
export type Ads_Min_Order_By = {
  ad_description_company?: Maybe<Order_By>;
  ad_description_qualifications?: Maybe<Order_By>;
  ad_description_tasks?: Maybe<Order_By>;
  color_1?: Maybe<Order_By>;
  color_2?: Maybe<Order_By>;
  color_3?: Maybe<Order_By>;
  color_4?: Maybe<Order_By>;
  color_5?: Maybe<Order_By>;
  company_logo_file_id?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  company_staff_count?: Maybe<Order_By>;
  company_url?: Maybe<Order_By>;
  contact_city?: Maybe<Order_By>;
  contact_country_id?: Maybe<Order_By>;
  contact_email?: Maybe<Order_By>;
  contact_fax?: Maybe<Order_By>;
  contact_first_name?: Maybe<Order_By>;
  contact_last_name?: Maybe<Order_By>;
  contact_phone?: Maybe<Order_By>;
  contact_street_and_nr?: Maybe<Order_By>;
  contact_title?: Maybe<Order_By>;
  contact_us_here_url?: Maybe<Order_By>;
  contact_zip?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_user_id?: Maybe<Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
  job_city?: Maybe<Order_By>;
  job_country?: Maybe<Order_By>;
  job_duration?: Maybe<Order_By>;
  job_geo_lang?: Maybe<Order_By>;
  job_geo_lat?: Maybe<Order_By>;
  job_house_nr?: Maybe<Order_By>;
  job_payment?: Maybe<Order_By>;
  job_region?: Maybe<Order_By>;
  job_start_date?: Maybe<Order_By>;
  job_street?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  job_type_id?: Maybe<Order_By>;
  job_zip?: Maybe<Order_By>;
  meta_title?: Maybe<Order_By>;
  offer_upload_id?: Maybe<Order_By>;
  published_at?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "ads" */
export type Ads_Mutation_Response = {
  __typename?: 'ads_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Ads>;
};

/** input type for inserting object relation for remote table "ads" */
export type Ads_Obj_Rel_Insert_Input = {
  data: Ads_Insert_Input;
  on_conflict?: Maybe<Ads_On_Conflict>;
};

/** on conflict condition type for table "ads" */
export type Ads_On_Conflict = {
  constraint: Ads_Constraint;
  update_columns: Array<Ads_Update_Column>;
  where?: Maybe<Ads_Bool_Exp>;
};

/** ordering options when selecting data from "ads" */
export type Ads_Order_By = {
  ad_description_company?: Maybe<Order_By>;
  ad_description_qualifications?: Maybe<Order_By>;
  ad_description_tasks?: Maybe<Order_By>;
  color_1?: Maybe<Order_By>;
  color_2?: Maybe<Order_By>;
  color_3?: Maybe<Order_By>;
  color_4?: Maybe<Order_By>;
  color_5?: Maybe<Order_By>;
  company_logo_file_id?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  company_staff_count?: Maybe<Order_By>;
  company_url?: Maybe<Order_By>;
  contact_city?: Maybe<Order_By>;
  contact_country_id?: Maybe<Order_By>;
  contact_email?: Maybe<Order_By>;
  contact_fax?: Maybe<Order_By>;
  contact_first_name?: Maybe<Order_By>;
  contact_last_name?: Maybe<Order_By>;
  contact_phone?: Maybe<Order_By>;
  contact_street_and_nr?: Maybe<Order_By>;
  contact_title?: Maybe<Order_By>;
  contact_us_here_url?: Maybe<Order_By>;
  contact_zip?: Maybe<Order_By>;
  country?: Maybe<Country_Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_user_id?: Maybe<Order_By>;
  deleted?: Maybe<Order_By>;
  file?: Maybe<File_Order_By>;
  file_storyblok?: Maybe<File_Storyblok_Order_By>;
  graphcool_id?: Maybe<Order_By>;
  hidden?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_advanced?: Maybe<Order_By>;
  jobCategoryByJobCategoryId?: Maybe<Job_Category_Order_By>;
  job_category?: Maybe<Job_Category_Order_By>;
  job_category_id?: Maybe<Order_By>;
  job_city?: Maybe<Order_By>;
  job_country?: Maybe<Order_By>;
  job_duration?: Maybe<Order_By>;
  job_geo_lang?: Maybe<Order_By>;
  job_geo_lat?: Maybe<Order_By>;
  job_house_nr?: Maybe<Order_By>;
  job_payment?: Maybe<Order_By>;
  job_region?: Maybe<Order_By>;
  job_start_date?: Maybe<Order_By>;
  job_street?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  job_type_id?: Maybe<Order_By>;
  job_zip?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  meta_title?: Maybe<Order_By>;
  mn_ads_job_category_subs_aggregate?: Maybe<Mn_Ads_Job_Category_Sub_Aggregate_Order_By>;
  offer_upload_id?: Maybe<Order_By>;
  pdf_only?: Maybe<Order_By>;
  published?: Maybe<Order_By>;
  published_at?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "ads" */
export type Ads_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ads" */
export enum Ads_Select_Column {
  /** column name */
  AdDescriptionCompany = 'ad_description_company',
  /** column name */
  AdDescriptionQualifications = 'ad_description_qualifications',
  /** column name */
  AdDescriptionTasks = 'ad_description_tasks',
  /** column name */
  Color_1 = 'color_1',
  /** column name */
  Color_2 = 'color_2',
  /** column name */
  Color_3 = 'color_3',
  /** column name */
  Color_4 = 'color_4',
  /** column name */
  Color_5 = 'color_5',
  /** column name */
  CompanyLogoFileId = 'company_logo_file_id',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CompanyStaffCount = 'company_staff_count',
  /** column name */
  CompanyUrl = 'company_url',
  /** column name */
  ContactCity = 'contact_city',
  /** column name */
  ContactCountryId = 'contact_country_id',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactFax = 'contact_fax',
  /** column name */
  ContactFirstName = 'contact_first_name',
  /** column name */
  ContactLastName = 'contact_last_name',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactStreetAndNr = 'contact_street_and_nr',
  /** column name */
  ContactTitle = 'contact_title',
  /** column name */
  ContactUsHereUrl = 'contact_us_here_url',
  /** column name */
  ContactZip = 'contact_zip',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdvanced = 'is_advanced',
  /** column name */
  JobCategoryId = 'job_category_id',
  /** column name */
  JobCity = 'job_city',
  /** column name */
  JobCountry = 'job_country',
  /** column name */
  JobDuration = 'job_duration',
  /** column name */
  JobGeoLang = 'job_geo_lang',
  /** column name */
  JobGeoLat = 'job_geo_lat',
  /** column name */
  JobHouseNr = 'job_house_nr',
  /** column name */
  JobPayment = 'job_payment',
  /** column name */
  JobRegion = 'job_region',
  /** column name */
  JobStartDate = 'job_start_date',
  /** column name */
  JobStreet = 'job_street',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  JobTypeId = 'job_type_id',
  /** column name */
  JobZip = 'job_zip',
  /** column name */
  Location = 'location',
  /** column name */
  MetaTitle = 'meta_title',
  /** column name */
  OfferUploadId = 'offer_upload_id',
  /** column name */
  PdfOnly = 'pdf_only',
  /** column name */
  Published = 'published',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ads" */
export type Ads_Set_Input = {
  ad_description_company?: Maybe<Scalars['String']>;
  ad_description_qualifications?: Maybe<Scalars['String']>;
  ad_description_tasks?: Maybe<Scalars['String']>;
  color_1?: Maybe<Scalars['String']>;
  color_2?: Maybe<Scalars['String']>;
  color_3?: Maybe<Scalars['String']>;
  color_4?: Maybe<Scalars['String']>;
  color_5?: Maybe<Scalars['String']>;
  company_logo_file_id?: Maybe<Scalars['Int']>;
  company_name?: Maybe<Scalars['String']>;
  company_staff_count?: Maybe<Scalars['String']>;
  company_url?: Maybe<Scalars['String']>;
  contact_city?: Maybe<Scalars['String']>;
  contact_country_id?: Maybe<Scalars['Int']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_fax?: Maybe<Scalars['String']>;
  contact_first_name?: Maybe<Scalars['String']>;
  contact_last_name?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  contact_street_and_nr?: Maybe<Scalars['String']>;
  contact_title?: Maybe<Scalars['String']>;
  contact_us_here_url?: Maybe<Scalars['String']>;
  contact_zip?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Boolean']>;
  graphcool_id?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  is_advanced?: Maybe<Scalars['Boolean']>;
  job_category_id?: Maybe<Scalars['Int']>;
  job_city?: Maybe<Scalars['String']>;
  job_country?: Maybe<Scalars['String']>;
  job_duration?: Maybe<Scalars['String']>;
  job_geo_lang?: Maybe<Scalars['numeric']>;
  job_geo_lat?: Maybe<Scalars['numeric']>;
  job_house_nr?: Maybe<Scalars['String']>;
  job_payment?: Maybe<Scalars['String']>;
  job_region?: Maybe<Scalars['String']>;
  job_start_date?: Maybe<Scalars['String']>;
  job_street?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  job_type_id?: Maybe<Scalars['Int']>;
  job_zip?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['geography']>;
  meta_title?: Maybe<Scalars['String']>;
  offer_upload_id?: Maybe<Scalars['Int']>;
  pdf_only?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['timestamp']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Ads_Stddev_Fields = {
  __typename?: 'ads_stddev_fields';
  company_logo_file_id?: Maybe<Scalars['Float']>;
  contact_country_id?: Maybe<Scalars['Float']>;
  created_by_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
  job_geo_lang?: Maybe<Scalars['Float']>;
  job_geo_lat?: Maybe<Scalars['Float']>;
  job_type_id?: Maybe<Scalars['Float']>;
  offer_upload_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ads" */
export type Ads_Stddev_Order_By = {
  company_logo_file_id?: Maybe<Order_By>;
  contact_country_id?: Maybe<Order_By>;
  created_by_user_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
  job_geo_lang?: Maybe<Order_By>;
  job_geo_lat?: Maybe<Order_By>;
  job_type_id?: Maybe<Order_By>;
  offer_upload_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ads_Stddev_Pop_Fields = {
  __typename?: 'ads_stddev_pop_fields';
  company_logo_file_id?: Maybe<Scalars['Float']>;
  contact_country_id?: Maybe<Scalars['Float']>;
  created_by_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
  job_geo_lang?: Maybe<Scalars['Float']>;
  job_geo_lat?: Maybe<Scalars['Float']>;
  job_type_id?: Maybe<Scalars['Float']>;
  offer_upload_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ads" */
export type Ads_Stddev_Pop_Order_By = {
  company_logo_file_id?: Maybe<Order_By>;
  contact_country_id?: Maybe<Order_By>;
  created_by_user_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
  job_geo_lang?: Maybe<Order_By>;
  job_geo_lat?: Maybe<Order_By>;
  job_type_id?: Maybe<Order_By>;
  offer_upload_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ads_Stddev_Samp_Fields = {
  __typename?: 'ads_stddev_samp_fields';
  company_logo_file_id?: Maybe<Scalars['Float']>;
  contact_country_id?: Maybe<Scalars['Float']>;
  created_by_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
  job_geo_lang?: Maybe<Scalars['Float']>;
  job_geo_lat?: Maybe<Scalars['Float']>;
  job_type_id?: Maybe<Scalars['Float']>;
  offer_upload_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ads" */
export type Ads_Stddev_Samp_Order_By = {
  company_logo_file_id?: Maybe<Order_By>;
  contact_country_id?: Maybe<Order_By>;
  created_by_user_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
  job_geo_lang?: Maybe<Order_By>;
  job_geo_lat?: Maybe<Order_By>;
  job_type_id?: Maybe<Order_By>;
  offer_upload_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Ads_Sum_Fields = {
  __typename?: 'ads_sum_fields';
  company_logo_file_id?: Maybe<Scalars['Int']>;
  contact_country_id?: Maybe<Scalars['Int']>;
  created_by_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  job_category_id?: Maybe<Scalars['Int']>;
  job_geo_lang?: Maybe<Scalars['numeric']>;
  job_geo_lat?: Maybe<Scalars['numeric']>;
  job_type_id?: Maybe<Scalars['Int']>;
  offer_upload_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ads" */
export type Ads_Sum_Order_By = {
  company_logo_file_id?: Maybe<Order_By>;
  contact_country_id?: Maybe<Order_By>;
  created_by_user_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
  job_geo_lang?: Maybe<Order_By>;
  job_geo_lat?: Maybe<Order_By>;
  job_type_id?: Maybe<Order_By>;
  offer_upload_id?: Maybe<Order_By>;
};

/** update columns of table "ads" */
export enum Ads_Update_Column {
  /** column name */
  AdDescriptionCompany = 'ad_description_company',
  /** column name */
  AdDescriptionQualifications = 'ad_description_qualifications',
  /** column name */
  AdDescriptionTasks = 'ad_description_tasks',
  /** column name */
  Color_1 = 'color_1',
  /** column name */
  Color_2 = 'color_2',
  /** column name */
  Color_3 = 'color_3',
  /** column name */
  Color_4 = 'color_4',
  /** column name */
  Color_5 = 'color_5',
  /** column name */
  CompanyLogoFileId = 'company_logo_file_id',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CompanyStaffCount = 'company_staff_count',
  /** column name */
  CompanyUrl = 'company_url',
  /** column name */
  ContactCity = 'contact_city',
  /** column name */
  ContactCountryId = 'contact_country_id',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactFax = 'contact_fax',
  /** column name */
  ContactFirstName = 'contact_first_name',
  /** column name */
  ContactLastName = 'contact_last_name',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactStreetAndNr = 'contact_street_and_nr',
  /** column name */
  ContactTitle = 'contact_title',
  /** column name */
  ContactUsHereUrl = 'contact_us_here_url',
  /** column name */
  ContactZip = 'contact_zip',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdvanced = 'is_advanced',
  /** column name */
  JobCategoryId = 'job_category_id',
  /** column name */
  JobCity = 'job_city',
  /** column name */
  JobCountry = 'job_country',
  /** column name */
  JobDuration = 'job_duration',
  /** column name */
  JobGeoLang = 'job_geo_lang',
  /** column name */
  JobGeoLat = 'job_geo_lat',
  /** column name */
  JobHouseNr = 'job_house_nr',
  /** column name */
  JobPayment = 'job_payment',
  /** column name */
  JobRegion = 'job_region',
  /** column name */
  JobStartDate = 'job_start_date',
  /** column name */
  JobStreet = 'job_street',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  JobTypeId = 'job_type_id',
  /** column name */
  JobZip = 'job_zip',
  /** column name */
  Location = 'location',
  /** column name */
  MetaTitle = 'meta_title',
  /** column name */
  OfferUploadId = 'offer_upload_id',
  /** column name */
  PdfOnly = 'pdf_only',
  /** column name */
  Published = 'published',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Ads_Var_Pop_Fields = {
  __typename?: 'ads_var_pop_fields';
  company_logo_file_id?: Maybe<Scalars['Float']>;
  contact_country_id?: Maybe<Scalars['Float']>;
  created_by_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
  job_geo_lang?: Maybe<Scalars['Float']>;
  job_geo_lat?: Maybe<Scalars['Float']>;
  job_type_id?: Maybe<Scalars['Float']>;
  offer_upload_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ads" */
export type Ads_Var_Pop_Order_By = {
  company_logo_file_id?: Maybe<Order_By>;
  contact_country_id?: Maybe<Order_By>;
  created_by_user_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
  job_geo_lang?: Maybe<Order_By>;
  job_geo_lat?: Maybe<Order_By>;
  job_type_id?: Maybe<Order_By>;
  offer_upload_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ads_Var_Samp_Fields = {
  __typename?: 'ads_var_samp_fields';
  company_logo_file_id?: Maybe<Scalars['Float']>;
  contact_country_id?: Maybe<Scalars['Float']>;
  created_by_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
  job_geo_lang?: Maybe<Scalars['Float']>;
  job_geo_lat?: Maybe<Scalars['Float']>;
  job_type_id?: Maybe<Scalars['Float']>;
  offer_upload_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ads" */
export type Ads_Var_Samp_Order_By = {
  company_logo_file_id?: Maybe<Order_By>;
  contact_country_id?: Maybe<Order_By>;
  created_by_user_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
  job_geo_lang?: Maybe<Order_By>;
  job_geo_lat?: Maybe<Order_By>;
  job_type_id?: Maybe<Order_By>;
  offer_upload_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Ads_Variance_Fields = {
  __typename?: 'ads_variance_fields';
  company_logo_file_id?: Maybe<Scalars['Float']>;
  contact_country_id?: Maybe<Scalars['Float']>;
  created_by_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
  job_geo_lang?: Maybe<Scalars['Float']>;
  job_geo_lat?: Maybe<Scalars['Float']>;
  job_type_id?: Maybe<Scalars['Float']>;
  offer_upload_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ads" */
export type Ads_Variance_Order_By = {
  company_logo_file_id?: Maybe<Order_By>;
  contact_country_id?: Maybe<Order_By>;
  created_by_user_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
  job_geo_lang?: Maybe<Order_By>;
  job_geo_lat?: Maybe<Order_By>;
  job_type_id?: Maybe<Order_By>;
  offer_upload_id?: Maybe<Order_By>;
};

/** expression to compare columns of type Boolean. All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

/** columns and relationships of "company" */
export type Company = {
  __typename?: 'company';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  name: Scalars['String'];
  staff_count?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  url?: Maybe<Scalars['String']>;
};

/** aggregated selection of "company" */
export type Company_Aggregate = {
  __typename?: 'company_aggregate';
  aggregate?: Maybe<Company_Aggregate_Fields>;
  nodes: Array<Company>;
};

/** aggregate fields of "company" */
export type Company_Aggregate_Fields = {
  __typename?: 'company_aggregate_fields';
  avg?: Maybe<Company_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Company_Max_Fields>;
  min?: Maybe<Company_Min_Fields>;
  stddev?: Maybe<Company_Stddev_Fields>;
  stddev_pop?: Maybe<Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Company_Stddev_Samp_Fields>;
  sum?: Maybe<Company_Sum_Fields>;
  var_pop?: Maybe<Company_Var_Pop_Fields>;
  var_samp?: Maybe<Company_Var_Samp_Fields>;
  variance?: Maybe<Company_Variance_Fields>;
};


/** aggregate fields of "company" */
export type Company_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Company_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company" */
export type Company_Aggregate_Order_By = {
  avg?: Maybe<Company_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Company_Max_Order_By>;
  min?: Maybe<Company_Min_Order_By>;
  stddev?: Maybe<Company_Stddev_Order_By>;
  stddev_pop?: Maybe<Company_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Company_Stddev_Samp_Order_By>;
  sum?: Maybe<Company_Sum_Order_By>;
  var_pop?: Maybe<Company_Var_Pop_Order_By>;
  var_samp?: Maybe<Company_Var_Samp_Order_By>;
  variance?: Maybe<Company_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "company" */
export type Company_Arr_Rel_Insert_Input = {
  data: Array<Company_Insert_Input>;
  on_conflict?: Maybe<Company_On_Conflict>;
};

/** aggregate avg on columns */
export type Company_Avg_Fields = {
  __typename?: 'company_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "company" */
export type Company_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "company". All fields are combined with a logical 'AND'. */
export type Company_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Company_Bool_Exp>>>;
  _not?: Maybe<Company_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Company_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  staff_count?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  url?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "company" */
export enum Company_Constraint {
  /** unique or primary key constraint */
  CompanyPkey = 'company_pkey'
}

/** input type for incrementing integer column in table "company" */
export type Company_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "company" */
export type Company_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  staff_count?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Company_Max_Fields = {
  __typename?: 'company_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  staff_count?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "company" */
export type Company_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  staff_count?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Company_Min_Fields = {
  __typename?: 'company_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  staff_count?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "company" */
export type Company_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  staff_count?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** response of any mutation on the table "company" */
export type Company_Mutation_Response = {
  __typename?: 'company_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Company>;
};

/** input type for inserting object relation for remote table "company" */
export type Company_Obj_Rel_Insert_Input = {
  data: Company_Insert_Input;
  on_conflict?: Maybe<Company_On_Conflict>;
};

/** on conflict condition type for table "company" */
export type Company_On_Conflict = {
  constraint: Company_Constraint;
  update_columns: Array<Company_Update_Column>;
  where?: Maybe<Company_Bool_Exp>;
};

/** ordering options when selecting data from "company" */
export type Company_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  staff_count?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** primary key columns input for table: "company" */
export type Company_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "company" */
export enum Company_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StaffCount = 'staff_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "company" */
export type Company_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  staff_count?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Company_Stddev_Fields = {
  __typename?: 'company_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "company" */
export type Company_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Company_Stddev_Pop_Fields = {
  __typename?: 'company_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "company" */
export type Company_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Company_Stddev_Samp_Fields = {
  __typename?: 'company_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "company" */
export type Company_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Company_Sum_Fields = {
  __typename?: 'company_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "company" */
export type Company_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "company" */
export enum Company_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StaffCount = 'staff_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** aggregate var_pop on columns */
export type Company_Var_Pop_Fields = {
  __typename?: 'company_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "company" */
export type Company_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Company_Var_Samp_Fields = {
  __typename?: 'company_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "company" */
export type Company_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Company_Variance_Fields = {
  __typename?: 'company_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "company" */
export type Company_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** columns and relationships of "country" */
export type Country = {
  __typename?: 'country';
  /** An array relationship */
  ads: Array<Ads>;
  /** An aggregated array relationship */
  ads_aggregate: Ads_Aggregate;
  graphcool_id: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  sorting?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "country" */
export type CountryAdsArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryAds_AggregateArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};

/** aggregated selection of "country" */
export type Country_Aggregate = {
  __typename?: 'country_aggregate';
  aggregate?: Maybe<Country_Aggregate_Fields>;
  nodes: Array<Country>;
};

/** aggregate fields of "country" */
export type Country_Aggregate_Fields = {
  __typename?: 'country_aggregate_fields';
  avg?: Maybe<Country_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Country_Max_Fields>;
  min?: Maybe<Country_Min_Fields>;
  stddev?: Maybe<Country_Stddev_Fields>;
  stddev_pop?: Maybe<Country_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Country_Stddev_Samp_Fields>;
  sum?: Maybe<Country_Sum_Fields>;
  var_pop?: Maybe<Country_Var_Pop_Fields>;
  var_samp?: Maybe<Country_Var_Samp_Fields>;
  variance?: Maybe<Country_Variance_Fields>;
};


/** aggregate fields of "country" */
export type Country_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Country_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "country" */
export type Country_Aggregate_Order_By = {
  avg?: Maybe<Country_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Country_Max_Order_By>;
  min?: Maybe<Country_Min_Order_By>;
  stddev?: Maybe<Country_Stddev_Order_By>;
  stddev_pop?: Maybe<Country_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Country_Stddev_Samp_Order_By>;
  sum?: Maybe<Country_Sum_Order_By>;
  var_pop?: Maybe<Country_Var_Pop_Order_By>;
  var_samp?: Maybe<Country_Var_Samp_Order_By>;
  variance?: Maybe<Country_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "country" */
export type Country_Arr_Rel_Insert_Input = {
  data: Array<Country_Insert_Input>;
  on_conflict?: Maybe<Country_On_Conflict>;
};

/** aggregate avg on columns */
export type Country_Avg_Fields = {
  __typename?: 'country_avg_fields';
  id?: Maybe<Scalars['Float']>;
  sorting?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "country" */
export type Country_Avg_Order_By = {
  id?: Maybe<Order_By>;
  sorting?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "country". All fields are combined with a logical 'AND'. */
export type Country_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Country_Bool_Exp>>>;
  _not?: Maybe<Country_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Country_Bool_Exp>>>;
  ads?: Maybe<Ads_Bool_Exp>;
  graphcool_id?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  sorting?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "country" */
export enum Country_Constraint {
  /** unique or primary key constraint */
  CountryGraphcoolIdKey = 'country_graphcool_id_key',
  /** unique or primary key constraint */
  CountryNameKey = 'country_name_key',
  /** unique or primary key constraint */
  CountryNameSortingKey = 'country_name_sorting_key',
  /** unique or primary key constraint */
  CountryPkey = 'country_pkey'
}

/** input type for incrementing integer column in table "country" */
export type Country_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  sorting?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "country" */
export type Country_Insert_Input = {
  ads?: Maybe<Ads_Arr_Rel_Insert_Input>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sorting?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Country_Max_Fields = {
  __typename?: 'country_max_fields';
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sorting?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "country" */
export type Country_Max_Order_By = {
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  sorting?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Country_Min_Fields = {
  __typename?: 'country_min_fields';
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sorting?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "country" */
export type Country_Min_Order_By = {
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  sorting?: Maybe<Order_By>;
};

/** response of any mutation on the table "country" */
export type Country_Mutation_Response = {
  __typename?: 'country_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Country>;
};

/** input type for inserting object relation for remote table "country" */
export type Country_Obj_Rel_Insert_Input = {
  data: Country_Insert_Input;
  on_conflict?: Maybe<Country_On_Conflict>;
};

/** on conflict condition type for table "country" */
export type Country_On_Conflict = {
  constraint: Country_Constraint;
  update_columns: Array<Country_Update_Column>;
  where?: Maybe<Country_Bool_Exp>;
};

/** ordering options when selecting data from "country" */
export type Country_Order_By = {
  ads_aggregate?: Maybe<Ads_Aggregate_Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  sorting?: Maybe<Order_By>;
};

/** primary key columns input for table: "country" */
export type Country_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "country" */
export enum Country_Select_Column {
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Sorting = 'sorting'
}

/** input type for updating data in table "country" */
export type Country_Set_Input = {
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sorting?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Country_Stddev_Fields = {
  __typename?: 'country_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  sorting?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "country" */
export type Country_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  sorting?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Country_Stddev_Pop_Fields = {
  __typename?: 'country_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sorting?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "country" */
export type Country_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  sorting?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Country_Stddev_Samp_Fields = {
  __typename?: 'country_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sorting?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "country" */
export type Country_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  sorting?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Country_Sum_Fields = {
  __typename?: 'country_sum_fields';
  id?: Maybe<Scalars['Int']>;
  sorting?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "country" */
export type Country_Sum_Order_By = {
  id?: Maybe<Order_By>;
  sorting?: Maybe<Order_By>;
};

/** update columns of table "country" */
export enum Country_Update_Column {
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Sorting = 'sorting'
}

/** aggregate var_pop on columns */
export type Country_Var_Pop_Fields = {
  __typename?: 'country_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sorting?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "country" */
export type Country_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  sorting?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Country_Var_Samp_Fields = {
  __typename?: 'country_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sorting?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "country" */
export type Country_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  sorting?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Country_Variance_Fields = {
  __typename?: 'country_variance_fields';
  id?: Maybe<Scalars['Float']>;
  sorting?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "country" */
export type Country_Variance_Order_By = {
  id?: Maybe<Order_By>;
  sorting?: Maybe<Order_By>;
};

/** columns and relationships of "enum_language" */
export type Enum_Language = {
  __typename?: 'enum_language';
  key: Scalars['String'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregated array relationship */
  users_aggregate: Users_Aggregate;
};


/** columns and relationships of "enum_language" */
export type Enum_LanguageUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "enum_language" */
export type Enum_LanguageUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "enum_language" */
export type Enum_Language_Aggregate = {
  __typename?: 'enum_language_aggregate';
  aggregate?: Maybe<Enum_Language_Aggregate_Fields>;
  nodes: Array<Enum_Language>;
};

/** aggregate fields of "enum_language" */
export type Enum_Language_Aggregate_Fields = {
  __typename?: 'enum_language_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Enum_Language_Max_Fields>;
  min?: Maybe<Enum_Language_Min_Fields>;
};


/** aggregate fields of "enum_language" */
export type Enum_Language_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Enum_Language_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "enum_language" */
export type Enum_Language_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Enum_Language_Max_Order_By>;
  min?: Maybe<Enum_Language_Min_Order_By>;
};

/** input type for inserting array relation for remote table "enum_language" */
export type Enum_Language_Arr_Rel_Insert_Input = {
  data: Array<Enum_Language_Insert_Input>;
  on_conflict?: Maybe<Enum_Language_On_Conflict>;
};

/** Boolean expression to filter rows from the table "enum_language". All fields are combined with a logical 'AND'. */
export type Enum_Language_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Enum_Language_Bool_Exp>>>;
  _not?: Maybe<Enum_Language_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Enum_Language_Bool_Exp>>>;
  key?: Maybe<String_Comparison_Exp>;
  users?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "enum_language" */
export enum Enum_Language_Constraint {
  /** unique or primary key constraint */
  EnumLanguagePkey = 'enum_language_pkey'
}

export enum Enum_Language_Enum {
  De = 'DE'
}

/** expression to compare columns of type enum_language_enum. All fields are combined with logical 'AND'. */
export type Enum_Language_Enum_Comparison_Exp = {
  _eq?: Maybe<Enum_Language_Enum>;
  _in?: Maybe<Array<Enum_Language_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Enum_Language_Enum>;
  _nin?: Maybe<Array<Enum_Language_Enum>>;
};

/** input type for inserting data into table "enum_language" */
export type Enum_Language_Insert_Input = {
  key?: Maybe<Scalars['String']>;
  users?: Maybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Enum_Language_Max_Fields = {
  __typename?: 'enum_language_max_fields';
  key?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "enum_language" */
export type Enum_Language_Max_Order_By = {
  key?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Enum_Language_Min_Fields = {
  __typename?: 'enum_language_min_fields';
  key?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "enum_language" */
export type Enum_Language_Min_Order_By = {
  key?: Maybe<Order_By>;
};

/** response of any mutation on the table "enum_language" */
export type Enum_Language_Mutation_Response = {
  __typename?: 'enum_language_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Enum_Language>;
};

/** input type for inserting object relation for remote table "enum_language" */
export type Enum_Language_Obj_Rel_Insert_Input = {
  data: Enum_Language_Insert_Input;
  on_conflict?: Maybe<Enum_Language_On_Conflict>;
};

/** on conflict condition type for table "enum_language" */
export type Enum_Language_On_Conflict = {
  constraint: Enum_Language_Constraint;
  update_columns: Array<Enum_Language_Update_Column>;
  where?: Maybe<Enum_Language_Bool_Exp>;
};

/** ordering options when selecting data from "enum_language" */
export type Enum_Language_Order_By = {
  key?: Maybe<Order_By>;
  users_aggregate?: Maybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: "enum_language" */
export type Enum_Language_Pk_Columns_Input = {
  key: Scalars['String'];
};

/** select columns of table "enum_language" */
export enum Enum_Language_Select_Column {
  /** column name */
  Key = 'key'
}

/** input type for updating data in table "enum_language" */
export type Enum_Language_Set_Input = {
  key?: Maybe<Scalars['String']>;
};

/** update columns of table "enum_language" */
export enum Enum_Language_Update_Column {
  /** column name */
  Key = 'key'
}

/** columns and relationships of "enum_user_role" */
export type Enum_User_Role = {
  __typename?: 'enum_user_role';
  text: Scalars['String'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregated array relationship */
  users_aggregate: Users_Aggregate;
};


/** columns and relationships of "enum_user_role" */
export type Enum_User_RoleUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "enum_user_role" */
export type Enum_User_RoleUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "enum_user_role" */
export type Enum_User_Role_Aggregate = {
  __typename?: 'enum_user_role_aggregate';
  aggregate?: Maybe<Enum_User_Role_Aggregate_Fields>;
  nodes: Array<Enum_User_Role>;
};

/** aggregate fields of "enum_user_role" */
export type Enum_User_Role_Aggregate_Fields = {
  __typename?: 'enum_user_role_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Enum_User_Role_Max_Fields>;
  min?: Maybe<Enum_User_Role_Min_Fields>;
};


/** aggregate fields of "enum_user_role" */
export type Enum_User_Role_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Enum_User_Role_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "enum_user_role" */
export type Enum_User_Role_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Enum_User_Role_Max_Order_By>;
  min?: Maybe<Enum_User_Role_Min_Order_By>;
};

/** input type for inserting array relation for remote table "enum_user_role" */
export type Enum_User_Role_Arr_Rel_Insert_Input = {
  data: Array<Enum_User_Role_Insert_Input>;
  on_conflict?: Maybe<Enum_User_Role_On_Conflict>;
};

/** Boolean expression to filter rows from the table "enum_user_role". All fields are combined with a logical 'AND'. */
export type Enum_User_Role_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Enum_User_Role_Bool_Exp>>>;
  _not?: Maybe<Enum_User_Role_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Enum_User_Role_Bool_Exp>>>;
  text?: Maybe<String_Comparison_Exp>;
  users?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "enum_user_role" */
export enum Enum_User_Role_Constraint {
  /** unique or primary key constraint */
  EnumUserRolePkey = 'enum_user_role_pkey'
}

export enum Enum_User_Role_Enum {
  Admin = 'admin',
  Client = 'client'
}

/** expression to compare columns of type enum_user_role_enum. All fields are combined with logical 'AND'. */
export type Enum_User_Role_Enum_Comparison_Exp = {
  _eq?: Maybe<Enum_User_Role_Enum>;
  _in?: Maybe<Array<Enum_User_Role_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Enum_User_Role_Enum>;
  _nin?: Maybe<Array<Enum_User_Role_Enum>>;
};

/** input type for inserting data into table "enum_user_role" */
export type Enum_User_Role_Insert_Input = {
  text?: Maybe<Scalars['String']>;
  users?: Maybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Enum_User_Role_Max_Fields = {
  __typename?: 'enum_user_role_max_fields';
  text?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "enum_user_role" */
export type Enum_User_Role_Max_Order_By = {
  text?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Enum_User_Role_Min_Fields = {
  __typename?: 'enum_user_role_min_fields';
  text?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "enum_user_role" */
export type Enum_User_Role_Min_Order_By = {
  text?: Maybe<Order_By>;
};

/** response of any mutation on the table "enum_user_role" */
export type Enum_User_Role_Mutation_Response = {
  __typename?: 'enum_user_role_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Enum_User_Role>;
};

/** input type for inserting object relation for remote table "enum_user_role" */
export type Enum_User_Role_Obj_Rel_Insert_Input = {
  data: Enum_User_Role_Insert_Input;
  on_conflict?: Maybe<Enum_User_Role_On_Conflict>;
};

/** on conflict condition type for table "enum_user_role" */
export type Enum_User_Role_On_Conflict = {
  constraint: Enum_User_Role_Constraint;
  update_columns: Array<Enum_User_Role_Update_Column>;
  where?: Maybe<Enum_User_Role_Bool_Exp>;
};

/** ordering options when selecting data from "enum_user_role" */
export type Enum_User_Role_Order_By = {
  text?: Maybe<Order_By>;
  users_aggregate?: Maybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: "enum_user_role" */
export type Enum_User_Role_Pk_Columns_Input = {
  text: Scalars['String'];
};

/** select columns of table "enum_user_role" */
export enum Enum_User_Role_Select_Column {
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "enum_user_role" */
export type Enum_User_Role_Set_Input = {
  text?: Maybe<Scalars['String']>;
};

/** update columns of table "enum_user_role" */
export enum Enum_User_Role_Update_Column {
  /** column name */
  Text = 'text'
}

/** columns and relationships of "file" */
export type File = {
  __typename?: 'file';
  /** An object relationship */
  adById?: Maybe<Ads>;
  created_at: Scalars['timestamptz'];
  graphcool_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  mimetype: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  old_name?: Maybe<Scalars['String']>;
  old_url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  url?: Maybe<Scalars['String']>;
};

/** aggregated selection of "file" */
export type File_Aggregate = {
  __typename?: 'file_aggregate';
  aggregate?: Maybe<File_Aggregate_Fields>;
  nodes: Array<File>;
};

/** aggregate fields of "file" */
export type File_Aggregate_Fields = {
  __typename?: 'file_aggregate_fields';
  avg?: Maybe<File_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<File_Max_Fields>;
  min?: Maybe<File_Min_Fields>;
  stddev?: Maybe<File_Stddev_Fields>;
  stddev_pop?: Maybe<File_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<File_Stddev_Samp_Fields>;
  sum?: Maybe<File_Sum_Fields>;
  var_pop?: Maybe<File_Var_Pop_Fields>;
  var_samp?: Maybe<File_Var_Samp_Fields>;
  variance?: Maybe<File_Variance_Fields>;
};


/** aggregate fields of "file" */
export type File_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<File_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "file" */
export type File_Aggregate_Order_By = {
  avg?: Maybe<File_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<File_Max_Order_By>;
  min?: Maybe<File_Min_Order_By>;
  stddev?: Maybe<File_Stddev_Order_By>;
  stddev_pop?: Maybe<File_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<File_Stddev_Samp_Order_By>;
  sum?: Maybe<File_Sum_Order_By>;
  var_pop?: Maybe<File_Var_Pop_Order_By>;
  var_samp?: Maybe<File_Var_Samp_Order_By>;
  variance?: Maybe<File_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "file" */
export type File_Arr_Rel_Insert_Input = {
  data: Array<File_Insert_Input>;
  on_conflict?: Maybe<File_On_Conflict>;
};

/** aggregate avg on columns */
export type File_Avg_Fields = {
  __typename?: 'file_avg_fields';
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "file" */
export type File_Avg_Order_By = {
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file". All fields are combined with a logical 'AND'. */
export type File_Bool_Exp = {
  _and?: Maybe<Array<Maybe<File_Bool_Exp>>>;
  _not?: Maybe<File_Bool_Exp>;
  _or?: Maybe<Array<Maybe<File_Bool_Exp>>>;
  adById?: Maybe<Ads_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  graphcool_id?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  mimetype?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  old_name?: Maybe<String_Comparison_Exp>;
  old_url?: Maybe<String_Comparison_Exp>;
  size?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  url?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "file" */
export enum File_Constraint {
  /** unique or primary key constraint */
  FileGraphcoolIdKey = 'file_graphcool_id_key',
  /** unique or primary key constraint */
  FileOldUrlKey = 'file_old_url_key',
  /** unique or primary key constraint */
  FilePkey = 'file_pkey',
  /** unique or primary key constraint */
  FileUrlKey = 'file_url_key'
}

/** input type for incrementing integer column in table "file" */
export type File_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "file" */
export type File_Insert_Input = {
  adById?: Maybe<Ads_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mimetype?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  old_name?: Maybe<Scalars['String']>;
  old_url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type File_Max_Fields = {
  __typename?: 'file_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mimetype?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  old_name?: Maybe<Scalars['String']>;
  old_url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "file" */
export type File_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mimetype?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  old_name?: Maybe<Order_By>;
  old_url?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type File_Min_Fields = {
  __typename?: 'file_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mimetype?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  old_name?: Maybe<Scalars['String']>;
  old_url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "file" */
export type File_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mimetype?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  old_name?: Maybe<Order_By>;
  old_url?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** response of any mutation on the table "file" */
export type File_Mutation_Response = {
  __typename?: 'file_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<File>;
};

/** input type for inserting object relation for remote table "file" */
export type File_Obj_Rel_Insert_Input = {
  data: File_Insert_Input;
  on_conflict?: Maybe<File_On_Conflict>;
};

/** on conflict condition type for table "file" */
export type File_On_Conflict = {
  constraint: File_Constraint;
  update_columns: Array<File_Update_Column>;
  where?: Maybe<File_Bool_Exp>;
};

/** ordering options when selecting data from "file" */
export type File_Order_By = {
  adById?: Maybe<Ads_Order_By>;
  created_at?: Maybe<Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mimetype?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  old_name?: Maybe<Order_By>;
  old_url?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** primary key columns input for table: "file" */
export type File_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "file" */
export enum File_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Id = 'id',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  Name = 'name',
  /** column name */
  OldName = 'old_name',
  /** column name */
  OldUrl = 'old_url',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "file" */
export type File_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mimetype?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  old_name?: Maybe<Scalars['String']>;
  old_url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type File_Stddev_Fields = {
  __typename?: 'file_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "file" */
export type File_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type File_Stddev_Pop_Fields = {
  __typename?: 'file_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "file" */
export type File_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type File_Stddev_Samp_Fields = {
  __typename?: 'file_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "file" */
export type File_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
};

/** columns and relationships of "file_storyblok" */
export type File_Storyblok = {
  __typename?: 'file_storyblok';
  /** An object relationship */
  ad?: Maybe<Ads>;
  graphcool_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  old_url?: Maybe<Scalars['String']>;
  storyblok_id?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregated selection of "file_storyblok" */
export type File_Storyblok_Aggregate = {
  __typename?: 'file_storyblok_aggregate';
  aggregate?: Maybe<File_Storyblok_Aggregate_Fields>;
  nodes: Array<File_Storyblok>;
};

/** aggregate fields of "file_storyblok" */
export type File_Storyblok_Aggregate_Fields = {
  __typename?: 'file_storyblok_aggregate_fields';
  avg?: Maybe<File_Storyblok_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<File_Storyblok_Max_Fields>;
  min?: Maybe<File_Storyblok_Min_Fields>;
  stddev?: Maybe<File_Storyblok_Stddev_Fields>;
  stddev_pop?: Maybe<File_Storyblok_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<File_Storyblok_Stddev_Samp_Fields>;
  sum?: Maybe<File_Storyblok_Sum_Fields>;
  var_pop?: Maybe<File_Storyblok_Var_Pop_Fields>;
  var_samp?: Maybe<File_Storyblok_Var_Samp_Fields>;
  variance?: Maybe<File_Storyblok_Variance_Fields>;
};


/** aggregate fields of "file_storyblok" */
export type File_Storyblok_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<File_Storyblok_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "file_storyblok" */
export type File_Storyblok_Aggregate_Order_By = {
  avg?: Maybe<File_Storyblok_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<File_Storyblok_Max_Order_By>;
  min?: Maybe<File_Storyblok_Min_Order_By>;
  stddev?: Maybe<File_Storyblok_Stddev_Order_By>;
  stddev_pop?: Maybe<File_Storyblok_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<File_Storyblok_Stddev_Samp_Order_By>;
  sum?: Maybe<File_Storyblok_Sum_Order_By>;
  var_pop?: Maybe<File_Storyblok_Var_Pop_Order_By>;
  var_samp?: Maybe<File_Storyblok_Var_Samp_Order_By>;
  variance?: Maybe<File_Storyblok_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "file_storyblok" */
export type File_Storyblok_Arr_Rel_Insert_Input = {
  data: Array<File_Storyblok_Insert_Input>;
  on_conflict?: Maybe<File_Storyblok_On_Conflict>;
};

/** aggregate avg on columns */
export type File_Storyblok_Avg_Fields = {
  __typename?: 'file_storyblok_avg_fields';
  id?: Maybe<Scalars['Float']>;
  storyblok_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "file_storyblok" */
export type File_Storyblok_Avg_Order_By = {
  id?: Maybe<Order_By>;
  storyblok_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file_storyblok". All fields are combined with a logical 'AND'. */
export type File_Storyblok_Bool_Exp = {
  _and?: Maybe<Array<Maybe<File_Storyblok_Bool_Exp>>>;
  _not?: Maybe<File_Storyblok_Bool_Exp>;
  _or?: Maybe<Array<Maybe<File_Storyblok_Bool_Exp>>>;
  ad?: Maybe<Ads_Bool_Exp>;
  graphcool_id?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  old_url?: Maybe<String_Comparison_Exp>;
  storyblok_id?: Maybe<Int_Comparison_Exp>;
  url?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "file_storyblok" */
export enum File_Storyblok_Constraint {
  /** unique or primary key constraint */
  FileStoryblokGraphcoolIdKey = 'file_storyblok_graphcool_id_key',
  /** unique or primary key constraint */
  FileStoryblokOldUrlKey = 'file_storyblok_old_url_key',
  /** unique or primary key constraint */
  FileStoryblokPkey = 'file_storyblok_pkey',
  /** unique or primary key constraint */
  FileStoryblokStoryblokIdKey = 'file_storyblok_storyblok_id_key',
  /** unique or primary key constraint */
  FileStoryblokUrlKey = 'file_storyblok_url_key'
}

/** input type for incrementing integer column in table "file_storyblok" */
export type File_Storyblok_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  storyblok_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "file_storyblok" */
export type File_Storyblok_Insert_Input = {
  ad?: Maybe<Ads_Obj_Rel_Insert_Input>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  old_url?: Maybe<Scalars['String']>;
  storyblok_id?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type File_Storyblok_Max_Fields = {
  __typename?: 'file_storyblok_max_fields';
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  old_url?: Maybe<Scalars['String']>;
  storyblok_id?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "file_storyblok" */
export type File_Storyblok_Max_Order_By = {
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  old_url?: Maybe<Order_By>;
  storyblok_id?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type File_Storyblok_Min_Fields = {
  __typename?: 'file_storyblok_min_fields';
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  old_url?: Maybe<Scalars['String']>;
  storyblok_id?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "file_storyblok" */
export type File_Storyblok_Min_Order_By = {
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  old_url?: Maybe<Order_By>;
  storyblok_id?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** response of any mutation on the table "file_storyblok" */
export type File_Storyblok_Mutation_Response = {
  __typename?: 'file_storyblok_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<File_Storyblok>;
};

/** input type for inserting object relation for remote table "file_storyblok" */
export type File_Storyblok_Obj_Rel_Insert_Input = {
  data: File_Storyblok_Insert_Input;
  on_conflict?: Maybe<File_Storyblok_On_Conflict>;
};

/** on conflict condition type for table "file_storyblok" */
export type File_Storyblok_On_Conflict = {
  constraint: File_Storyblok_Constraint;
  update_columns: Array<File_Storyblok_Update_Column>;
  where?: Maybe<File_Storyblok_Bool_Exp>;
};

/** ordering options when selecting data from "file_storyblok" */
export type File_Storyblok_Order_By = {
  ad?: Maybe<Ads_Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  old_url?: Maybe<Order_By>;
  storyblok_id?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** primary key columns input for table: "file_storyblok" */
export type File_Storyblok_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "file_storyblok" */
export enum File_Storyblok_Select_Column {
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OldUrl = 'old_url',
  /** column name */
  StoryblokId = 'storyblok_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "file_storyblok" */
export type File_Storyblok_Set_Input = {
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  old_url?: Maybe<Scalars['String']>;
  storyblok_id?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type File_Storyblok_Stddev_Fields = {
  __typename?: 'file_storyblok_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  storyblok_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "file_storyblok" */
export type File_Storyblok_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  storyblok_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type File_Storyblok_Stddev_Pop_Fields = {
  __typename?: 'file_storyblok_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  storyblok_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "file_storyblok" */
export type File_Storyblok_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  storyblok_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type File_Storyblok_Stddev_Samp_Fields = {
  __typename?: 'file_storyblok_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  storyblok_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "file_storyblok" */
export type File_Storyblok_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  storyblok_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type File_Storyblok_Sum_Fields = {
  __typename?: 'file_storyblok_sum_fields';
  id?: Maybe<Scalars['Int']>;
  storyblok_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "file_storyblok" */
export type File_Storyblok_Sum_Order_By = {
  id?: Maybe<Order_By>;
  storyblok_id?: Maybe<Order_By>;
};

/** update columns of table "file_storyblok" */
export enum File_Storyblok_Update_Column {
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OldUrl = 'old_url',
  /** column name */
  StoryblokId = 'storyblok_id',
  /** column name */
  Url = 'url'
}

/** aggregate var_pop on columns */
export type File_Storyblok_Var_Pop_Fields = {
  __typename?: 'file_storyblok_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  storyblok_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "file_storyblok" */
export type File_Storyblok_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  storyblok_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type File_Storyblok_Var_Samp_Fields = {
  __typename?: 'file_storyblok_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  storyblok_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "file_storyblok" */
export type File_Storyblok_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  storyblok_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type File_Storyblok_Variance_Fields = {
  __typename?: 'file_storyblok_variance_fields';
  id?: Maybe<Scalars['Float']>;
  storyblok_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "file_storyblok" */
export type File_Storyblok_Variance_Order_By = {
  id?: Maybe<Order_By>;
  storyblok_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type File_Sum_Fields = {
  __typename?: 'file_sum_fields';
  id?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "file" */
export type File_Sum_Order_By = {
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
};

/** update columns of table "file" */
export enum File_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Id = 'id',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  Name = 'name',
  /** column name */
  OldName = 'old_name',
  /** column name */
  OldUrl = 'old_url',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** aggregate var_pop on columns */
export type File_Var_Pop_Fields = {
  __typename?: 'file_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "file" */
export type File_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type File_Var_Samp_Fields = {
  __typename?: 'file_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "file" */
export type File_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type File_Variance_Fields = {
  __typename?: 'file_variance_fields';
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "file" */
export type File_Variance_Order_By = {
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
};


/** expression to compare columns of type float8. All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
};


/**
 * Expression to compare the result of casting a column of type geography. Multiple
 * cast targets are combined with logical 'AND'.
 */
export type Geography_Cast_Exp = {
  geometry?: Maybe<Geometry_Comparison_Exp>;
};

/** columns and relationships of "geography_columns" */
export type Geography_Columns = {
  __typename?: 'geography_columns';
  coord_dimension?: Maybe<Scalars['Int']>;
  f_geography_column?: Maybe<Scalars['name']>;
  f_table_catalog?: Maybe<Scalars['name']>;
  f_table_name?: Maybe<Scalars['name']>;
  f_table_schema?: Maybe<Scalars['name']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "geography_columns" */
export type Geography_Columns_Aggregate = {
  __typename?: 'geography_columns_aggregate';
  aggregate?: Maybe<Geography_Columns_Aggregate_Fields>;
  nodes: Array<Geography_Columns>;
};

/** aggregate fields of "geography_columns" */
export type Geography_Columns_Aggregate_Fields = {
  __typename?: 'geography_columns_aggregate_fields';
  avg?: Maybe<Geography_Columns_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Geography_Columns_Max_Fields>;
  min?: Maybe<Geography_Columns_Min_Fields>;
  stddev?: Maybe<Geography_Columns_Stddev_Fields>;
  stddev_pop?: Maybe<Geography_Columns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Geography_Columns_Stddev_Samp_Fields>;
  sum?: Maybe<Geography_Columns_Sum_Fields>;
  var_pop?: Maybe<Geography_Columns_Var_Pop_Fields>;
  var_samp?: Maybe<Geography_Columns_Var_Samp_Fields>;
  variance?: Maybe<Geography_Columns_Variance_Fields>;
};


/** aggregate fields of "geography_columns" */
export type Geography_Columns_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Geography_Columns_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "geography_columns" */
export type Geography_Columns_Aggregate_Order_By = {
  avg?: Maybe<Geography_Columns_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Geography_Columns_Max_Order_By>;
  min?: Maybe<Geography_Columns_Min_Order_By>;
  stddev?: Maybe<Geography_Columns_Stddev_Order_By>;
  stddev_pop?: Maybe<Geography_Columns_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Geography_Columns_Stddev_Samp_Order_By>;
  sum?: Maybe<Geography_Columns_Sum_Order_By>;
  var_pop?: Maybe<Geography_Columns_Var_Pop_Order_By>;
  var_samp?: Maybe<Geography_Columns_Var_Samp_Order_By>;
  variance?: Maybe<Geography_Columns_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Geography_Columns_Avg_Fields = {
  __typename?: 'geography_columns_avg_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "geography_columns" */
export type Geography_Columns_Avg_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "geography_columns". All fields are combined with a logical 'AND'. */
export type Geography_Columns_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Geography_Columns_Bool_Exp>>>;
  _not?: Maybe<Geography_Columns_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Geography_Columns_Bool_Exp>>>;
  coord_dimension?: Maybe<Int_Comparison_Exp>;
  f_geography_column?: Maybe<Name_Comparison_Exp>;
  f_table_catalog?: Maybe<Name_Comparison_Exp>;
  f_table_name?: Maybe<Name_Comparison_Exp>;
  f_table_schema?: Maybe<Name_Comparison_Exp>;
  srid?: Maybe<Int_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Geography_Columns_Max_Fields = {
  __typename?: 'geography_columns_max_fields';
  coord_dimension?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "geography_columns" */
export type Geography_Columns_Max_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Geography_Columns_Min_Fields = {
  __typename?: 'geography_columns_min_fields';
  coord_dimension?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "geography_columns" */
export type Geography_Columns_Min_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
};

/** ordering options when selecting data from "geography_columns" */
export type Geography_Columns_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  f_geography_column?: Maybe<Order_By>;
  f_table_catalog?: Maybe<Order_By>;
  f_table_name?: Maybe<Order_By>;
  f_table_schema?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
};

/** select columns of table "geography_columns" */
export enum Geography_Columns_Select_Column {
  /** column name */
  CoordDimension = 'coord_dimension',
  /** column name */
  FGeographyColumn = 'f_geography_column',
  /** column name */
  FTableCatalog = 'f_table_catalog',
  /** column name */
  FTableName = 'f_table_name',
  /** column name */
  FTableSchema = 'f_table_schema',
  /** column name */
  Srid = 'srid',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Geography_Columns_Stddev_Fields = {
  __typename?: 'geography_columns_stddev_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "geography_columns" */
export type Geography_Columns_Stddev_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Geography_Columns_Stddev_Pop_Fields = {
  __typename?: 'geography_columns_stddev_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "geography_columns" */
export type Geography_Columns_Stddev_Pop_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Geography_Columns_Stddev_Samp_Fields = {
  __typename?: 'geography_columns_stddev_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "geography_columns" */
export type Geography_Columns_Stddev_Samp_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Geography_Columns_Sum_Fields = {
  __typename?: 'geography_columns_sum_fields';
  coord_dimension?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "geography_columns" */
export type Geography_Columns_Sum_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Geography_Columns_Var_Pop_Fields = {
  __typename?: 'geography_columns_var_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "geography_columns" */
export type Geography_Columns_Var_Pop_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Geography_Columns_Var_Samp_Fields = {
  __typename?: 'geography_columns_var_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "geography_columns" */
export type Geography_Columns_Var_Samp_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Geography_Columns_Variance_Fields = {
  __typename?: 'geography_columns_variance_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "geography_columns" */
export type Geography_Columns_Variance_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** expression to compare columns of type geography. All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: Maybe<Geography_Cast_Exp>;
  _eq?: Maybe<Scalars['geography']>;
  _gt?: Maybe<Scalars['geography']>;
  _gte?: Maybe<Scalars['geography']>;
  _in?: Maybe<Array<Scalars['geography']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['geography']>;
  _lte?: Maybe<Scalars['geography']>;
  _neq?: Maybe<Scalars['geography']>;
  _nin?: Maybe<Array<Scalars['geography']>>;
  /** is the column within a distance from a geography value */
  _st_d_within?: Maybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: Maybe<Scalars['geography']>;
};


/**
 * Expression to compare the result of casting a column of type geometry. Multiple
 * cast targets are combined with logical 'AND'.
 */
export type Geometry_Cast_Exp = {
  geography?: Maybe<Geography_Comparison_Exp>;
};

/** columns and relationships of "geometry_columns" */
export type Geometry_Columns = {
  __typename?: 'geometry_columns';
  coord_dimension?: Maybe<Scalars['Int']>;
  f_geometry_column?: Maybe<Scalars['name']>;
  f_table_catalog?: Maybe<Scalars['String']>;
  f_table_name?: Maybe<Scalars['name']>;
  f_table_schema?: Maybe<Scalars['name']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "geometry_columns" */
export type Geometry_Columns_Aggregate = {
  __typename?: 'geometry_columns_aggregate';
  aggregate?: Maybe<Geometry_Columns_Aggregate_Fields>;
  nodes: Array<Geometry_Columns>;
};

/** aggregate fields of "geometry_columns" */
export type Geometry_Columns_Aggregate_Fields = {
  __typename?: 'geometry_columns_aggregate_fields';
  avg?: Maybe<Geometry_Columns_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Geometry_Columns_Max_Fields>;
  min?: Maybe<Geometry_Columns_Min_Fields>;
  stddev?: Maybe<Geometry_Columns_Stddev_Fields>;
  stddev_pop?: Maybe<Geometry_Columns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Geometry_Columns_Stddev_Samp_Fields>;
  sum?: Maybe<Geometry_Columns_Sum_Fields>;
  var_pop?: Maybe<Geometry_Columns_Var_Pop_Fields>;
  var_samp?: Maybe<Geometry_Columns_Var_Samp_Fields>;
  variance?: Maybe<Geometry_Columns_Variance_Fields>;
};


/** aggregate fields of "geometry_columns" */
export type Geometry_Columns_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Geometry_Columns_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "geometry_columns" */
export type Geometry_Columns_Aggregate_Order_By = {
  avg?: Maybe<Geometry_Columns_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Geometry_Columns_Max_Order_By>;
  min?: Maybe<Geometry_Columns_Min_Order_By>;
  stddev?: Maybe<Geometry_Columns_Stddev_Order_By>;
  stddev_pop?: Maybe<Geometry_Columns_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Geometry_Columns_Stddev_Samp_Order_By>;
  sum?: Maybe<Geometry_Columns_Sum_Order_By>;
  var_pop?: Maybe<Geometry_Columns_Var_Pop_Order_By>;
  var_samp?: Maybe<Geometry_Columns_Var_Samp_Order_By>;
  variance?: Maybe<Geometry_Columns_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "geometry_columns" */
export type Geometry_Columns_Arr_Rel_Insert_Input = {
  data: Array<Geometry_Columns_Insert_Input>;
};

/** aggregate avg on columns */
export type Geometry_Columns_Avg_Fields = {
  __typename?: 'geometry_columns_avg_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "geometry_columns" */
export type Geometry_Columns_Avg_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "geometry_columns". All fields are combined with a logical 'AND'. */
export type Geometry_Columns_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Geometry_Columns_Bool_Exp>>>;
  _not?: Maybe<Geometry_Columns_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Geometry_Columns_Bool_Exp>>>;
  coord_dimension?: Maybe<Int_Comparison_Exp>;
  f_geometry_column?: Maybe<Name_Comparison_Exp>;
  f_table_catalog?: Maybe<String_Comparison_Exp>;
  f_table_name?: Maybe<Name_Comparison_Exp>;
  f_table_schema?: Maybe<Name_Comparison_Exp>;
  srid?: Maybe<Int_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
};

/** input type for incrementing integer column in table "geometry_columns" */
export type Geometry_Columns_Inc_Input = {
  coord_dimension?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "geometry_columns" */
export type Geometry_Columns_Insert_Input = {
  coord_dimension?: Maybe<Scalars['Int']>;
  f_geometry_column?: Maybe<Scalars['name']>;
  f_table_catalog?: Maybe<Scalars['String']>;
  f_table_name?: Maybe<Scalars['name']>;
  f_table_schema?: Maybe<Scalars['name']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Geometry_Columns_Max_Fields = {
  __typename?: 'geometry_columns_max_fields';
  coord_dimension?: Maybe<Scalars['Int']>;
  f_table_catalog?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "geometry_columns" */
export type Geometry_Columns_Max_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  f_table_catalog?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Geometry_Columns_Min_Fields = {
  __typename?: 'geometry_columns_min_fields';
  coord_dimension?: Maybe<Scalars['Int']>;
  f_table_catalog?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "geometry_columns" */
export type Geometry_Columns_Min_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  f_table_catalog?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
};

/** response of any mutation on the table "geometry_columns" */
export type Geometry_Columns_Mutation_Response = {
  __typename?: 'geometry_columns_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Geometry_Columns>;
};

/** input type for inserting object relation for remote table "geometry_columns" */
export type Geometry_Columns_Obj_Rel_Insert_Input = {
  data: Geometry_Columns_Insert_Input;
};

/** ordering options when selecting data from "geometry_columns" */
export type Geometry_Columns_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  f_geometry_column?: Maybe<Order_By>;
  f_table_catalog?: Maybe<Order_By>;
  f_table_name?: Maybe<Order_By>;
  f_table_schema?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
};

/** select columns of table "geometry_columns" */
export enum Geometry_Columns_Select_Column {
  /** column name */
  CoordDimension = 'coord_dimension',
  /** column name */
  FGeometryColumn = 'f_geometry_column',
  /** column name */
  FTableCatalog = 'f_table_catalog',
  /** column name */
  FTableName = 'f_table_name',
  /** column name */
  FTableSchema = 'f_table_schema',
  /** column name */
  Srid = 'srid',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "geometry_columns" */
export type Geometry_Columns_Set_Input = {
  coord_dimension?: Maybe<Scalars['Int']>;
  f_geometry_column?: Maybe<Scalars['name']>;
  f_table_catalog?: Maybe<Scalars['String']>;
  f_table_name?: Maybe<Scalars['name']>;
  f_table_schema?: Maybe<Scalars['name']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Geometry_Columns_Stddev_Fields = {
  __typename?: 'geometry_columns_stddev_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "geometry_columns" */
export type Geometry_Columns_Stddev_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Geometry_Columns_Stddev_Pop_Fields = {
  __typename?: 'geometry_columns_stddev_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "geometry_columns" */
export type Geometry_Columns_Stddev_Pop_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Geometry_Columns_Stddev_Samp_Fields = {
  __typename?: 'geometry_columns_stddev_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "geometry_columns" */
export type Geometry_Columns_Stddev_Samp_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Geometry_Columns_Sum_Fields = {
  __typename?: 'geometry_columns_sum_fields';
  coord_dimension?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "geometry_columns" */
export type Geometry_Columns_Sum_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Geometry_Columns_Var_Pop_Fields = {
  __typename?: 'geometry_columns_var_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "geometry_columns" */
export type Geometry_Columns_Var_Pop_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Geometry_Columns_Var_Samp_Fields = {
  __typename?: 'geometry_columns_var_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "geometry_columns" */
export type Geometry_Columns_Var_Samp_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Geometry_Columns_Variance_Fields = {
  __typename?: 'geometry_columns_variance_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "geometry_columns" */
export type Geometry_Columns_Variance_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** expression to compare columns of type geometry. All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: Maybe<Geometry_Cast_Exp>;
  _eq?: Maybe<Scalars['geometry']>;
  _gt?: Maybe<Scalars['geometry']>;
  _gte?: Maybe<Scalars['geometry']>;
  _in?: Maybe<Array<Scalars['geometry']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['geometry']>;
  _lte?: Maybe<Scalars['geometry']>;
  _neq?: Maybe<Scalars['geometry']>;
  _nin?: Maybe<Array<Scalars['geometry']>>;
  /** does the column contain the given geometry value */
  _st_contains?: Maybe<Scalars['geometry']>;
  /** does the column crosses the given geometry value */
  _st_crosses?: Maybe<Scalars['geometry']>;
  /** is the column within a distance from a geometry value */
  _st_d_within?: Maybe<St_D_Within_Input>;
  /** is the column equal to given geometry value. Directionality is ignored */
  _st_equals?: Maybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: Maybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: Maybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: Maybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: Maybe<Scalars['geometry']>;
};

/** expression to compare columns of type Int. All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

/** columns and relationships of "job_category" */
export type Job_Category = {
  __typename?: 'job_category';
  /** An array relationship */
  ads: Array<Ads>;
  /** An array relationship */
  adsByJobCategoryId: Array<Ads>;
  /** An aggregated array relationship */
  adsByJobCategoryId_aggregate: Ads_Aggregate;
  /** An aggregated array relationship */
  ads_aggregate: Ads_Aggregate;
  /** An array relationship */
  children: Array<Job_Category>;
  /** An aggregated array relationship */
  children_aggregate: Job_Category_Aggregate;
  created_at: Scalars['timestamptz'];
  graphcool_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An array relationship */
  mn_ads_job_category_subs: Array<Mn_Ads_Job_Category_Sub>;
  /** An aggregated array relationship */
  mn_ads_job_category_subs_aggregate: Mn_Ads_Job_Category_Sub_Aggregate;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  parent?: Maybe<Job_Category>;
  parent_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "job_category" */
export type Job_CategoryAdsArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};


/** columns and relationships of "job_category" */
export type Job_CategoryAdsByJobCategoryIdArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};


/** columns and relationships of "job_category" */
export type Job_CategoryAdsByJobCategoryId_AggregateArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};


/** columns and relationships of "job_category" */
export type Job_CategoryAds_AggregateArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};


/** columns and relationships of "job_category" */
export type Job_CategoryChildrenArgs = {
  distinct_on?: Maybe<Array<Job_Category_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Category_Order_By>>;
  where?: Maybe<Job_Category_Bool_Exp>;
};


/** columns and relationships of "job_category" */
export type Job_CategoryChildren_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Category_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Category_Order_By>>;
  where?: Maybe<Job_Category_Bool_Exp>;
};


/** columns and relationships of "job_category" */
export type Job_CategoryMn_Ads_Job_Category_SubsArgs = {
  distinct_on?: Maybe<Array<Mn_Ads_Job_Category_Sub_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Mn_Ads_Job_Category_Sub_Order_By>>;
  where?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
};


/** columns and relationships of "job_category" */
export type Job_CategoryMn_Ads_Job_Category_Subs_AggregateArgs = {
  distinct_on?: Maybe<Array<Mn_Ads_Job_Category_Sub_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Mn_Ads_Job_Category_Sub_Order_By>>;
  where?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
};

/** aggregated selection of "job_category" */
export type Job_Category_Aggregate = {
  __typename?: 'job_category_aggregate';
  aggregate?: Maybe<Job_Category_Aggregate_Fields>;
  nodes: Array<Job_Category>;
};

/** aggregate fields of "job_category" */
export type Job_Category_Aggregate_Fields = {
  __typename?: 'job_category_aggregate_fields';
  avg?: Maybe<Job_Category_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Job_Category_Max_Fields>;
  min?: Maybe<Job_Category_Min_Fields>;
  stddev?: Maybe<Job_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Category_Sum_Fields>;
  var_pop?: Maybe<Job_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Category_Var_Samp_Fields>;
  variance?: Maybe<Job_Category_Variance_Fields>;
};


/** aggregate fields of "job_category" */
export type Job_Category_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Category_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_category" */
export type Job_Category_Aggregate_Order_By = {
  avg?: Maybe<Job_Category_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Job_Category_Max_Order_By>;
  min?: Maybe<Job_Category_Min_Order_By>;
  stddev?: Maybe<Job_Category_Stddev_Order_By>;
  stddev_pop?: Maybe<Job_Category_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Job_Category_Stddev_Samp_Order_By>;
  sum?: Maybe<Job_Category_Sum_Order_By>;
  var_pop?: Maybe<Job_Category_Var_Pop_Order_By>;
  var_samp?: Maybe<Job_Category_Var_Samp_Order_By>;
  variance?: Maybe<Job_Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "job_category" */
export type Job_Category_Arr_Rel_Insert_Input = {
  data: Array<Job_Category_Insert_Input>;
  on_conflict?: Maybe<Job_Category_On_Conflict>;
};

/** aggregate avg on columns */
export type Job_Category_Avg_Fields = {
  __typename?: 'job_category_avg_fields';
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_category" */
export type Job_Category_Avg_Order_By = {
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "job_category". All fields are combined with a logical 'AND'. */
export type Job_Category_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Job_Category_Bool_Exp>>>;
  _not?: Maybe<Job_Category_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Job_Category_Bool_Exp>>>;
  ads?: Maybe<Ads_Bool_Exp>;
  adsByJobCategoryId?: Maybe<Ads_Bool_Exp>;
  children?: Maybe<Job_Category_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  graphcool_id?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  mn_ads_job_category_subs?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  parent?: Maybe<Job_Category_Bool_Exp>;
  parent_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_category" */
export enum Job_Category_Constraint {
  /** unique or primary key constraint */
  JobCategoryGraphcoolIdKey = 'job_category_graphcool_id_key',
  /** unique or primary key constraint */
  JobCategoryPkey = 'job_category_pkey'
}

/** input type for incrementing integer column in table "job_category" */
export type Job_Category_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  parent_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "job_category" */
export type Job_Category_Insert_Input = {
  ads?: Maybe<Ads_Arr_Rel_Insert_Input>;
  adsByJobCategoryId?: Maybe<Ads_Arr_Rel_Insert_Input>;
  children?: Maybe<Job_Category_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mn_ads_job_category_subs?: Maybe<Mn_Ads_Job_Category_Sub_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<Job_Category_Obj_Rel_Insert_Input>;
  parent_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Job_Category_Max_Fields = {
  __typename?: 'job_category_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "job_category" */
export type Job_Category_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Category_Min_Fields = {
  __typename?: 'job_category_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "job_category" */
export type Job_Category_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "job_category" */
export type Job_Category_Mutation_Response = {
  __typename?: 'job_category_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Job_Category>;
};

/** input type for inserting object relation for remote table "job_category" */
export type Job_Category_Obj_Rel_Insert_Input = {
  data: Job_Category_Insert_Input;
  on_conflict?: Maybe<Job_Category_On_Conflict>;
};

/** on conflict condition type for table "job_category" */
export type Job_Category_On_Conflict = {
  constraint: Job_Category_Constraint;
  update_columns: Array<Job_Category_Update_Column>;
  where?: Maybe<Job_Category_Bool_Exp>;
};

/** ordering options when selecting data from "job_category" */
export type Job_Category_Order_By = {
  adsByJobCategoryId_aggregate?: Maybe<Ads_Aggregate_Order_By>;
  ads_aggregate?: Maybe<Ads_Aggregate_Order_By>;
  children_aggregate?: Maybe<Job_Category_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mn_ads_job_category_subs_aggregate?: Maybe<Mn_Ads_Job_Category_Sub_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  parent?: Maybe<Job_Category_Order_By>;
  parent_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "job_category" */
export type Job_Category_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "job_category" */
export enum Job_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "job_category" */
export type Job_Category_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Job_Category_Stddev_Fields = {
  __typename?: 'job_category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_category" */
export type Job_Category_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Job_Category_Stddev_Pop_Fields = {
  __typename?: 'job_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "job_category" */
export type Job_Category_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Job_Category_Stddev_Samp_Fields = {
  __typename?: 'job_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "job_category" */
export type Job_Category_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Job_Category_Sum_Fields = {
  __typename?: 'job_category_sum_fields';
  id?: Maybe<Scalars['Int']>;
  parent_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "job_category" */
export type Job_Category_Sum_Order_By = {
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
};

/** update columns of table "job_category" */
export enum Job_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Job_Category_Var_Pop_Fields = {
  __typename?: 'job_category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "job_category" */
export type Job_Category_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Job_Category_Var_Samp_Fields = {
  __typename?: 'job_category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "job_category" */
export type Job_Category_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Job_Category_Variance_Fields = {
  __typename?: 'job_category_variance_fields';
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_category" */
export type Job_Category_Variance_Order_By = {
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
};

/** columns and relationships of "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub = {
  __typename?: 'mn_ads_job_category_sub';
  /** An object relationship */
  ad: Ads;
  ads_id: Scalars['Int'];
  /** An object relationship */
  job_category: Job_Category;
  job_category_id: Scalars['Int'];
};

/** aggregated selection of "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Aggregate = {
  __typename?: 'mn_ads_job_category_sub_aggregate';
  aggregate?: Maybe<Mn_Ads_Job_Category_Sub_Aggregate_Fields>;
  nodes: Array<Mn_Ads_Job_Category_Sub>;
};

/** aggregate fields of "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Aggregate_Fields = {
  __typename?: 'mn_ads_job_category_sub_aggregate_fields';
  avg?: Maybe<Mn_Ads_Job_Category_Sub_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Mn_Ads_Job_Category_Sub_Max_Fields>;
  min?: Maybe<Mn_Ads_Job_Category_Sub_Min_Fields>;
  stddev?: Maybe<Mn_Ads_Job_Category_Sub_Stddev_Fields>;
  stddev_pop?: Maybe<Mn_Ads_Job_Category_Sub_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mn_Ads_Job_Category_Sub_Stddev_Samp_Fields>;
  sum?: Maybe<Mn_Ads_Job_Category_Sub_Sum_Fields>;
  var_pop?: Maybe<Mn_Ads_Job_Category_Sub_Var_Pop_Fields>;
  var_samp?: Maybe<Mn_Ads_Job_Category_Sub_Var_Samp_Fields>;
  variance?: Maybe<Mn_Ads_Job_Category_Sub_Variance_Fields>;
};


/** aggregate fields of "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Mn_Ads_Job_Category_Sub_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Aggregate_Order_By = {
  avg?: Maybe<Mn_Ads_Job_Category_Sub_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Mn_Ads_Job_Category_Sub_Max_Order_By>;
  min?: Maybe<Mn_Ads_Job_Category_Sub_Min_Order_By>;
  stddev?: Maybe<Mn_Ads_Job_Category_Sub_Stddev_Order_By>;
  stddev_pop?: Maybe<Mn_Ads_Job_Category_Sub_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Mn_Ads_Job_Category_Sub_Stddev_Samp_Order_By>;
  sum?: Maybe<Mn_Ads_Job_Category_Sub_Sum_Order_By>;
  var_pop?: Maybe<Mn_Ads_Job_Category_Sub_Var_Pop_Order_By>;
  var_samp?: Maybe<Mn_Ads_Job_Category_Sub_Var_Samp_Order_By>;
  variance?: Maybe<Mn_Ads_Job_Category_Sub_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Arr_Rel_Insert_Input = {
  data: Array<Mn_Ads_Job_Category_Sub_Insert_Input>;
  on_conflict?: Maybe<Mn_Ads_Job_Category_Sub_On_Conflict>;
};

/** aggregate avg on columns */
export type Mn_Ads_Job_Category_Sub_Avg_Fields = {
  __typename?: 'mn_ads_job_category_sub_avg_fields';
  ads_id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Avg_Order_By = {
  ads_id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mn_ads_job_category_sub". All fields are combined with a logical 'AND'. */
export type Mn_Ads_Job_Category_Sub_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>>>;
  _not?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>>>;
  ad?: Maybe<Ads_Bool_Exp>;
  ads_id?: Maybe<Int_Comparison_Exp>;
  job_category?: Maybe<Job_Category_Bool_Exp>;
  job_category_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "mn_ads_job_category_sub" */
export enum Mn_Ads_Job_Category_Sub_Constraint {
  /** unique or primary key constraint */
  MnAdsJobCategorySubPkey = 'mn_ads_job_category_sub_pkey'
}

/** input type for incrementing integer column in table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Inc_Input = {
  ads_id?: Maybe<Scalars['Int']>;
  job_category_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Insert_Input = {
  ad?: Maybe<Ads_Obj_Rel_Insert_Input>;
  ads_id?: Maybe<Scalars['Int']>;
  job_category?: Maybe<Job_Category_Obj_Rel_Insert_Input>;
  job_category_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Mn_Ads_Job_Category_Sub_Max_Fields = {
  __typename?: 'mn_ads_job_category_sub_max_fields';
  ads_id?: Maybe<Scalars['Int']>;
  job_category_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Max_Order_By = {
  ads_id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Mn_Ads_Job_Category_Sub_Min_Fields = {
  __typename?: 'mn_ads_job_category_sub_min_fields';
  ads_id?: Maybe<Scalars['Int']>;
  job_category_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Min_Order_By = {
  ads_id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Mutation_Response = {
  __typename?: 'mn_ads_job_category_sub_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Mn_Ads_Job_Category_Sub>;
};

/** input type for inserting object relation for remote table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Obj_Rel_Insert_Input = {
  data: Mn_Ads_Job_Category_Sub_Insert_Input;
  on_conflict?: Maybe<Mn_Ads_Job_Category_Sub_On_Conflict>;
};

/** on conflict condition type for table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_On_Conflict = {
  constraint: Mn_Ads_Job_Category_Sub_Constraint;
  update_columns: Array<Mn_Ads_Job_Category_Sub_Update_Column>;
  where?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
};

/** ordering options when selecting data from "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Order_By = {
  ad?: Maybe<Ads_Order_By>;
  ads_id?: Maybe<Order_By>;
  job_category?: Maybe<Job_Category_Order_By>;
  job_category_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Pk_Columns_Input = {
  ads_id: Scalars['Int'];
  job_category_id: Scalars['Int'];
};

/** select columns of table "mn_ads_job_category_sub" */
export enum Mn_Ads_Job_Category_Sub_Select_Column {
  /** column name */
  AdsId = 'ads_id',
  /** column name */
  JobCategoryId = 'job_category_id'
}

/** input type for updating data in table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Set_Input = {
  ads_id?: Maybe<Scalars['Int']>;
  job_category_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Mn_Ads_Job_Category_Sub_Stddev_Fields = {
  __typename?: 'mn_ads_job_category_sub_stddev_fields';
  ads_id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Stddev_Order_By = {
  ads_id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mn_Ads_Job_Category_Sub_Stddev_Pop_Fields = {
  __typename?: 'mn_ads_job_category_sub_stddev_pop_fields';
  ads_id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Stddev_Pop_Order_By = {
  ads_id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mn_Ads_Job_Category_Sub_Stddev_Samp_Fields = {
  __typename?: 'mn_ads_job_category_sub_stddev_samp_fields';
  ads_id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Stddev_Samp_Order_By = {
  ads_id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Mn_Ads_Job_Category_Sub_Sum_Fields = {
  __typename?: 'mn_ads_job_category_sub_sum_fields';
  ads_id?: Maybe<Scalars['Int']>;
  job_category_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Sum_Order_By = {
  ads_id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
};

/** update columns of table "mn_ads_job_category_sub" */
export enum Mn_Ads_Job_Category_Sub_Update_Column {
  /** column name */
  AdsId = 'ads_id',
  /** column name */
  JobCategoryId = 'job_category_id'
}

/** aggregate var_pop on columns */
export type Mn_Ads_Job_Category_Sub_Var_Pop_Fields = {
  __typename?: 'mn_ads_job_category_sub_var_pop_fields';
  ads_id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Var_Pop_Order_By = {
  ads_id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mn_Ads_Job_Category_Sub_Var_Samp_Fields = {
  __typename?: 'mn_ads_job_category_sub_var_samp_fields';
  ads_id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Var_Samp_Order_By = {
  ads_id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Mn_Ads_Job_Category_Sub_Variance_Fields = {
  __typename?: 'mn_ads_job_category_sub_variance_fields';
  ads_id?: Maybe<Scalars['Float']>;
  job_category_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mn_ads_job_category_sub" */
export type Mn_Ads_Job_Category_Sub_Variance_Order_By = {
  ads_id?: Maybe<Order_By>;
  job_category_id?: Maybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "ads" */
  delete_ads?: Maybe<Ads_Mutation_Response>;
  /** delete single row from the table: "ads" */
  delete_ads_by_pk?: Maybe<Ads>;
  /** delete data from the table: "company" */
  delete_company?: Maybe<Company_Mutation_Response>;
  /** delete single row from the table: "company" */
  delete_company_by_pk?: Maybe<Company>;
  /** delete data from the table: "country" */
  delete_country?: Maybe<Country_Mutation_Response>;
  /** delete single row from the table: "country" */
  delete_country_by_pk?: Maybe<Country>;
  /** delete data from the table: "enum_language" */
  delete_enum_language?: Maybe<Enum_Language_Mutation_Response>;
  /** delete single row from the table: "enum_language" */
  delete_enum_language_by_pk?: Maybe<Enum_Language>;
  /** delete data from the table: "enum_user_role" */
  delete_enum_user_role?: Maybe<Enum_User_Role_Mutation_Response>;
  /** delete single row from the table: "enum_user_role" */
  delete_enum_user_role_by_pk?: Maybe<Enum_User_Role>;
  /** delete data from the table: "file" */
  delete_file?: Maybe<File_Mutation_Response>;
  /** delete single row from the table: "file" */
  delete_file_by_pk?: Maybe<File>;
  /** delete data from the table: "file_storyblok" */
  delete_file_storyblok?: Maybe<File_Storyblok_Mutation_Response>;
  /** delete single row from the table: "file_storyblok" */
  delete_file_storyblok_by_pk?: Maybe<File_Storyblok>;
  /** delete data from the table: "geometry_columns" */
  delete_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** delete data from the table: "job_category" */
  delete_job_category?: Maybe<Job_Category_Mutation_Response>;
  /** delete single row from the table: "job_category" */
  delete_job_category_by_pk?: Maybe<Job_Category>;
  /** delete data from the table: "mn_ads_job_category_sub" */
  delete_mn_ads_job_category_sub?: Maybe<Mn_Ads_Job_Category_Sub_Mutation_Response>;
  /** delete single row from the table: "mn_ads_job_category_sub" */
  delete_mn_ads_job_category_sub_by_pk?: Maybe<Mn_Ads_Job_Category_Sub>;
  /** delete data from the table: "spatial_ref_sys" */
  delete_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** delete single row from the table: "spatial_ref_sys" */
  delete_spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "users_password_reset_token" */
  delete_users_password_reset_token?: Maybe<Users_Password_Reset_Token_Mutation_Response>;
  /** delete single row from the table: "users_password_reset_token" */
  delete_users_password_reset_token_by_pk?: Maybe<Users_Password_Reset_Token>;
  /** delete data from the table: "users_resume_token" */
  delete_users_resume_token?: Maybe<Users_Resume_Token_Mutation_Response>;
  /** delete single row from the table: "users_resume_token" */
  delete_users_resume_token_by_pk?: Maybe<Users_Resume_Token>;
  /** insert data into the table: "ads" */
  insert_ads?: Maybe<Ads_Mutation_Response>;
  /** insert a single row into the table: "ads" */
  insert_ads_one?: Maybe<Ads>;
  /** insert data into the table: "company" */
  insert_company?: Maybe<Company_Mutation_Response>;
  /** insert a single row into the table: "company" */
  insert_company_one?: Maybe<Company>;
  /** insert data into the table: "country" */
  insert_country?: Maybe<Country_Mutation_Response>;
  /** insert a single row into the table: "country" */
  insert_country_one?: Maybe<Country>;
  /** insert data into the table: "enum_language" */
  insert_enum_language?: Maybe<Enum_Language_Mutation_Response>;
  /** insert a single row into the table: "enum_language" */
  insert_enum_language_one?: Maybe<Enum_Language>;
  /** insert data into the table: "enum_user_role" */
  insert_enum_user_role?: Maybe<Enum_User_Role_Mutation_Response>;
  /** insert a single row into the table: "enum_user_role" */
  insert_enum_user_role_one?: Maybe<Enum_User_Role>;
  /** insert data into the table: "file" */
  insert_file?: Maybe<File_Mutation_Response>;
  /** insert a single row into the table: "file" */
  insert_file_one?: Maybe<File>;
  /** insert data into the table: "file_storyblok" */
  insert_file_storyblok?: Maybe<File_Storyblok_Mutation_Response>;
  /** insert a single row into the table: "file_storyblok" */
  insert_file_storyblok_one?: Maybe<File_Storyblok>;
  /** insert data into the table: "geometry_columns" */
  insert_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** insert a single row into the table: "geometry_columns" */
  insert_geometry_columns_one?: Maybe<Geometry_Columns>;
  /** insert data into the table: "job_category" */
  insert_job_category?: Maybe<Job_Category_Mutation_Response>;
  /** insert a single row into the table: "job_category" */
  insert_job_category_one?: Maybe<Job_Category>;
  /** insert data into the table: "mn_ads_job_category_sub" */
  insert_mn_ads_job_category_sub?: Maybe<Mn_Ads_Job_Category_Sub_Mutation_Response>;
  /** insert a single row into the table: "mn_ads_job_category_sub" */
  insert_mn_ads_job_category_sub_one?: Maybe<Mn_Ads_Job_Category_Sub>;
  /** insert data into the table: "spatial_ref_sys" */
  insert_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** insert a single row into the table: "spatial_ref_sys" */
  insert_spatial_ref_sys_one?: Maybe<Spatial_Ref_Sys>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "users_password_reset_token" */
  insert_users_password_reset_token?: Maybe<Users_Password_Reset_Token_Mutation_Response>;
  /** insert a single row into the table: "users_password_reset_token" */
  insert_users_password_reset_token_one?: Maybe<Users_Password_Reset_Token>;
  /** insert data into the table: "users_resume_token" */
  insert_users_resume_token?: Maybe<Users_Resume_Token_Mutation_Response>;
  /** insert a single row into the table: "users_resume_token" */
  insert_users_resume_token_one?: Maybe<Users_Resume_Token>;
  /** update data of the table: "ads" */
  update_ads?: Maybe<Ads_Mutation_Response>;
  /** update single row of the table: "ads" */
  update_ads_by_pk?: Maybe<Ads>;
  /** update data of the table: "company" */
  update_company?: Maybe<Company_Mutation_Response>;
  /** update single row of the table: "company" */
  update_company_by_pk?: Maybe<Company>;
  /** update data of the table: "country" */
  update_country?: Maybe<Country_Mutation_Response>;
  /** update single row of the table: "country" */
  update_country_by_pk?: Maybe<Country>;
  /** update data of the table: "enum_language" */
  update_enum_language?: Maybe<Enum_Language_Mutation_Response>;
  /** update single row of the table: "enum_language" */
  update_enum_language_by_pk?: Maybe<Enum_Language>;
  /** update data of the table: "enum_user_role" */
  update_enum_user_role?: Maybe<Enum_User_Role_Mutation_Response>;
  /** update single row of the table: "enum_user_role" */
  update_enum_user_role_by_pk?: Maybe<Enum_User_Role>;
  /** update data of the table: "file" */
  update_file?: Maybe<File_Mutation_Response>;
  /** update single row of the table: "file" */
  update_file_by_pk?: Maybe<File>;
  /** update data of the table: "file_storyblok" */
  update_file_storyblok?: Maybe<File_Storyblok_Mutation_Response>;
  /** update single row of the table: "file_storyblok" */
  update_file_storyblok_by_pk?: Maybe<File_Storyblok>;
  /** update data of the table: "geometry_columns" */
  update_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** update data of the table: "job_category" */
  update_job_category?: Maybe<Job_Category_Mutation_Response>;
  /** update single row of the table: "job_category" */
  update_job_category_by_pk?: Maybe<Job_Category>;
  /** update data of the table: "mn_ads_job_category_sub" */
  update_mn_ads_job_category_sub?: Maybe<Mn_Ads_Job_Category_Sub_Mutation_Response>;
  /** update single row of the table: "mn_ads_job_category_sub" */
  update_mn_ads_job_category_sub_by_pk?: Maybe<Mn_Ads_Job_Category_Sub>;
  /** update data of the table: "spatial_ref_sys" */
  update_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** update single row of the table: "spatial_ref_sys" */
  update_spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update data of the table: "users_password_reset_token" */
  update_users_password_reset_token?: Maybe<Users_Password_Reset_Token_Mutation_Response>;
  /** update single row of the table: "users_password_reset_token" */
  update_users_password_reset_token_by_pk?: Maybe<Users_Password_Reset_Token>;
  /** update data of the table: "users_resume_token" */
  update_users_resume_token?: Maybe<Users_Resume_Token_Mutation_Response>;
  /** update single row of the table: "users_resume_token" */
  update_users_resume_token_by_pk?: Maybe<Users_Resume_Token>;
};


/** mutation root */
export type Mutation_RootDelete_AdsArgs = {
  where: Ads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ads_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyArgs = {
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CountryArgs = {
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Country_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_LanguageArgs = {
  where: Enum_Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Language_By_PkArgs = {
  key: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_User_RoleArgs = {
  where: Enum_User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_User_Role_By_PkArgs = {
  text: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_FileArgs = {
  where: File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_File_StoryblokArgs = {
  where: File_Storyblok_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_Storyblok_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Geometry_ColumnsArgs = {
  where: Geometry_Columns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_CategoryArgs = {
  where: Job_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Category_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mn_Ads_Job_Category_SubArgs = {
  where: Mn_Ads_Job_Category_Sub_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mn_Ads_Job_Category_Sub_By_PkArgs = {
  ads_id: Scalars['Int'];
  job_category_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Spatial_Ref_SysArgs = {
  where: Spatial_Ref_Sys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Spatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Users_Password_Reset_TokenArgs = {
  where: Users_Password_Reset_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_Password_Reset_Token_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Users_Resume_TokenArgs = {
  where: Users_Resume_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_Resume_Token_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsert_AdsArgs = {
  objects: Array<Ads_Insert_Input>;
  on_conflict?: Maybe<Ads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ads_OneArgs = {
  object: Ads_Insert_Input;
  on_conflict?: Maybe<Ads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyArgs = {
  objects: Array<Company_Insert_Input>;
  on_conflict?: Maybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_OneArgs = {
  object: Company_Insert_Input;
  on_conflict?: Maybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountryArgs = {
  objects: Array<Country_Insert_Input>;
  on_conflict?: Maybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_OneArgs = {
  object: Country_Insert_Input;
  on_conflict?: Maybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_LanguageArgs = {
  objects: Array<Enum_Language_Insert_Input>;
  on_conflict?: Maybe<Enum_Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Language_OneArgs = {
  object: Enum_Language_Insert_Input;
  on_conflict?: Maybe<Enum_Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_User_RoleArgs = {
  objects: Array<Enum_User_Role_Insert_Input>;
  on_conflict?: Maybe<Enum_User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_User_Role_OneArgs = {
  object: Enum_User_Role_Insert_Input;
  on_conflict?: Maybe<Enum_User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileArgs = {
  objects: Array<File_Insert_Input>;
  on_conflict?: Maybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_OneArgs = {
  object: File_Insert_Input;
  on_conflict?: Maybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_StoryblokArgs = {
  objects: Array<File_Storyblok_Insert_Input>;
  on_conflict?: Maybe<File_Storyblok_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_Storyblok_OneArgs = {
  object: File_Storyblok_Insert_Input;
  on_conflict?: Maybe<File_Storyblok_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Geometry_ColumnsArgs = {
  objects: Array<Geometry_Columns_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Geometry_Columns_OneArgs = {
  object: Geometry_Columns_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_CategoryArgs = {
  objects: Array<Job_Category_Insert_Input>;
  on_conflict?: Maybe<Job_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Category_OneArgs = {
  object: Job_Category_Insert_Input;
  on_conflict?: Maybe<Job_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mn_Ads_Job_Category_SubArgs = {
  objects: Array<Mn_Ads_Job_Category_Sub_Insert_Input>;
  on_conflict?: Maybe<Mn_Ads_Job_Category_Sub_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mn_Ads_Job_Category_Sub_OneArgs = {
  object: Mn_Ads_Job_Category_Sub_Insert_Input;
  on_conflict?: Maybe<Mn_Ads_Job_Category_Sub_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spatial_Ref_SysArgs = {
  objects: Array<Spatial_Ref_Sys_Insert_Input>;
  on_conflict?: Maybe<Spatial_Ref_Sys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spatial_Ref_Sys_OneArgs = {
  object: Spatial_Ref_Sys_Insert_Input;
  on_conflict?: Maybe<Spatial_Ref_Sys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Password_Reset_TokenArgs = {
  objects: Array<Users_Password_Reset_Token_Insert_Input>;
  on_conflict?: Maybe<Users_Password_Reset_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Password_Reset_Token_OneArgs = {
  object: Users_Password_Reset_Token_Insert_Input;
  on_conflict?: Maybe<Users_Password_Reset_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Resume_TokenArgs = {
  objects: Array<Users_Resume_Token_Insert_Input>;
  on_conflict?: Maybe<Users_Resume_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Resume_Token_OneArgs = {
  object: Users_Resume_Token_Insert_Input;
  on_conflict?: Maybe<Users_Resume_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_AdsArgs = {
  _inc?: Maybe<Ads_Inc_Input>;
  _set?: Maybe<Ads_Set_Input>;
  where: Ads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ads_By_PkArgs = {
  _inc?: Maybe<Ads_Inc_Input>;
  _set?: Maybe<Ads_Set_Input>;
  pk_columns: Ads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyArgs = {
  _inc?: Maybe<Company_Inc_Input>;
  _set?: Maybe<Company_Set_Input>;
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_By_PkArgs = {
  _inc?: Maybe<Company_Inc_Input>;
  _set?: Maybe<Company_Set_Input>;
  pk_columns: Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CountryArgs = {
  _inc?: Maybe<Country_Inc_Input>;
  _set?: Maybe<Country_Set_Input>;
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Country_By_PkArgs = {
  _inc?: Maybe<Country_Inc_Input>;
  _set?: Maybe<Country_Set_Input>;
  pk_columns: Country_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_LanguageArgs = {
  _set?: Maybe<Enum_Language_Set_Input>;
  where: Enum_Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Language_By_PkArgs = {
  _set?: Maybe<Enum_Language_Set_Input>;
  pk_columns: Enum_Language_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_User_RoleArgs = {
  _set?: Maybe<Enum_User_Role_Set_Input>;
  where: Enum_User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_User_Role_By_PkArgs = {
  _set?: Maybe<Enum_User_Role_Set_Input>;
  pk_columns: Enum_User_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FileArgs = {
  _inc?: Maybe<File_Inc_Input>;
  _set?: Maybe<File_Set_Input>;
  where: File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_By_PkArgs = {
  _inc?: Maybe<File_Inc_Input>;
  _set?: Maybe<File_Set_Input>;
  pk_columns: File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_StoryblokArgs = {
  _inc?: Maybe<File_Storyblok_Inc_Input>;
  _set?: Maybe<File_Storyblok_Set_Input>;
  where: File_Storyblok_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_Storyblok_By_PkArgs = {
  _inc?: Maybe<File_Storyblok_Inc_Input>;
  _set?: Maybe<File_Storyblok_Set_Input>;
  pk_columns: File_Storyblok_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Geometry_ColumnsArgs = {
  _inc?: Maybe<Geometry_Columns_Inc_Input>;
  _set?: Maybe<Geometry_Columns_Set_Input>;
  where: Geometry_Columns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_CategoryArgs = {
  _inc?: Maybe<Job_Category_Inc_Input>;
  _set?: Maybe<Job_Category_Set_Input>;
  where: Job_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Category_By_PkArgs = {
  _inc?: Maybe<Job_Category_Inc_Input>;
  _set?: Maybe<Job_Category_Set_Input>;
  pk_columns: Job_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mn_Ads_Job_Category_SubArgs = {
  _inc?: Maybe<Mn_Ads_Job_Category_Sub_Inc_Input>;
  _set?: Maybe<Mn_Ads_Job_Category_Sub_Set_Input>;
  where: Mn_Ads_Job_Category_Sub_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mn_Ads_Job_Category_Sub_By_PkArgs = {
  _inc?: Maybe<Mn_Ads_Job_Category_Sub_Inc_Input>;
  _set?: Maybe<Mn_Ads_Job_Category_Sub_Set_Input>;
  pk_columns: Mn_Ads_Job_Category_Sub_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Spatial_Ref_SysArgs = {
  _inc?: Maybe<Spatial_Ref_Sys_Inc_Input>;
  _set?: Maybe<Spatial_Ref_Sys_Set_Input>;
  where: Spatial_Ref_Sys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Spatial_Ref_Sys_By_PkArgs = {
  _inc?: Maybe<Spatial_Ref_Sys_Inc_Input>;
  _set?: Maybe<Spatial_Ref_Sys_Set_Input>;
  pk_columns: Spatial_Ref_Sys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: Maybe<Users_Inc_Input>;
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: Maybe<Users_Inc_Input>;
  _set?: Maybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Password_Reset_TokenArgs = {
  _inc?: Maybe<Users_Password_Reset_Token_Inc_Input>;
  _set?: Maybe<Users_Password_Reset_Token_Set_Input>;
  where: Users_Password_Reset_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Password_Reset_Token_By_PkArgs = {
  _inc?: Maybe<Users_Password_Reset_Token_Inc_Input>;
  _set?: Maybe<Users_Password_Reset_Token_Set_Input>;
  pk_columns: Users_Password_Reset_Token_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Resume_TokenArgs = {
  _inc?: Maybe<Users_Resume_Token_Inc_Input>;
  _set?: Maybe<Users_Resume_Token_Set_Input>;
  where: Users_Resume_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Resume_Token_By_PkArgs = {
  _inc?: Maybe<Users_Resume_Token_Inc_Input>;
  _set?: Maybe<Users_Resume_Token_Set_Input>;
  pk_columns: Users_Resume_Token_Pk_Columns_Input;
};


/** expression to compare columns of type name. All fields are combined with logical 'AND'. */
export type Name_Comparison_Exp = {
  _eq?: Maybe<Scalars['name']>;
  _gt?: Maybe<Scalars['name']>;
  _gte?: Maybe<Scalars['name']>;
  _in?: Maybe<Array<Scalars['name']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['name']>;
  _lte?: Maybe<Scalars['name']>;
  _neq?: Maybe<Scalars['name']>;
  _nin?: Maybe<Array<Scalars['name']>>;
};


/** expression to compare columns of type numeric. All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in the ascending order, nulls last */
  Asc = 'asc',
  /** in the ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in the ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in the descending order, nulls first */
  Desc = 'desc',
  /** in the descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in the descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** query root */
export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "ads" */
  ads: Array<Ads>;
  /** fetch aggregated fields from the table: "ads" */
  ads_aggregate: Ads_Aggregate;
  /** fetch data from the table: "ads" using primary key columns */
  ads_by_pk?: Maybe<Ads>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "enum_language" */
  enum_language: Array<Enum_Language>;
  /** fetch aggregated fields from the table: "enum_language" */
  enum_language_aggregate: Enum_Language_Aggregate;
  /** fetch data from the table: "enum_language" using primary key columns */
  enum_language_by_pk?: Maybe<Enum_Language>;
  /** fetch data from the table: "enum_user_role" */
  enum_user_role: Array<Enum_User_Role>;
  /** fetch aggregated fields from the table: "enum_user_role" */
  enum_user_role_aggregate: Enum_User_Role_Aggregate;
  /** fetch data from the table: "enum_user_role" using primary key columns */
  enum_user_role_by_pk?: Maybe<Enum_User_Role>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk?: Maybe<File>;
  /** fetch data from the table: "file_storyblok" */
  file_storyblok: Array<File_Storyblok>;
  /** fetch aggregated fields from the table: "file_storyblok" */
  file_storyblok_aggregate: File_Storyblok_Aggregate;
  /** fetch data from the table: "file_storyblok" using primary key columns */
  file_storyblok_by_pk?: Maybe<File_Storyblok>;
  /** fetch data from the table: "geography_columns" */
  geography_columns: Array<Geography_Columns>;
  /** fetch aggregated fields from the table: "geography_columns" */
  geography_columns_aggregate: Geography_Columns_Aggregate;
  /** fetch data from the table: "geometry_columns" */
  geometry_columns: Array<Geometry_Columns>;
  /** fetch aggregated fields from the table: "geometry_columns" */
  geometry_columns_aggregate: Geometry_Columns_Aggregate;
  /** fetch data from the table: "job_category" */
  job_category: Array<Job_Category>;
  /** fetch aggregated fields from the table: "job_category" */
  job_category_aggregate: Job_Category_Aggregate;
  /** fetch data from the table: "job_category" using primary key columns */
  job_category_by_pk?: Maybe<Job_Category>;
  /** fetch data from the table: "mn_ads_job_category_sub" */
  mn_ads_job_category_sub: Array<Mn_Ads_Job_Category_Sub>;
  /** fetch aggregated fields from the table: "mn_ads_job_category_sub" */
  mn_ads_job_category_sub_aggregate: Mn_Ads_Job_Category_Sub_Aggregate;
  /** fetch data from the table: "mn_ads_job_category_sub" using primary key columns */
  mn_ads_job_category_sub_by_pk?: Maybe<Mn_Ads_Job_Category_Sub>;
  /** fetch data from the table: "raster_columns" */
  raster_columns: Array<Raster_Columns>;
  /** fetch aggregated fields from the table: "raster_columns" */
  raster_columns_aggregate: Raster_Columns_Aggregate;
  /** fetch data from the table: "raster_overviews" */
  raster_overviews: Array<Raster_Overviews>;
  /** fetch aggregated fields from the table: "raster_overviews" */
  raster_overviews_aggregate: Raster_Overviews_Aggregate;
  /** fetch data from the table: "spatial_ref_sys" */
  spatial_ref_sys: Array<Spatial_Ref_Sys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatial_ref_sys_aggregate: Spatial_Ref_Sys_Aggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "users_password_reset_token" */
  users_password_reset_token: Array<Users_Password_Reset_Token>;
  /** fetch aggregated fields from the table: "users_password_reset_token" */
  users_password_reset_token_aggregate: Users_Password_Reset_Token_Aggregate;
  /** fetch data from the table: "users_password_reset_token" using primary key columns */
  users_password_reset_token_by_pk?: Maybe<Users_Password_Reset_Token>;
  /** fetch data from the table: "users_resume_token" */
  users_resume_token: Array<Users_Resume_Token>;
  /** fetch aggregated fields from the table: "users_resume_token" */
  users_resume_token_aggregate: Users_Resume_Token_Aggregate;
  /** fetch data from the table: "users_resume_token" using primary key columns */
  users_resume_token_by_pk?: Maybe<Users_Resume_Token>;
};


/** query root */
export type Query_RootAdsArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};


/** query root */
export type Query_RootAds_AggregateArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};


/** query root */
export type Query_RootAds_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootCompanyArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


/** query root */
export type Query_RootCompany_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


/** query root */
export type Query_RootCompany_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootCountryArgs = {
  distinct_on?: Maybe<Array<Country_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Country_Order_By>>;
  where?: Maybe<Country_Bool_Exp>;
};


/** query root */
export type Query_RootCountry_AggregateArgs = {
  distinct_on?: Maybe<Array<Country_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Country_Order_By>>;
  where?: Maybe<Country_Bool_Exp>;
};


/** query root */
export type Query_RootCountry_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootEnum_LanguageArgs = {
  distinct_on?: Maybe<Array<Enum_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Language_Order_By>>;
  where?: Maybe<Enum_Language_Bool_Exp>;
};


/** query root */
export type Query_RootEnum_Language_AggregateArgs = {
  distinct_on?: Maybe<Array<Enum_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Language_Order_By>>;
  where?: Maybe<Enum_Language_Bool_Exp>;
};


/** query root */
export type Query_RootEnum_Language_By_PkArgs = {
  key: Scalars['String'];
};


/** query root */
export type Query_RootEnum_User_RoleArgs = {
  distinct_on?: Maybe<Array<Enum_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_User_Role_Order_By>>;
  where?: Maybe<Enum_User_Role_Bool_Exp>;
};


/** query root */
export type Query_RootEnum_User_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Enum_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_User_Role_Order_By>>;
  where?: Maybe<Enum_User_Role_Bool_Exp>;
};


/** query root */
export type Query_RootEnum_User_Role_By_PkArgs = {
  text: Scalars['String'];
};


/** query root */
export type Query_RootFileArgs = {
  distinct_on?: Maybe<Array<File_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Order_By>>;
  where?: Maybe<File_Bool_Exp>;
};


/** query root */
export type Query_RootFile_AggregateArgs = {
  distinct_on?: Maybe<Array<File_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Order_By>>;
  where?: Maybe<File_Bool_Exp>;
};


/** query root */
export type Query_RootFile_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootFile_StoryblokArgs = {
  distinct_on?: Maybe<Array<File_Storyblok_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Storyblok_Order_By>>;
  where?: Maybe<File_Storyblok_Bool_Exp>;
};


/** query root */
export type Query_RootFile_Storyblok_AggregateArgs = {
  distinct_on?: Maybe<Array<File_Storyblok_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Storyblok_Order_By>>;
  where?: Maybe<File_Storyblok_Bool_Exp>;
};


/** query root */
export type Query_RootFile_Storyblok_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootGeography_ColumnsArgs = {
  distinct_on?: Maybe<Array<Geography_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geography_Columns_Order_By>>;
  where?: Maybe<Geography_Columns_Bool_Exp>;
};


/** query root */
export type Query_RootGeography_Columns_AggregateArgs = {
  distinct_on?: Maybe<Array<Geography_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geography_Columns_Order_By>>;
  where?: Maybe<Geography_Columns_Bool_Exp>;
};


/** query root */
export type Query_RootGeometry_ColumnsArgs = {
  distinct_on?: Maybe<Array<Geometry_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geometry_Columns_Order_By>>;
  where?: Maybe<Geometry_Columns_Bool_Exp>;
};


/** query root */
export type Query_RootGeometry_Columns_AggregateArgs = {
  distinct_on?: Maybe<Array<Geometry_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geometry_Columns_Order_By>>;
  where?: Maybe<Geometry_Columns_Bool_Exp>;
};


/** query root */
export type Query_RootJob_CategoryArgs = {
  distinct_on?: Maybe<Array<Job_Category_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Category_Order_By>>;
  where?: Maybe<Job_Category_Bool_Exp>;
};


/** query root */
export type Query_RootJob_Category_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Category_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Category_Order_By>>;
  where?: Maybe<Job_Category_Bool_Exp>;
};


/** query root */
export type Query_RootJob_Category_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootMn_Ads_Job_Category_SubArgs = {
  distinct_on?: Maybe<Array<Mn_Ads_Job_Category_Sub_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Mn_Ads_Job_Category_Sub_Order_By>>;
  where?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
};


/** query root */
export type Query_RootMn_Ads_Job_Category_Sub_AggregateArgs = {
  distinct_on?: Maybe<Array<Mn_Ads_Job_Category_Sub_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Mn_Ads_Job_Category_Sub_Order_By>>;
  where?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
};


/** query root */
export type Query_RootMn_Ads_Job_Category_Sub_By_PkArgs = {
  ads_id: Scalars['Int'];
  job_category_id: Scalars['Int'];
};


/** query root */
export type Query_RootRaster_ColumnsArgs = {
  distinct_on?: Maybe<Array<Raster_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Raster_Columns_Order_By>>;
  where?: Maybe<Raster_Columns_Bool_Exp>;
};


/** query root */
export type Query_RootRaster_Columns_AggregateArgs = {
  distinct_on?: Maybe<Array<Raster_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Raster_Columns_Order_By>>;
  where?: Maybe<Raster_Columns_Bool_Exp>;
};


/** query root */
export type Query_RootRaster_OverviewsArgs = {
  distinct_on?: Maybe<Array<Raster_Overviews_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Raster_Overviews_Order_By>>;
  where?: Maybe<Raster_Overviews_Bool_Exp>;
};


/** query root */
export type Query_RootRaster_Overviews_AggregateArgs = {
  distinct_on?: Maybe<Array<Raster_Overviews_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Raster_Overviews_Order_By>>;
  where?: Maybe<Raster_Overviews_Bool_Exp>;
};


/** query root */
export type Query_RootSpatial_Ref_SysArgs = {
  distinct_on?: Maybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
};


/** query root */
export type Query_RootSpatial_Ref_Sys_AggregateArgs = {
  distinct_on?: Maybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
};


/** query root */
export type Query_RootSpatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int'];
};


/** query root */
export type Query_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootUsers_Password_Reset_TokenArgs = {
  distinct_on?: Maybe<Array<Users_Password_Reset_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Password_Reset_Token_Order_By>>;
  where?: Maybe<Users_Password_Reset_Token_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_Password_Reset_Token_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Password_Reset_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Password_Reset_Token_Order_By>>;
  where?: Maybe<Users_Password_Reset_Token_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_Password_Reset_Token_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootUsers_Resume_TokenArgs = {
  distinct_on?: Maybe<Array<Users_Resume_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Resume_Token_Order_By>>;
  where?: Maybe<Users_Resume_Token_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_Resume_Token_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Resume_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Resume_Token_Order_By>>;
  where?: Maybe<Users_Resume_Token_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_Resume_Token_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "raster_columns" */
export type Raster_Columns = {
  __typename?: 'raster_columns';
  blocksize_x?: Maybe<Scalars['Int']>;
  blocksize_y?: Maybe<Scalars['Int']>;
  extent?: Maybe<Scalars['geometry']>;
  nodata_values?: Maybe<Scalars['_float8']>;
  num_bands?: Maybe<Scalars['Int']>;
  out_db?: Maybe<Scalars['_bool']>;
  pixel_types?: Maybe<Scalars['_text']>;
  r_raster_column?: Maybe<Scalars['name']>;
  r_table_catalog?: Maybe<Scalars['name']>;
  r_table_name?: Maybe<Scalars['name']>;
  r_table_schema?: Maybe<Scalars['name']>;
  regular_blocking?: Maybe<Scalars['Boolean']>;
  same_alignment?: Maybe<Scalars['Boolean']>;
  scale_x?: Maybe<Scalars['float8']>;
  scale_y?: Maybe<Scalars['float8']>;
  spatial_index?: Maybe<Scalars['Boolean']>;
  srid?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "raster_columns" */
export type Raster_Columns_Aggregate = {
  __typename?: 'raster_columns_aggregate';
  aggregate?: Maybe<Raster_Columns_Aggregate_Fields>;
  nodes: Array<Raster_Columns>;
};

/** aggregate fields of "raster_columns" */
export type Raster_Columns_Aggregate_Fields = {
  __typename?: 'raster_columns_aggregate_fields';
  avg?: Maybe<Raster_Columns_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Raster_Columns_Max_Fields>;
  min?: Maybe<Raster_Columns_Min_Fields>;
  stddev?: Maybe<Raster_Columns_Stddev_Fields>;
  stddev_pop?: Maybe<Raster_Columns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Raster_Columns_Stddev_Samp_Fields>;
  sum?: Maybe<Raster_Columns_Sum_Fields>;
  var_pop?: Maybe<Raster_Columns_Var_Pop_Fields>;
  var_samp?: Maybe<Raster_Columns_Var_Samp_Fields>;
  variance?: Maybe<Raster_Columns_Variance_Fields>;
};


/** aggregate fields of "raster_columns" */
export type Raster_Columns_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Raster_Columns_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "raster_columns" */
export type Raster_Columns_Aggregate_Order_By = {
  avg?: Maybe<Raster_Columns_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Raster_Columns_Max_Order_By>;
  min?: Maybe<Raster_Columns_Min_Order_By>;
  stddev?: Maybe<Raster_Columns_Stddev_Order_By>;
  stddev_pop?: Maybe<Raster_Columns_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Raster_Columns_Stddev_Samp_Order_By>;
  sum?: Maybe<Raster_Columns_Sum_Order_By>;
  var_pop?: Maybe<Raster_Columns_Var_Pop_Order_By>;
  var_samp?: Maybe<Raster_Columns_Var_Samp_Order_By>;
  variance?: Maybe<Raster_Columns_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Raster_Columns_Avg_Fields = {
  __typename?: 'raster_columns_avg_fields';
  blocksize_x?: Maybe<Scalars['Float']>;
  blocksize_y?: Maybe<Scalars['Float']>;
  num_bands?: Maybe<Scalars['Float']>;
  scale_x?: Maybe<Scalars['Float']>;
  scale_y?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "raster_columns" */
export type Raster_Columns_Avg_Order_By = {
  blocksize_x?: Maybe<Order_By>;
  blocksize_y?: Maybe<Order_By>;
  num_bands?: Maybe<Order_By>;
  scale_x?: Maybe<Order_By>;
  scale_y?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "raster_columns". All fields are combined with a logical 'AND'. */
export type Raster_Columns_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Raster_Columns_Bool_Exp>>>;
  _not?: Maybe<Raster_Columns_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Raster_Columns_Bool_Exp>>>;
  blocksize_x?: Maybe<Int_Comparison_Exp>;
  blocksize_y?: Maybe<Int_Comparison_Exp>;
  extent?: Maybe<Geometry_Comparison_Exp>;
  nodata_values?: Maybe<_Float8_Comparison_Exp>;
  num_bands?: Maybe<Int_Comparison_Exp>;
  out_db?: Maybe<_Bool_Comparison_Exp>;
  pixel_types?: Maybe<_Text_Comparison_Exp>;
  r_raster_column?: Maybe<Name_Comparison_Exp>;
  r_table_catalog?: Maybe<Name_Comparison_Exp>;
  r_table_name?: Maybe<Name_Comparison_Exp>;
  r_table_schema?: Maybe<Name_Comparison_Exp>;
  regular_blocking?: Maybe<Boolean_Comparison_Exp>;
  same_alignment?: Maybe<Boolean_Comparison_Exp>;
  scale_x?: Maybe<Float8_Comparison_Exp>;
  scale_y?: Maybe<Float8_Comparison_Exp>;
  spatial_index?: Maybe<Boolean_Comparison_Exp>;
  srid?: Maybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Raster_Columns_Max_Fields = {
  __typename?: 'raster_columns_max_fields';
  blocksize_x?: Maybe<Scalars['Int']>;
  blocksize_y?: Maybe<Scalars['Int']>;
  num_bands?: Maybe<Scalars['Int']>;
  scale_x?: Maybe<Scalars['float8']>;
  scale_y?: Maybe<Scalars['float8']>;
  srid?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "raster_columns" */
export type Raster_Columns_Max_Order_By = {
  blocksize_x?: Maybe<Order_By>;
  blocksize_y?: Maybe<Order_By>;
  num_bands?: Maybe<Order_By>;
  scale_x?: Maybe<Order_By>;
  scale_y?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Raster_Columns_Min_Fields = {
  __typename?: 'raster_columns_min_fields';
  blocksize_x?: Maybe<Scalars['Int']>;
  blocksize_y?: Maybe<Scalars['Int']>;
  num_bands?: Maybe<Scalars['Int']>;
  scale_x?: Maybe<Scalars['float8']>;
  scale_y?: Maybe<Scalars['float8']>;
  srid?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "raster_columns" */
export type Raster_Columns_Min_Order_By = {
  blocksize_x?: Maybe<Order_By>;
  blocksize_y?: Maybe<Order_By>;
  num_bands?: Maybe<Order_By>;
  scale_x?: Maybe<Order_By>;
  scale_y?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** ordering options when selecting data from "raster_columns" */
export type Raster_Columns_Order_By = {
  blocksize_x?: Maybe<Order_By>;
  blocksize_y?: Maybe<Order_By>;
  extent?: Maybe<Order_By>;
  nodata_values?: Maybe<Order_By>;
  num_bands?: Maybe<Order_By>;
  out_db?: Maybe<Order_By>;
  pixel_types?: Maybe<Order_By>;
  r_raster_column?: Maybe<Order_By>;
  r_table_catalog?: Maybe<Order_By>;
  r_table_name?: Maybe<Order_By>;
  r_table_schema?: Maybe<Order_By>;
  regular_blocking?: Maybe<Order_By>;
  same_alignment?: Maybe<Order_By>;
  scale_x?: Maybe<Order_By>;
  scale_y?: Maybe<Order_By>;
  spatial_index?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** select columns of table "raster_columns" */
export enum Raster_Columns_Select_Column {
  /** column name */
  BlocksizeX = 'blocksize_x',
  /** column name */
  BlocksizeY = 'blocksize_y',
  /** column name */
  Extent = 'extent',
  /** column name */
  NodataValues = 'nodata_values',
  /** column name */
  NumBands = 'num_bands',
  /** column name */
  OutDb = 'out_db',
  /** column name */
  PixelTypes = 'pixel_types',
  /** column name */
  RRasterColumn = 'r_raster_column',
  /** column name */
  RTableCatalog = 'r_table_catalog',
  /** column name */
  RTableName = 'r_table_name',
  /** column name */
  RTableSchema = 'r_table_schema',
  /** column name */
  RegularBlocking = 'regular_blocking',
  /** column name */
  SameAlignment = 'same_alignment',
  /** column name */
  ScaleX = 'scale_x',
  /** column name */
  ScaleY = 'scale_y',
  /** column name */
  SpatialIndex = 'spatial_index',
  /** column name */
  Srid = 'srid'
}

/** aggregate stddev on columns */
export type Raster_Columns_Stddev_Fields = {
  __typename?: 'raster_columns_stddev_fields';
  blocksize_x?: Maybe<Scalars['Float']>;
  blocksize_y?: Maybe<Scalars['Float']>;
  num_bands?: Maybe<Scalars['Float']>;
  scale_x?: Maybe<Scalars['Float']>;
  scale_y?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "raster_columns" */
export type Raster_Columns_Stddev_Order_By = {
  blocksize_x?: Maybe<Order_By>;
  blocksize_y?: Maybe<Order_By>;
  num_bands?: Maybe<Order_By>;
  scale_x?: Maybe<Order_By>;
  scale_y?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Raster_Columns_Stddev_Pop_Fields = {
  __typename?: 'raster_columns_stddev_pop_fields';
  blocksize_x?: Maybe<Scalars['Float']>;
  blocksize_y?: Maybe<Scalars['Float']>;
  num_bands?: Maybe<Scalars['Float']>;
  scale_x?: Maybe<Scalars['Float']>;
  scale_y?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "raster_columns" */
export type Raster_Columns_Stddev_Pop_Order_By = {
  blocksize_x?: Maybe<Order_By>;
  blocksize_y?: Maybe<Order_By>;
  num_bands?: Maybe<Order_By>;
  scale_x?: Maybe<Order_By>;
  scale_y?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Raster_Columns_Stddev_Samp_Fields = {
  __typename?: 'raster_columns_stddev_samp_fields';
  blocksize_x?: Maybe<Scalars['Float']>;
  blocksize_y?: Maybe<Scalars['Float']>;
  num_bands?: Maybe<Scalars['Float']>;
  scale_x?: Maybe<Scalars['Float']>;
  scale_y?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "raster_columns" */
export type Raster_Columns_Stddev_Samp_Order_By = {
  blocksize_x?: Maybe<Order_By>;
  blocksize_y?: Maybe<Order_By>;
  num_bands?: Maybe<Order_By>;
  scale_x?: Maybe<Order_By>;
  scale_y?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Raster_Columns_Sum_Fields = {
  __typename?: 'raster_columns_sum_fields';
  blocksize_x?: Maybe<Scalars['Int']>;
  blocksize_y?: Maybe<Scalars['Int']>;
  num_bands?: Maybe<Scalars['Int']>;
  scale_x?: Maybe<Scalars['float8']>;
  scale_y?: Maybe<Scalars['float8']>;
  srid?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "raster_columns" */
export type Raster_Columns_Sum_Order_By = {
  blocksize_x?: Maybe<Order_By>;
  blocksize_y?: Maybe<Order_By>;
  num_bands?: Maybe<Order_By>;
  scale_x?: Maybe<Order_By>;
  scale_y?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Raster_Columns_Var_Pop_Fields = {
  __typename?: 'raster_columns_var_pop_fields';
  blocksize_x?: Maybe<Scalars['Float']>;
  blocksize_y?: Maybe<Scalars['Float']>;
  num_bands?: Maybe<Scalars['Float']>;
  scale_x?: Maybe<Scalars['Float']>;
  scale_y?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "raster_columns" */
export type Raster_Columns_Var_Pop_Order_By = {
  blocksize_x?: Maybe<Order_By>;
  blocksize_y?: Maybe<Order_By>;
  num_bands?: Maybe<Order_By>;
  scale_x?: Maybe<Order_By>;
  scale_y?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Raster_Columns_Var_Samp_Fields = {
  __typename?: 'raster_columns_var_samp_fields';
  blocksize_x?: Maybe<Scalars['Float']>;
  blocksize_y?: Maybe<Scalars['Float']>;
  num_bands?: Maybe<Scalars['Float']>;
  scale_x?: Maybe<Scalars['Float']>;
  scale_y?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "raster_columns" */
export type Raster_Columns_Var_Samp_Order_By = {
  blocksize_x?: Maybe<Order_By>;
  blocksize_y?: Maybe<Order_By>;
  num_bands?: Maybe<Order_By>;
  scale_x?: Maybe<Order_By>;
  scale_y?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Raster_Columns_Variance_Fields = {
  __typename?: 'raster_columns_variance_fields';
  blocksize_x?: Maybe<Scalars['Float']>;
  blocksize_y?: Maybe<Scalars['Float']>;
  num_bands?: Maybe<Scalars['Float']>;
  scale_x?: Maybe<Scalars['Float']>;
  scale_y?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "raster_columns" */
export type Raster_Columns_Variance_Order_By = {
  blocksize_x?: Maybe<Order_By>;
  blocksize_y?: Maybe<Order_By>;
  num_bands?: Maybe<Order_By>;
  scale_x?: Maybe<Order_By>;
  scale_y?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** columns and relationships of "raster_overviews" */
export type Raster_Overviews = {
  __typename?: 'raster_overviews';
  o_raster_column?: Maybe<Scalars['name']>;
  o_table_catalog?: Maybe<Scalars['name']>;
  o_table_name?: Maybe<Scalars['name']>;
  o_table_schema?: Maybe<Scalars['name']>;
  overview_factor?: Maybe<Scalars['Int']>;
  r_raster_column?: Maybe<Scalars['name']>;
  r_table_catalog?: Maybe<Scalars['name']>;
  r_table_name?: Maybe<Scalars['name']>;
  r_table_schema?: Maybe<Scalars['name']>;
};

/** aggregated selection of "raster_overviews" */
export type Raster_Overviews_Aggregate = {
  __typename?: 'raster_overviews_aggregate';
  aggregate?: Maybe<Raster_Overviews_Aggregate_Fields>;
  nodes: Array<Raster_Overviews>;
};

/** aggregate fields of "raster_overviews" */
export type Raster_Overviews_Aggregate_Fields = {
  __typename?: 'raster_overviews_aggregate_fields';
  avg?: Maybe<Raster_Overviews_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Raster_Overviews_Max_Fields>;
  min?: Maybe<Raster_Overviews_Min_Fields>;
  stddev?: Maybe<Raster_Overviews_Stddev_Fields>;
  stddev_pop?: Maybe<Raster_Overviews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Raster_Overviews_Stddev_Samp_Fields>;
  sum?: Maybe<Raster_Overviews_Sum_Fields>;
  var_pop?: Maybe<Raster_Overviews_Var_Pop_Fields>;
  var_samp?: Maybe<Raster_Overviews_Var_Samp_Fields>;
  variance?: Maybe<Raster_Overviews_Variance_Fields>;
};


/** aggregate fields of "raster_overviews" */
export type Raster_Overviews_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Raster_Overviews_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "raster_overviews" */
export type Raster_Overviews_Aggregate_Order_By = {
  avg?: Maybe<Raster_Overviews_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Raster_Overviews_Max_Order_By>;
  min?: Maybe<Raster_Overviews_Min_Order_By>;
  stddev?: Maybe<Raster_Overviews_Stddev_Order_By>;
  stddev_pop?: Maybe<Raster_Overviews_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Raster_Overviews_Stddev_Samp_Order_By>;
  sum?: Maybe<Raster_Overviews_Sum_Order_By>;
  var_pop?: Maybe<Raster_Overviews_Var_Pop_Order_By>;
  var_samp?: Maybe<Raster_Overviews_Var_Samp_Order_By>;
  variance?: Maybe<Raster_Overviews_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Raster_Overviews_Avg_Fields = {
  __typename?: 'raster_overviews_avg_fields';
  overview_factor?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "raster_overviews" */
export type Raster_Overviews_Avg_Order_By = {
  overview_factor?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "raster_overviews". All fields are combined with a logical 'AND'. */
export type Raster_Overviews_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Raster_Overviews_Bool_Exp>>>;
  _not?: Maybe<Raster_Overviews_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Raster_Overviews_Bool_Exp>>>;
  o_raster_column?: Maybe<Name_Comparison_Exp>;
  o_table_catalog?: Maybe<Name_Comparison_Exp>;
  o_table_name?: Maybe<Name_Comparison_Exp>;
  o_table_schema?: Maybe<Name_Comparison_Exp>;
  overview_factor?: Maybe<Int_Comparison_Exp>;
  r_raster_column?: Maybe<Name_Comparison_Exp>;
  r_table_catalog?: Maybe<Name_Comparison_Exp>;
  r_table_name?: Maybe<Name_Comparison_Exp>;
  r_table_schema?: Maybe<Name_Comparison_Exp>;
};

/** aggregate max on columns */
export type Raster_Overviews_Max_Fields = {
  __typename?: 'raster_overviews_max_fields';
  overview_factor?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "raster_overviews" */
export type Raster_Overviews_Max_Order_By = {
  overview_factor?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Raster_Overviews_Min_Fields = {
  __typename?: 'raster_overviews_min_fields';
  overview_factor?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "raster_overviews" */
export type Raster_Overviews_Min_Order_By = {
  overview_factor?: Maybe<Order_By>;
};

/** ordering options when selecting data from "raster_overviews" */
export type Raster_Overviews_Order_By = {
  o_raster_column?: Maybe<Order_By>;
  o_table_catalog?: Maybe<Order_By>;
  o_table_name?: Maybe<Order_By>;
  o_table_schema?: Maybe<Order_By>;
  overview_factor?: Maybe<Order_By>;
  r_raster_column?: Maybe<Order_By>;
  r_table_catalog?: Maybe<Order_By>;
  r_table_name?: Maybe<Order_By>;
  r_table_schema?: Maybe<Order_By>;
};

/** select columns of table "raster_overviews" */
export enum Raster_Overviews_Select_Column {
  /** column name */
  ORasterColumn = 'o_raster_column',
  /** column name */
  OTableCatalog = 'o_table_catalog',
  /** column name */
  OTableName = 'o_table_name',
  /** column name */
  OTableSchema = 'o_table_schema',
  /** column name */
  OverviewFactor = 'overview_factor',
  /** column name */
  RRasterColumn = 'r_raster_column',
  /** column name */
  RTableCatalog = 'r_table_catalog',
  /** column name */
  RTableName = 'r_table_name',
  /** column name */
  RTableSchema = 'r_table_schema'
}

/** aggregate stddev on columns */
export type Raster_Overviews_Stddev_Fields = {
  __typename?: 'raster_overviews_stddev_fields';
  overview_factor?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "raster_overviews" */
export type Raster_Overviews_Stddev_Order_By = {
  overview_factor?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Raster_Overviews_Stddev_Pop_Fields = {
  __typename?: 'raster_overviews_stddev_pop_fields';
  overview_factor?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "raster_overviews" */
export type Raster_Overviews_Stddev_Pop_Order_By = {
  overview_factor?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Raster_Overviews_Stddev_Samp_Fields = {
  __typename?: 'raster_overviews_stddev_samp_fields';
  overview_factor?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "raster_overviews" */
export type Raster_Overviews_Stddev_Samp_Order_By = {
  overview_factor?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Raster_Overviews_Sum_Fields = {
  __typename?: 'raster_overviews_sum_fields';
  overview_factor?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "raster_overviews" */
export type Raster_Overviews_Sum_Order_By = {
  overview_factor?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Raster_Overviews_Var_Pop_Fields = {
  __typename?: 'raster_overviews_var_pop_fields';
  overview_factor?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "raster_overviews" */
export type Raster_Overviews_Var_Pop_Order_By = {
  overview_factor?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Raster_Overviews_Var_Samp_Fields = {
  __typename?: 'raster_overviews_var_samp_fields';
  overview_factor?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "raster_overviews" */
export type Raster_Overviews_Var_Samp_Order_By = {
  overview_factor?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Raster_Overviews_Variance_Fields = {
  __typename?: 'raster_overviews_variance_fields';
  overview_factor?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "raster_overviews" */
export type Raster_Overviews_Variance_Order_By = {
  overview_factor?: Maybe<Order_By>;
};

/** columns and relationships of "spatial_ref_sys" */
export type Spatial_Ref_Sys = {
  __typename?: 'spatial_ref_sys';
  auth_name?: Maybe<Scalars['String']>;
  auth_srid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid: Scalars['Int'];
  srtext?: Maybe<Scalars['String']>;
};

/** aggregated selection of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate = {
  __typename?: 'spatial_ref_sys_aggregate';
  aggregate?: Maybe<Spatial_Ref_Sys_Aggregate_Fields>;
  nodes: Array<Spatial_Ref_Sys>;
};

/** aggregate fields of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate_Fields = {
  __typename?: 'spatial_ref_sys_aggregate_fields';
  avg?: Maybe<Spatial_Ref_Sys_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Spatial_Ref_Sys_Max_Fields>;
  min?: Maybe<Spatial_Ref_Sys_Min_Fields>;
  stddev?: Maybe<Spatial_Ref_Sys_Stddev_Fields>;
  stddev_pop?: Maybe<Spatial_Ref_Sys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spatial_Ref_Sys_Stddev_Samp_Fields>;
  sum?: Maybe<Spatial_Ref_Sys_Sum_Fields>;
  var_pop?: Maybe<Spatial_Ref_Sys_Var_Pop_Fields>;
  var_samp?: Maybe<Spatial_Ref_Sys_Var_Samp_Fields>;
  variance?: Maybe<Spatial_Ref_Sys_Variance_Fields>;
};


/** aggregate fields of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Spatial_Ref_Sys_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate_Order_By = {
  avg?: Maybe<Spatial_Ref_Sys_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Spatial_Ref_Sys_Max_Order_By>;
  min?: Maybe<Spatial_Ref_Sys_Min_Order_By>;
  stddev?: Maybe<Spatial_Ref_Sys_Stddev_Order_By>;
  stddev_pop?: Maybe<Spatial_Ref_Sys_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Spatial_Ref_Sys_Stddev_Samp_Order_By>;
  sum?: Maybe<Spatial_Ref_Sys_Sum_Order_By>;
  var_pop?: Maybe<Spatial_Ref_Sys_Var_Pop_Order_By>;
  var_samp?: Maybe<Spatial_Ref_Sys_Var_Samp_Order_By>;
  variance?: Maybe<Spatial_Ref_Sys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Arr_Rel_Insert_Input = {
  data: Array<Spatial_Ref_Sys_Insert_Input>;
  on_conflict?: Maybe<Spatial_Ref_Sys_On_Conflict>;
};

/** aggregate avg on columns */
export type Spatial_Ref_Sys_Avg_Fields = {
  __typename?: 'spatial_ref_sys_avg_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Avg_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spatial_ref_sys". All fields are combined with a logical 'AND'. */
export type Spatial_Ref_Sys_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Spatial_Ref_Sys_Bool_Exp>>>;
  _not?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Spatial_Ref_Sys_Bool_Exp>>>;
  auth_name?: Maybe<String_Comparison_Exp>;
  auth_srid?: Maybe<Int_Comparison_Exp>;
  proj4text?: Maybe<String_Comparison_Exp>;
  srid?: Maybe<Int_Comparison_Exp>;
  srtext?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Constraint {
  /** unique or primary key constraint */
  SpatialRefSysPkey = 'spatial_ref_sys_pkey'
}

/** input type for incrementing integer column in table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Inc_Input = {
  auth_srid?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Insert_Input = {
  auth_name?: Maybe<Scalars['String']>;
  auth_srid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  srtext?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Spatial_Ref_Sys_Max_Fields = {
  __typename?: 'spatial_ref_sys_max_fields';
  auth_name?: Maybe<Scalars['String']>;
  auth_srid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  srtext?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Max_Order_By = {
  auth_name?: Maybe<Order_By>;
  auth_srid?: Maybe<Order_By>;
  proj4text?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  srtext?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Spatial_Ref_Sys_Min_Fields = {
  __typename?: 'spatial_ref_sys_min_fields';
  auth_name?: Maybe<Scalars['String']>;
  auth_srid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  srtext?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Min_Order_By = {
  auth_name?: Maybe<Order_By>;
  auth_srid?: Maybe<Order_By>;
  proj4text?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  srtext?: Maybe<Order_By>;
};

/** response of any mutation on the table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Mutation_Response = {
  __typename?: 'spatial_ref_sys_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Spatial_Ref_Sys>;
};

/** input type for inserting object relation for remote table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Obj_Rel_Insert_Input = {
  data: Spatial_Ref_Sys_Insert_Input;
  on_conflict?: Maybe<Spatial_Ref_Sys_On_Conflict>;
};

/** on conflict condition type for table "spatial_ref_sys" */
export type Spatial_Ref_Sys_On_Conflict = {
  constraint: Spatial_Ref_Sys_Constraint;
  update_columns: Array<Spatial_Ref_Sys_Update_Column>;
  where?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
};

/** ordering options when selecting data from "spatial_ref_sys" */
export type Spatial_Ref_Sys_Order_By = {
  auth_name?: Maybe<Order_By>;
  auth_srid?: Maybe<Order_By>;
  proj4text?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  srtext?: Maybe<Order_By>;
};

/** primary key columns input for table: "spatial_ref_sys" */
export type Spatial_Ref_Sys_Pk_Columns_Input = {
  srid: Scalars['Int'];
};

/** select columns of table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Select_Column {
  /** column name */
  AuthName = 'auth_name',
  /** column name */
  AuthSrid = 'auth_srid',
  /** column name */
  Proj4text = 'proj4text',
  /** column name */
  Srid = 'srid',
  /** column name */
  Srtext = 'srtext'
}

/** input type for updating data in table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Set_Input = {
  auth_name?: Maybe<Scalars['String']>;
  auth_srid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  srtext?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Spatial_Ref_Sys_Stddev_Fields = {
  __typename?: 'spatial_ref_sys_stddev_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Stddev_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spatial_Ref_Sys_Stddev_Pop_Fields = {
  __typename?: 'spatial_ref_sys_stddev_pop_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Stddev_Pop_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spatial_Ref_Sys_Stddev_Samp_Fields = {
  __typename?: 'spatial_ref_sys_stddev_samp_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Stddev_Samp_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Spatial_Ref_Sys_Sum_Fields = {
  __typename?: 'spatial_ref_sys_sum_fields';
  auth_srid?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Sum_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** update columns of table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Update_Column {
  /** column name */
  AuthName = 'auth_name',
  /** column name */
  AuthSrid = 'auth_srid',
  /** column name */
  Proj4text = 'proj4text',
  /** column name */
  Srid = 'srid',
  /** column name */
  Srtext = 'srtext'
}

/** aggregate var_pop on columns */
export type Spatial_Ref_Sys_Var_Pop_Fields = {
  __typename?: 'spatial_ref_sys_var_pop_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Var_Pop_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spatial_Ref_Sys_Var_Samp_Fields = {
  __typename?: 'spatial_ref_sys_var_samp_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Var_Samp_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Spatial_Ref_Sys_Variance_Fields = {
  __typename?: 'spatial_ref_sys_variance_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Variance_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: Maybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

/** expression to compare columns of type String. All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  _nlike?: Maybe<Scalars['String']>;
  _nsimilar?: Maybe<Scalars['String']>;
  _similar?: Maybe<Scalars['String']>;
};

/** subscription root */
export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "ads" */
  ads: Array<Ads>;
  /** fetch aggregated fields from the table: "ads" */
  ads_aggregate: Ads_Aggregate;
  /** fetch data from the table: "ads" using primary key columns */
  ads_by_pk?: Maybe<Ads>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "enum_language" */
  enum_language: Array<Enum_Language>;
  /** fetch aggregated fields from the table: "enum_language" */
  enum_language_aggregate: Enum_Language_Aggregate;
  /** fetch data from the table: "enum_language" using primary key columns */
  enum_language_by_pk?: Maybe<Enum_Language>;
  /** fetch data from the table: "enum_user_role" */
  enum_user_role: Array<Enum_User_Role>;
  /** fetch aggregated fields from the table: "enum_user_role" */
  enum_user_role_aggregate: Enum_User_Role_Aggregate;
  /** fetch data from the table: "enum_user_role" using primary key columns */
  enum_user_role_by_pk?: Maybe<Enum_User_Role>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk?: Maybe<File>;
  /** fetch data from the table: "file_storyblok" */
  file_storyblok: Array<File_Storyblok>;
  /** fetch aggregated fields from the table: "file_storyblok" */
  file_storyblok_aggregate: File_Storyblok_Aggregate;
  /** fetch data from the table: "file_storyblok" using primary key columns */
  file_storyblok_by_pk?: Maybe<File_Storyblok>;
  /** fetch data from the table: "geography_columns" */
  geography_columns: Array<Geography_Columns>;
  /** fetch aggregated fields from the table: "geography_columns" */
  geography_columns_aggregate: Geography_Columns_Aggregate;
  /** fetch data from the table: "geometry_columns" */
  geometry_columns: Array<Geometry_Columns>;
  /** fetch aggregated fields from the table: "geometry_columns" */
  geometry_columns_aggregate: Geometry_Columns_Aggregate;
  /** fetch data from the table: "job_category" */
  job_category: Array<Job_Category>;
  /** fetch aggregated fields from the table: "job_category" */
  job_category_aggregate: Job_Category_Aggregate;
  /** fetch data from the table: "job_category" using primary key columns */
  job_category_by_pk?: Maybe<Job_Category>;
  /** fetch data from the table: "mn_ads_job_category_sub" */
  mn_ads_job_category_sub: Array<Mn_Ads_Job_Category_Sub>;
  /** fetch aggregated fields from the table: "mn_ads_job_category_sub" */
  mn_ads_job_category_sub_aggregate: Mn_Ads_Job_Category_Sub_Aggregate;
  /** fetch data from the table: "mn_ads_job_category_sub" using primary key columns */
  mn_ads_job_category_sub_by_pk?: Maybe<Mn_Ads_Job_Category_Sub>;
  /** fetch data from the table: "raster_columns" */
  raster_columns: Array<Raster_Columns>;
  /** fetch aggregated fields from the table: "raster_columns" */
  raster_columns_aggregate: Raster_Columns_Aggregate;
  /** fetch data from the table: "raster_overviews" */
  raster_overviews: Array<Raster_Overviews>;
  /** fetch aggregated fields from the table: "raster_overviews" */
  raster_overviews_aggregate: Raster_Overviews_Aggregate;
  /** fetch data from the table: "spatial_ref_sys" */
  spatial_ref_sys: Array<Spatial_Ref_Sys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatial_ref_sys_aggregate: Spatial_Ref_Sys_Aggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "users_password_reset_token" */
  users_password_reset_token: Array<Users_Password_Reset_Token>;
  /** fetch aggregated fields from the table: "users_password_reset_token" */
  users_password_reset_token_aggregate: Users_Password_Reset_Token_Aggregate;
  /** fetch data from the table: "users_password_reset_token" using primary key columns */
  users_password_reset_token_by_pk?: Maybe<Users_Password_Reset_Token>;
  /** fetch data from the table: "users_resume_token" */
  users_resume_token: Array<Users_Resume_Token>;
  /** fetch aggregated fields from the table: "users_resume_token" */
  users_resume_token_aggregate: Users_Resume_Token_Aggregate;
  /** fetch data from the table: "users_resume_token" using primary key columns */
  users_resume_token_by_pk?: Maybe<Users_Resume_Token>;
};


/** subscription root */
export type Subscription_RootAdsArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAds_AggregateArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAds_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootCompanyArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCompany_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCompany_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootCountryArgs = {
  distinct_on?: Maybe<Array<Country_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Country_Order_By>>;
  where?: Maybe<Country_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCountry_AggregateArgs = {
  distinct_on?: Maybe<Array<Country_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Country_Order_By>>;
  where?: Maybe<Country_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCountry_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootEnum_LanguageArgs = {
  distinct_on?: Maybe<Array<Enum_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Language_Order_By>>;
  where?: Maybe<Enum_Language_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEnum_Language_AggregateArgs = {
  distinct_on?: Maybe<Array<Enum_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Language_Order_By>>;
  where?: Maybe<Enum_Language_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEnum_Language_By_PkArgs = {
  key: Scalars['String'];
};


/** subscription root */
export type Subscription_RootEnum_User_RoleArgs = {
  distinct_on?: Maybe<Array<Enum_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_User_Role_Order_By>>;
  where?: Maybe<Enum_User_Role_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEnum_User_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Enum_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_User_Role_Order_By>>;
  where?: Maybe<Enum_User_Role_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEnum_User_Role_By_PkArgs = {
  text: Scalars['String'];
};


/** subscription root */
export type Subscription_RootFileArgs = {
  distinct_on?: Maybe<Array<File_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Order_By>>;
  where?: Maybe<File_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFile_AggregateArgs = {
  distinct_on?: Maybe<Array<File_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Order_By>>;
  where?: Maybe<File_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFile_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootFile_StoryblokArgs = {
  distinct_on?: Maybe<Array<File_Storyblok_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Storyblok_Order_By>>;
  where?: Maybe<File_Storyblok_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFile_Storyblok_AggregateArgs = {
  distinct_on?: Maybe<Array<File_Storyblok_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Storyblok_Order_By>>;
  where?: Maybe<File_Storyblok_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFile_Storyblok_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootGeography_ColumnsArgs = {
  distinct_on?: Maybe<Array<Geography_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geography_Columns_Order_By>>;
  where?: Maybe<Geography_Columns_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGeography_Columns_AggregateArgs = {
  distinct_on?: Maybe<Array<Geography_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geography_Columns_Order_By>>;
  where?: Maybe<Geography_Columns_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGeometry_ColumnsArgs = {
  distinct_on?: Maybe<Array<Geometry_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geometry_Columns_Order_By>>;
  where?: Maybe<Geometry_Columns_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGeometry_Columns_AggregateArgs = {
  distinct_on?: Maybe<Array<Geometry_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geometry_Columns_Order_By>>;
  where?: Maybe<Geometry_Columns_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootJob_CategoryArgs = {
  distinct_on?: Maybe<Array<Job_Category_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Category_Order_By>>;
  where?: Maybe<Job_Category_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootJob_Category_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Category_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Category_Order_By>>;
  where?: Maybe<Job_Category_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootJob_Category_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootMn_Ads_Job_Category_SubArgs = {
  distinct_on?: Maybe<Array<Mn_Ads_Job_Category_Sub_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Mn_Ads_Job_Category_Sub_Order_By>>;
  where?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootMn_Ads_Job_Category_Sub_AggregateArgs = {
  distinct_on?: Maybe<Array<Mn_Ads_Job_Category_Sub_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Mn_Ads_Job_Category_Sub_Order_By>>;
  where?: Maybe<Mn_Ads_Job_Category_Sub_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootMn_Ads_Job_Category_Sub_By_PkArgs = {
  ads_id: Scalars['Int'];
  job_category_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootRaster_ColumnsArgs = {
  distinct_on?: Maybe<Array<Raster_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Raster_Columns_Order_By>>;
  where?: Maybe<Raster_Columns_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRaster_Columns_AggregateArgs = {
  distinct_on?: Maybe<Array<Raster_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Raster_Columns_Order_By>>;
  where?: Maybe<Raster_Columns_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRaster_OverviewsArgs = {
  distinct_on?: Maybe<Array<Raster_Overviews_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Raster_Overviews_Order_By>>;
  where?: Maybe<Raster_Overviews_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRaster_Overviews_AggregateArgs = {
  distinct_on?: Maybe<Array<Raster_Overviews_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Raster_Overviews_Order_By>>;
  where?: Maybe<Raster_Overviews_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSpatial_Ref_SysArgs = {
  distinct_on?: Maybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSpatial_Ref_Sys_AggregateArgs = {
  distinct_on?: Maybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSpatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootUsers_Password_Reset_TokenArgs = {
  distinct_on?: Maybe<Array<Users_Password_Reset_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Password_Reset_Token_Order_By>>;
  where?: Maybe<Users_Password_Reset_Token_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_Password_Reset_Token_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Password_Reset_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Password_Reset_Token_Order_By>>;
  where?: Maybe<Users_Password_Reset_Token_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_Password_Reset_Token_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootUsers_Resume_TokenArgs = {
  distinct_on?: Maybe<Array<Users_Resume_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Resume_Token_Order_By>>;
  where?: Maybe<Users_Resume_Token_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_Resume_Token_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Resume_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Resume_Token_Order_By>>;
  where?: Maybe<Users_Resume_Token_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_Resume_Token_By_PkArgs = {
  id: Scalars['uuid'];
};


/** expression to compare columns of type timestamp. All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
};


/** expression to compare columns of type timestamptz. All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** An array relationship */
  ads: Array<Ads>;
  /** An aggregated array relationship */
  ads_aggregate: Ads_Aggregate;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  /** An object relationship */
  enum_language: Enum_Language;
  /** An object relationship */
  enum_user_role: Enum_User_Role;
  first_name: Scalars['String'];
  graphcool_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  language_key: Enum_Language_Enum;
  last_name: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role: Enum_User_Role_Enum;
  street?: Maybe<Scalars['String']>;
  tax_nr?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  users_password_reset_tokens: Array<Users_Password_Reset_Token>;
  /** An aggregated array relationship */
  users_password_reset_tokens_aggregate: Users_Password_Reset_Token_Aggregate;
  /** An array relationship */
  users_resume_tokens: Array<Users_Resume_Token>;
  /** An aggregated array relationship */
  users_resume_tokens_aggregate: Users_Resume_Token_Aggregate;
  zip?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersAdsArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAds_AggregateArgs = {
  distinct_on?: Maybe<Array<Ads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ads_Order_By>>;
  where?: Maybe<Ads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Password_Reset_TokensArgs = {
  distinct_on?: Maybe<Array<Users_Password_Reset_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Password_Reset_Token_Order_By>>;
  where?: Maybe<Users_Password_Reset_Token_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Password_Reset_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Password_Reset_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Password_Reset_Token_Order_By>>;
  where?: Maybe<Users_Password_Reset_Token_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Resume_TokensArgs = {
  distinct_on?: Maybe<Array<Users_Resume_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Resume_Token_Order_By>>;
  where?: Maybe<Users_Resume_Token_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Resume_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Resume_Token_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Resume_Token_Order_By>>;
  where?: Maybe<Users_Resume_Token_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: Maybe<Users_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Users_Max_Order_By>;
  min?: Maybe<Users_Min_Order_By>;
  stddev?: Maybe<Users_Stddev_Order_By>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Order_By>;
  sum?: Maybe<Users_Sum_Order_By>;
  var_pop?: Maybe<Users_Var_Pop_Order_By>;
  var_samp?: Maybe<Users_Var_Samp_Order_By>;
  variance?: Maybe<Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Users_Bool_Exp>>>;
  _not?: Maybe<Users_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Users_Bool_Exp>>>;
  ads?: Maybe<Ads_Bool_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  company?: Maybe<String_Comparison_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  enum_language?: Maybe<Enum_Language_Bool_Exp>;
  enum_user_role?: Maybe<Enum_User_Role_Bool_Exp>;
  first_name?: Maybe<String_Comparison_Exp>;
  graphcool_id?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  language_key?: Maybe<Enum_Language_Enum_Comparison_Exp>;
  last_name?: Maybe<String_Comparison_Exp>;
  password?: Maybe<String_Comparison_Exp>;
  phone?: Maybe<String_Comparison_Exp>;
  role?: Maybe<Enum_User_Role_Enum_Comparison_Exp>;
  street?: Maybe<String_Comparison_Exp>;
  tax_nr?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  users_password_reset_tokens?: Maybe<Users_Password_Reset_Token_Bool_Exp>;
  users_resume_tokens?: Maybe<Users_Resume_Token_Bool_Exp>;
  zip?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint */
  UsersGraphcoolIdKey = 'users_graphcool_id_key',
  /** unique or primary key constraint */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing integer column in table "users" */
export type Users_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  ads?: Maybe<Ads_Arr_Rel_Insert_Input>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  enum_language?: Maybe<Enum_Language_Obj_Rel_Insert_Input>;
  enum_user_role?: Maybe<Enum_User_Role_Obj_Rel_Insert_Input>;
  first_name?: Maybe<Scalars['String']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  language_key?: Maybe<Enum_Language_Enum>;
  last_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Enum_User_Role_Enum>;
  street?: Maybe<Scalars['String']>;
  tax_nr?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  users_password_reset_tokens?: Maybe<Users_Password_Reset_Token_Arr_Rel_Insert_Input>;
  users_resume_tokens?: Maybe<Users_Resume_Token_Arr_Rel_Insert_Input>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  tax_nr?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  city?: Maybe<Order_By>;
  company?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  password?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  street?: Maybe<Order_By>;
  tax_nr?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  zip?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  tax_nr?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  city?: Maybe<Order_By>;
  company?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  password?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  street?: Maybe<Order_By>;
  tax_nr?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  zip?: Maybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** on conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns: Array<Users_Update_Column>;
  where?: Maybe<Users_Bool_Exp>;
};

/** ordering options when selecting data from "users" */
export type Users_Order_By = {
  ads_aggregate?: Maybe<Ads_Aggregate_Order_By>;
  city?: Maybe<Order_By>;
  company?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  enum_language?: Maybe<Enum_Language_Order_By>;
  enum_user_role?: Maybe<Enum_User_Role_Order_By>;
  first_name?: Maybe<Order_By>;
  graphcool_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  language_key?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  password?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  street?: Maybe<Order_By>;
  tax_nr?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  users_password_reset_tokens_aggregate?: Maybe<Users_Password_Reset_Token_Aggregate_Order_By>;
  users_resume_tokens_aggregate?: Maybe<Users_Resume_Token_Aggregate_Order_By>;
  zip?: Maybe<Order_By>;
};

/** columns and relationships of "users_password_reset_token" */
export type Users_Password_Reset_Token = {
  __typename?: 'users_password_reset_token';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  token: Scalars['String'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};

/** aggregated selection of "users_password_reset_token" */
export type Users_Password_Reset_Token_Aggregate = {
  __typename?: 'users_password_reset_token_aggregate';
  aggregate?: Maybe<Users_Password_Reset_Token_Aggregate_Fields>;
  nodes: Array<Users_Password_Reset_Token>;
};

/** aggregate fields of "users_password_reset_token" */
export type Users_Password_Reset_Token_Aggregate_Fields = {
  __typename?: 'users_password_reset_token_aggregate_fields';
  avg?: Maybe<Users_Password_Reset_Token_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Users_Password_Reset_Token_Max_Fields>;
  min?: Maybe<Users_Password_Reset_Token_Min_Fields>;
  stddev?: Maybe<Users_Password_Reset_Token_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Password_Reset_Token_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Password_Reset_Token_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Password_Reset_Token_Sum_Fields>;
  var_pop?: Maybe<Users_Password_Reset_Token_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Password_Reset_Token_Var_Samp_Fields>;
  variance?: Maybe<Users_Password_Reset_Token_Variance_Fields>;
};


/** aggregate fields of "users_password_reset_token" */
export type Users_Password_Reset_Token_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Users_Password_Reset_Token_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users_password_reset_token" */
export type Users_Password_Reset_Token_Aggregate_Order_By = {
  avg?: Maybe<Users_Password_Reset_Token_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Users_Password_Reset_Token_Max_Order_By>;
  min?: Maybe<Users_Password_Reset_Token_Min_Order_By>;
  stddev?: Maybe<Users_Password_Reset_Token_Stddev_Order_By>;
  stddev_pop?: Maybe<Users_Password_Reset_Token_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Users_Password_Reset_Token_Stddev_Samp_Order_By>;
  sum?: Maybe<Users_Password_Reset_Token_Sum_Order_By>;
  var_pop?: Maybe<Users_Password_Reset_Token_Var_Pop_Order_By>;
  var_samp?: Maybe<Users_Password_Reset_Token_Var_Samp_Order_By>;
  variance?: Maybe<Users_Password_Reset_Token_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users_password_reset_token" */
export type Users_Password_Reset_Token_Arr_Rel_Insert_Input = {
  data: Array<Users_Password_Reset_Token_Insert_Input>;
  on_conflict?: Maybe<Users_Password_Reset_Token_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Password_Reset_Token_Avg_Fields = {
  __typename?: 'users_password_reset_token_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users_password_reset_token" */
export type Users_Password_Reset_Token_Avg_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_password_reset_token". All fields are combined with a logical 'AND'. */
export type Users_Password_Reset_Token_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Users_Password_Reset_Token_Bool_Exp>>>;
  _not?: Maybe<Users_Password_Reset_Token_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Users_Password_Reset_Token_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  token?: Maybe<String_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "users_password_reset_token" */
export enum Users_Password_Reset_Token_Constraint {
  /** unique or primary key constraint */
  UsersPasswordResetTokenPkey = 'users_password_reset_token_pkey'
}

/** input type for incrementing integer column in table "users_password_reset_token" */
export type Users_Password_Reset_Token_Inc_Input = {
  user_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "users_password_reset_token" */
export type Users_Password_Reset_Token_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Users_Password_Reset_Token_Max_Fields = {
  __typename?: 'users_password_reset_token_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "users_password_reset_token" */
export type Users_Password_Reset_Token_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Password_Reset_Token_Min_Fields = {
  __typename?: 'users_password_reset_token_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "users_password_reset_token" */
export type Users_Password_Reset_Token_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "users_password_reset_token" */
export type Users_Password_Reset_Token_Mutation_Response = {
  __typename?: 'users_password_reset_token_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Users_Password_Reset_Token>;
};

/** input type for inserting object relation for remote table "users_password_reset_token" */
export type Users_Password_Reset_Token_Obj_Rel_Insert_Input = {
  data: Users_Password_Reset_Token_Insert_Input;
  on_conflict?: Maybe<Users_Password_Reset_Token_On_Conflict>;
};

/** on conflict condition type for table "users_password_reset_token" */
export type Users_Password_Reset_Token_On_Conflict = {
  constraint: Users_Password_Reset_Token_Constraint;
  update_columns: Array<Users_Password_Reset_Token_Update_Column>;
  where?: Maybe<Users_Password_Reset_Token_Bool_Exp>;
};

/** ordering options when selecting data from "users_password_reset_token" */
export type Users_Password_Reset_Token_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "users_password_reset_token" */
export type Users_Password_Reset_Token_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "users_password_reset_token" */
export enum Users_Password_Reset_Token_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "users_password_reset_token" */
export type Users_Password_Reset_Token_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Users_Password_Reset_Token_Stddev_Fields = {
  __typename?: 'users_password_reset_token_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users_password_reset_token" */
export type Users_Password_Reset_Token_Stddev_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Password_Reset_Token_Stddev_Pop_Fields = {
  __typename?: 'users_password_reset_token_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users_password_reset_token" */
export type Users_Password_Reset_Token_Stddev_Pop_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Password_Reset_Token_Stddev_Samp_Fields = {
  __typename?: 'users_password_reset_token_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users_password_reset_token" */
export type Users_Password_Reset_Token_Stddev_Samp_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Users_Password_Reset_Token_Sum_Fields = {
  __typename?: 'users_password_reset_token_sum_fields';
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "users_password_reset_token" */
export type Users_Password_Reset_Token_Sum_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** update columns of table "users_password_reset_token" */
export enum Users_Password_Reset_Token_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Users_Password_Reset_Token_Var_Pop_Fields = {
  __typename?: 'users_password_reset_token_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users_password_reset_token" */
export type Users_Password_Reset_Token_Var_Pop_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Password_Reset_Token_Var_Samp_Fields = {
  __typename?: 'users_password_reset_token_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users_password_reset_token" */
export type Users_Password_Reset_Token_Var_Samp_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Password_Reset_Token_Variance_Fields = {
  __typename?: 'users_password_reset_token_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users_password_reset_token" */
export type Users_Password_Reset_Token_Variance_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "users" */
export type Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "users_resume_token" */
export type Users_Resume_Token = {
  __typename?: 'users_resume_token';
  created_at: Scalars['timestamptz'];
  expired_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};

/** aggregated selection of "users_resume_token" */
export type Users_Resume_Token_Aggregate = {
  __typename?: 'users_resume_token_aggregate';
  aggregate?: Maybe<Users_Resume_Token_Aggregate_Fields>;
  nodes: Array<Users_Resume_Token>;
};

/** aggregate fields of "users_resume_token" */
export type Users_Resume_Token_Aggregate_Fields = {
  __typename?: 'users_resume_token_aggregate_fields';
  avg?: Maybe<Users_Resume_Token_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Users_Resume_Token_Max_Fields>;
  min?: Maybe<Users_Resume_Token_Min_Fields>;
  stddev?: Maybe<Users_Resume_Token_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Resume_Token_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Resume_Token_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Resume_Token_Sum_Fields>;
  var_pop?: Maybe<Users_Resume_Token_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Resume_Token_Var_Samp_Fields>;
  variance?: Maybe<Users_Resume_Token_Variance_Fields>;
};


/** aggregate fields of "users_resume_token" */
export type Users_Resume_Token_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Users_Resume_Token_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users_resume_token" */
export type Users_Resume_Token_Aggregate_Order_By = {
  avg?: Maybe<Users_Resume_Token_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Users_Resume_Token_Max_Order_By>;
  min?: Maybe<Users_Resume_Token_Min_Order_By>;
  stddev?: Maybe<Users_Resume_Token_Stddev_Order_By>;
  stddev_pop?: Maybe<Users_Resume_Token_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Users_Resume_Token_Stddev_Samp_Order_By>;
  sum?: Maybe<Users_Resume_Token_Sum_Order_By>;
  var_pop?: Maybe<Users_Resume_Token_Var_Pop_Order_By>;
  var_samp?: Maybe<Users_Resume_Token_Var_Samp_Order_By>;
  variance?: Maybe<Users_Resume_Token_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users_resume_token" */
export type Users_Resume_Token_Arr_Rel_Insert_Input = {
  data: Array<Users_Resume_Token_Insert_Input>;
  on_conflict?: Maybe<Users_Resume_Token_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Resume_Token_Avg_Fields = {
  __typename?: 'users_resume_token_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users_resume_token" */
export type Users_Resume_Token_Avg_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_resume_token". All fields are combined with a logical 'AND'. */
export type Users_Resume_Token_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Users_Resume_Token_Bool_Exp>>>;
  _not?: Maybe<Users_Resume_Token_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Users_Resume_Token_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  expired_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "users_resume_token" */
export enum Users_Resume_Token_Constraint {
  /** unique or primary key constraint */
  UsersResumeTokenPkey = 'users_resume_token_pkey'
}

/** input type for incrementing integer column in table "users_resume_token" */
export type Users_Resume_Token_Inc_Input = {
  user_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "users_resume_token" */
export type Users_Resume_Token_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expired_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Users_Resume_Token_Max_Fields = {
  __typename?: 'users_resume_token_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expired_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "users_resume_token" */
export type Users_Resume_Token_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  expired_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Resume_Token_Min_Fields = {
  __typename?: 'users_resume_token_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expired_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "users_resume_token" */
export type Users_Resume_Token_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  expired_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "users_resume_token" */
export type Users_Resume_Token_Mutation_Response = {
  __typename?: 'users_resume_token_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Users_Resume_Token>;
};

/** input type for inserting object relation for remote table "users_resume_token" */
export type Users_Resume_Token_Obj_Rel_Insert_Input = {
  data: Users_Resume_Token_Insert_Input;
  on_conflict?: Maybe<Users_Resume_Token_On_Conflict>;
};

/** on conflict condition type for table "users_resume_token" */
export type Users_Resume_Token_On_Conflict = {
  constraint: Users_Resume_Token_Constraint;
  update_columns: Array<Users_Resume_Token_Update_Column>;
  where?: Maybe<Users_Resume_Token_Bool_Exp>;
};

/** ordering options when selecting data from "users_resume_token" */
export type Users_Resume_Token_Order_By = {
  created_at?: Maybe<Order_By>;
  expired_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "users_resume_token" */
export type Users_Resume_Token_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "users_resume_token" */
export enum Users_Resume_Token_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiredAt = 'expired_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "users_resume_token" */
export type Users_Resume_Token_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expired_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Users_Resume_Token_Stddev_Fields = {
  __typename?: 'users_resume_token_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users_resume_token" */
export type Users_Resume_Token_Stddev_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Resume_Token_Stddev_Pop_Fields = {
  __typename?: 'users_resume_token_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users_resume_token" */
export type Users_Resume_Token_Stddev_Pop_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Resume_Token_Stddev_Samp_Fields = {
  __typename?: 'users_resume_token_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users_resume_token" */
export type Users_Resume_Token_Stddev_Samp_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Users_Resume_Token_Sum_Fields = {
  __typename?: 'users_resume_token_sum_fields';
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "users_resume_token" */
export type Users_Resume_Token_Sum_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** update columns of table "users_resume_token" */
export enum Users_Resume_Token_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiredAt = 'expired_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Users_Resume_Token_Var_Pop_Fields = {
  __typename?: 'users_resume_token_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users_resume_token" */
export type Users_Resume_Token_Var_Pop_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Resume_Token_Var_Samp_Fields = {
  __typename?: 'users_resume_token_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users_resume_token" */
export type Users_Resume_Token_Var_Samp_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Resume_Token_Variance_Fields = {
  __typename?: 'users_resume_token_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users_resume_token" */
export type Users_Resume_Token_Variance_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Company = 'company',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Id = 'id',
  /** column name */
  LanguageKey = 'language_key',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Password = 'password',
  /** column name */
  Phone = 'phone',
  /** column name */
  Role = 'role',
  /** column name */
  Street = 'street',
  /** column name */
  TaxNr = 'tax_nr',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  graphcool_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  language_key?: Maybe<Enum_Language_Enum>;
  last_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Enum_User_Role_Enum>;
  street?: Maybe<Scalars['String']>;
  tax_nr?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  Company = 'company',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  GraphcoolId = 'graphcool_id',
  /** column name */
  Id = 'id',
  /** column name */
  LanguageKey = 'language_key',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Password = 'password',
  /** column name */
  Phone = 'phone',
  /** column name */
  Role = 'role',
  /** column name */
  Street = 'street',
  /** column name */
  TaxNr = 'tax_nr',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zip = 'zip'
}

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  id?: Maybe<Order_By>;
};


/** expression to compare columns of type uuid. All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

export type Ad_By_PkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Ad_By_PkQuery = (
  { __typename?: 'query_root' }
  & { ads_by_pk?: Maybe<(
    { __typename?: 'ads' }
    & Pick<Ads, 'ad_description_company' | 'ad_description_qualifications' | 'ad_description_tasks' | 'color_1' | 'color_2' | 'color_3' | 'color_4' | 'color_5' | 'company_name' | 'company_staff_count' | 'company_url' | 'contact_city' | 'contact_country_id' | 'contact_email' | 'contact_fax' | 'contact_first_name' | 'contact_last_name' | 'contact_phone' | 'contact_street_and_nr' | 'contact_title' | 'contact_us_here_url' | 'contact_zip' | 'created_at' | 'created_by_user_id' | 'deleted' | 'graphcool_id' | 'hidden' | 'id' | 'is_advanced' | 'job_category_id' | 'job_city' | 'job_country' | 'job_duration' | 'job_geo_lang' | 'job_geo_lat' | 'job_house_nr' | 'job_payment' | 'job_region' | 'job_start_date' | 'job_street' | 'job_title' | 'job_type_id' | 'job_zip' | 'location' | 'meta_title' | 'offer_upload_id' | 'company_logo_file_id' | 'pdf_only' | 'published' | 'published_at' | 'slug' | 'updated_at'>
    & { job_category?: Maybe<(
      { __typename?: 'job_category' }
      & Pick<Job_Category, 'id'>
    )>, mn_ads_job_category_subs: Array<(
      { __typename?: 'mn_ads_job_category_sub' }
      & Pick<Mn_Ads_Job_Category_Sub, 'ads_id' | 'job_category_id'>
    )>, file_storyblok?: Maybe<(
      { __typename?: 'file_storyblok' }
      & Pick<File_Storyblok, 'url' | 'id' | 'name' | 'storyblok_id'>
    )>, user?: Maybe<(
      { __typename?: 'users' }
      & Pick<Users, 'id'>
    )>, file?: Maybe<(
      { __typename?: 'file' }
      & Pick<File, 'name'>
    )> }
  )> }
);

export type All_AdsQueryVariables = Exact<{ [key: string]: never; }>;


export type All_AdsQuery = (
  { __typename?: 'query_root' }
  & { ads: Array<(
    { __typename?: 'ads' }
    & Pick<Ads, 'id' | 'company_name' | 'location' | 'job_title' | 'meta_title' | 'published' | 'hidden' | 'deleted'>
  )> }
);

export type Insert_Ads_OneMutationVariables = Exact<{
  object: Ads_Insert_Input;
}>;


export type Insert_Ads_OneMutation = (
  { __typename?: 'mutation_root' }
  & { insert_ads_one?: Maybe<(
    { __typename?: 'ads' }
    & Pick<Ads, 'id' | 'offer_upload_id' | 'company_logo_file_id'>
  )> }
);

export type Update_AdMutationVariables = Exact<{
  id: Scalars['Int'];
  set: Ads_Insert_Input;
}>;


export type Update_AdMutation = (
  { __typename?: 'mutation_root' }
  & { delete_mn_ads_job_category_sub?: Maybe<(
    { __typename?: 'mn_ads_job_category_sub_mutation_response' }
    & Pick<Mn_Ads_Job_Category_Sub_Mutation_Response, 'affected_rows'>
  )>, insert_ads?: Maybe<(
    { __typename?: 'ads_mutation_response' }
    & { returning: Array<(
      { __typename?: 'ads' }
      & Pick<Ads, 'id'>
    )> }
  )> }
);

export type Update_Ad_By_PkMutationVariables = Exact<{
  id: Scalars['Int'];
  set: Ads_Set_Input;
}>;


export type Update_Ad_By_PkMutation = (
  { __typename?: 'mutation_root' }
  & { update_ads_by_pk?: Maybe<(
    { __typename?: 'ads' }
    & Pick<Ads, 'id'>
  )> }
);

export type Update_AdsMutationVariables = Exact<{
  ids: Array<Scalars['Int']>;
  set?: Maybe<Ads_Set_Input>;
}>;


export type Update_AdsMutation = (
  { __typename?: 'mutation_root' }
  & { update_ads?: Maybe<(
    { __typename?: 'ads_mutation_response' }
    & Pick<Ads_Mutation_Response, 'affected_rows'>
  )> }
);

export type All_CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type All_CountriesQuery = (
  { __typename?: 'query_root' }
  & { country: Array<(
    { __typename?: 'country' }
    & Pick<Country, 'id' | 'name'>
  )> }
);

export type Insert_FileMutationVariables = Exact<{
  object: File_Insert_Input;
}>;


export type Insert_FileMutation = (
  { __typename?: 'mutation_root' }
  & { insert_file_one?: Maybe<(
    { __typename?: 'file' }
    & Pick<File, 'id'>
  )> }
);

export type Delete_FileMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Delete_FileMutation = (
  { __typename?: 'mutation_root' }
  & { delete_file_by_pk?: Maybe<(
    { __typename?: 'file' }
    & Pick<File, 'id'>
  )> }
);

export type Delete_File_StoryblokMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Delete_File_StoryblokMutation = (
  { __typename?: 'mutation_root' }
  & { delete_file_storyblok_by_pk?: Maybe<(
    { __typename?: 'file_storyblok' }
    & Pick<File_Storyblok, 'id'>
  )> }
);

export type All_Job_CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type All_Job_CategoriesQuery = (
  { __typename?: 'query_root' }
  & { job_category: Array<(
    { __typename?: 'job_category' }
    & Pick<Job_Category, 'id' | 'name'>
  )> }
);

export type All_Job_TypesQueryVariables = Exact<{ [key: string]: never; }>;


export type All_Job_TypesQuery = (
  { __typename?: 'query_root' }
  & { job_category: Array<(
    { __typename?: 'job_category' }
    & Pick<Job_Category, 'id' | 'name'>
  )> }
);

export type All_Job_Sub_CategoriesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type All_Job_Sub_CategoriesQuery = (
  { __typename?: 'query_root' }
  & { job_category: Array<(
    { __typename?: 'job_category' }
    & Pick<Job_Category, 'id' | 'name'>
  )> }
);

export type Update_UserMutationVariables = Exact<{
  id: Scalars['Int'];
  _set?: Maybe<Users_Set_Input>;
}>;


export type Update_UserMutation = (
  { __typename?: 'mutation_root' }
  & { update_users_by_pk?: Maybe<(
    { __typename?: 'users' }
    & Pick<Users, 'id'>
  )> }
);

export type User_QueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type User_QueryQuery = (
  { __typename?: 'query_root' }
  & { users: Array<(
    { __typename?: 'users' }
    & Pick<Users, 'id' | 'email' | 'first_name' | 'last_name' | 'role'>
  )> }
);

export type User_By_PkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type User_By_PkQuery = (
  { __typename?: 'query_root' }
  & { users_by_pk?: Maybe<(
    { __typename?: 'users' }
    & Pick<Users, 'id' | 'first_name' | 'last_name' | 'email'>
  )> }
);


export const Ad_By_PkDocument = gql`
    query AD_BY_PK($id: Int!) {
  ads_by_pk(id: $id) {
    ad_description_company
    ad_description_qualifications
    ad_description_tasks
    color_1
    color_2
    color_3
    color_4
    color_5
    company_name
    company_staff_count
    company_url
    contact_city
    contact_country_id
    contact_email
    contact_fax
    contact_first_name
    contact_last_name
    contact_phone
    contact_street_and_nr
    contact_title
    contact_us_here_url
    contact_zip
    created_at
    created_by_user_id
    deleted
    graphcool_id
    hidden
    id
    is_advanced
    job_category {
      id
    }
    job_category_id
    job_city
    job_country
    job_duration
    job_geo_lang
    job_geo_lat
    job_house_nr
    job_payment
    job_region
    job_start_date
    job_street
    job_title
    job_type_id
    job_zip
    location
    meta_title
    mn_ads_job_category_subs {
      ads_id
      job_category_id
    }
    offer_upload_id
    company_logo_file_id
    file_storyblok {
      url
      id
      name
      storyblok_id
    }
    pdf_only
    published
    published_at
    slug
    updated_at
    user {
      id
    }
    file {
      name
    }
  }
}
    `;

/**
 * __useAd_By_PkQuery__
 *
 * To run a query within a React component, call `useAd_By_PkQuery` and pass it any options that fit your needs.
 * When your component renders, `useAd_By_PkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAd_By_PkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAd_By_PkQuery(baseOptions?: Apollo.QueryHookOptions<Ad_By_PkQuery, Ad_By_PkQueryVariables>) {
        return Apollo.useQuery<Ad_By_PkQuery, Ad_By_PkQueryVariables>(Ad_By_PkDocument, baseOptions);
      }
export function useAd_By_PkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Ad_By_PkQuery, Ad_By_PkQueryVariables>) {
          return Apollo.useLazyQuery<Ad_By_PkQuery, Ad_By_PkQueryVariables>(Ad_By_PkDocument, baseOptions);
        }
export type Ad_By_PkQueryHookResult = ReturnType<typeof useAd_By_PkQuery>;
export type Ad_By_PkLazyQueryHookResult = ReturnType<typeof useAd_By_PkLazyQuery>;
export type Ad_By_PkQueryResult = Apollo.QueryResult<Ad_By_PkQuery, Ad_By_PkQueryVariables>;
export const All_AdsDocument = gql`
    query ALL_ADS {
  ads(where: {deleted: {_eq: false}}) {
    id
    company_name
    location
    job_title
    meta_title
    published
    hidden
    deleted
    company_name
  }
}
    `;

/**
 * __useAll_AdsQuery__
 *
 * To run a query within a React component, call `useAll_AdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAll_AdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAll_AdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAll_AdsQuery(baseOptions?: Apollo.QueryHookOptions<All_AdsQuery, All_AdsQueryVariables>) {
        return Apollo.useQuery<All_AdsQuery, All_AdsQueryVariables>(All_AdsDocument, baseOptions);
      }
export function useAll_AdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<All_AdsQuery, All_AdsQueryVariables>) {
          return Apollo.useLazyQuery<All_AdsQuery, All_AdsQueryVariables>(All_AdsDocument, baseOptions);
        }
export type All_AdsQueryHookResult = ReturnType<typeof useAll_AdsQuery>;
export type All_AdsLazyQueryHookResult = ReturnType<typeof useAll_AdsLazyQuery>;
export type All_AdsQueryResult = Apollo.QueryResult<All_AdsQuery, All_AdsQueryVariables>;
export const Insert_Ads_OneDocument = gql`
    mutation INSERT_ADS_ONE($object: ads_insert_input!) {
  insert_ads_one(object: $object, on_conflict: {constraint: ads_pkey, update_columns: [id, slug, company_logo_file_id, offer_upload_id, created_by_user_id]}) {
    id
    offer_upload_id
    company_logo_file_id
  }
}
    `;
export type Insert_Ads_OneMutationFn = Apollo.MutationFunction<Insert_Ads_OneMutation, Insert_Ads_OneMutationVariables>;

/**
 * __useInsert_Ads_OneMutation__
 *
 * To run a mutation, you first call `useInsert_Ads_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Ads_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAdsOneMutation, { data, loading, error }] = useInsert_Ads_OneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Ads_OneMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Ads_OneMutation, Insert_Ads_OneMutationVariables>) {
        return Apollo.useMutation<Insert_Ads_OneMutation, Insert_Ads_OneMutationVariables>(Insert_Ads_OneDocument, baseOptions);
      }
export type Insert_Ads_OneMutationHookResult = ReturnType<typeof useInsert_Ads_OneMutation>;
export type Insert_Ads_OneMutationResult = Apollo.MutationResult<Insert_Ads_OneMutation>;
export type Insert_Ads_OneMutationOptions = Apollo.BaseMutationOptions<Insert_Ads_OneMutation, Insert_Ads_OneMutationVariables>;
export const Update_AdDocument = gql`
    mutation UPDATE_AD($id: Int!, $set: ads_insert_input!) {
  delete_mn_ads_job_category_sub(where: {ads_id: {_eq: $id}}) {
    affected_rows
  }
  insert_ads(objects: [$set], on_conflict: {constraint: ads_pkey, update_columns: [ad_description_company, ad_description_qualifications, ad_description_tasks, color_1, color_2, color_3, color_4, color_5, company_logo_file_id, company_name, company_staff_count, company_url, contact_city, contact_country_id, contact_email, contact_fax, contact_first_name, contact_last_name, contact_phone, contact_street_and_nr, contact_title, contact_us_here_url, contact_zip, created_at, created_by_user_id, deleted, graphcool_id, hidden, id, is_advanced, job_category_id, job_city, job_country, job_duration, job_geo_lang, job_geo_lat, job_house_nr, job_payment, job_region, job_start_date, job_street, job_title, job_type_id, job_zip, location, meta_title, offer_upload_id, pdf_only, published, published_at, slug, updated_at]}) {
    returning {
      id
    }
  }
}
    `;
export type Update_AdMutationFn = Apollo.MutationFunction<Update_AdMutation, Update_AdMutationVariables>;

/**
 * __useUpdate_AdMutation__
 *
 * To run a mutation, you first call `useUpdate_AdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_AdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdMutation, { data, loading, error }] = useUpdate_AdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdate_AdMutation(baseOptions?: Apollo.MutationHookOptions<Update_AdMutation, Update_AdMutationVariables>) {
        return Apollo.useMutation<Update_AdMutation, Update_AdMutationVariables>(Update_AdDocument, baseOptions);
      }
export type Update_AdMutationHookResult = ReturnType<typeof useUpdate_AdMutation>;
export type Update_AdMutationResult = Apollo.MutationResult<Update_AdMutation>;
export type Update_AdMutationOptions = Apollo.BaseMutationOptions<Update_AdMutation, Update_AdMutationVariables>;
export const Update_Ad_By_PkDocument = gql`
    mutation UPDATE_AD_BY_PK($id: Int!, $set: ads_set_input!) {
  update_ads_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;
export type Update_Ad_By_PkMutationFn = Apollo.MutationFunction<Update_Ad_By_PkMutation, Update_Ad_By_PkMutationVariables>;

/**
 * __useUpdate_Ad_By_PkMutation__
 *
 * To run a mutation, you first call `useUpdate_Ad_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Ad_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdByPkMutation, { data, loading, error }] = useUpdate_Ad_By_PkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdate_Ad_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Update_Ad_By_PkMutation, Update_Ad_By_PkMutationVariables>) {
        return Apollo.useMutation<Update_Ad_By_PkMutation, Update_Ad_By_PkMutationVariables>(Update_Ad_By_PkDocument, baseOptions);
      }
export type Update_Ad_By_PkMutationHookResult = ReturnType<typeof useUpdate_Ad_By_PkMutation>;
export type Update_Ad_By_PkMutationResult = Apollo.MutationResult<Update_Ad_By_PkMutation>;
export type Update_Ad_By_PkMutationOptions = Apollo.BaseMutationOptions<Update_Ad_By_PkMutation, Update_Ad_By_PkMutationVariables>;
export const Update_AdsDocument = gql`
    mutation UPDATE_ADS($ids: [Int!]!, $set: ads_set_input) {
  update_ads(where: {id: {_in: $ids}}, _set: $set) {
    affected_rows
  }
}
    `;
export type Update_AdsMutationFn = Apollo.MutationFunction<Update_AdsMutation, Update_AdsMutationVariables>;

/**
 * __useUpdate_AdsMutation__
 *
 * To run a mutation, you first call `useUpdate_AdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_AdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdsMutation, { data, loading, error }] = useUpdate_AdsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdate_AdsMutation(baseOptions?: Apollo.MutationHookOptions<Update_AdsMutation, Update_AdsMutationVariables>) {
        return Apollo.useMutation<Update_AdsMutation, Update_AdsMutationVariables>(Update_AdsDocument, baseOptions);
      }
export type Update_AdsMutationHookResult = ReturnType<typeof useUpdate_AdsMutation>;
export type Update_AdsMutationResult = Apollo.MutationResult<Update_AdsMutation>;
export type Update_AdsMutationOptions = Apollo.BaseMutationOptions<Update_AdsMutation, Update_AdsMutationVariables>;
export const All_CountriesDocument = gql`
    query ALL_COUNTRIES {
  country(order_by: [{sorting: asc}]) {
    id
    name
  }
}
    `;

/**
 * __useAll_CountriesQuery__
 *
 * To run a query within a React component, call `useAll_CountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAll_CountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAll_CountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAll_CountriesQuery(baseOptions?: Apollo.QueryHookOptions<All_CountriesQuery, All_CountriesQueryVariables>) {
        return Apollo.useQuery<All_CountriesQuery, All_CountriesQueryVariables>(All_CountriesDocument, baseOptions);
      }
export function useAll_CountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<All_CountriesQuery, All_CountriesQueryVariables>) {
          return Apollo.useLazyQuery<All_CountriesQuery, All_CountriesQueryVariables>(All_CountriesDocument, baseOptions);
        }
export type All_CountriesQueryHookResult = ReturnType<typeof useAll_CountriesQuery>;
export type All_CountriesLazyQueryHookResult = ReturnType<typeof useAll_CountriesLazyQuery>;
export type All_CountriesQueryResult = Apollo.QueryResult<All_CountriesQuery, All_CountriesQueryVariables>;
export const Insert_FileDocument = gql`
    mutation insert_file($object: file_insert_input!) {
  insert_file_one(object: $object) {
    id
  }
}
    `;
export type Insert_FileMutationFn = Apollo.MutationFunction<Insert_FileMutation, Insert_FileMutationVariables>;

/**
 * __useInsert_FileMutation__
 *
 * To run a mutation, you first call `useInsert_FileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_FileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertFileMutation, { data, loading, error }] = useInsert_FileMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_FileMutation(baseOptions?: Apollo.MutationHookOptions<Insert_FileMutation, Insert_FileMutationVariables>) {
        return Apollo.useMutation<Insert_FileMutation, Insert_FileMutationVariables>(Insert_FileDocument, baseOptions);
      }
export type Insert_FileMutationHookResult = ReturnType<typeof useInsert_FileMutation>;
export type Insert_FileMutationResult = Apollo.MutationResult<Insert_FileMutation>;
export type Insert_FileMutationOptions = Apollo.BaseMutationOptions<Insert_FileMutation, Insert_FileMutationVariables>;
export const Delete_FileDocument = gql`
    mutation delete_file($id: Int!) {
  delete_file_by_pk(id: $id) {
    id
  }
}
    `;
export type Delete_FileMutationFn = Apollo.MutationFunction<Delete_FileMutation, Delete_FileMutationVariables>;

/**
 * __useDelete_FileMutation__
 *
 * To run a mutation, you first call `useDelete_FileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_FileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDelete_FileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_FileMutation(baseOptions?: Apollo.MutationHookOptions<Delete_FileMutation, Delete_FileMutationVariables>) {
        return Apollo.useMutation<Delete_FileMutation, Delete_FileMutationVariables>(Delete_FileDocument, baseOptions);
      }
export type Delete_FileMutationHookResult = ReturnType<typeof useDelete_FileMutation>;
export type Delete_FileMutationResult = Apollo.MutationResult<Delete_FileMutation>;
export type Delete_FileMutationOptions = Apollo.BaseMutationOptions<Delete_FileMutation, Delete_FileMutationVariables>;
export const Delete_File_StoryblokDocument = gql`
    mutation delete_file_storyblok($id: Int!) {
  delete_file_storyblok_by_pk(id: $id) {
    id
  }
}
    `;
export type Delete_File_StoryblokMutationFn = Apollo.MutationFunction<Delete_File_StoryblokMutation, Delete_File_StoryblokMutationVariables>;

/**
 * __useDelete_File_StoryblokMutation__
 *
 * To run a mutation, you first call `useDelete_File_StoryblokMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_File_StoryblokMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileStoryblokMutation, { data, loading, error }] = useDelete_File_StoryblokMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_File_StoryblokMutation(baseOptions?: Apollo.MutationHookOptions<Delete_File_StoryblokMutation, Delete_File_StoryblokMutationVariables>) {
        return Apollo.useMutation<Delete_File_StoryblokMutation, Delete_File_StoryblokMutationVariables>(Delete_File_StoryblokDocument, baseOptions);
      }
export type Delete_File_StoryblokMutationHookResult = ReturnType<typeof useDelete_File_StoryblokMutation>;
export type Delete_File_StoryblokMutationResult = Apollo.MutationResult<Delete_File_StoryblokMutation>;
export type Delete_File_StoryblokMutationOptions = Apollo.BaseMutationOptions<Delete_File_StoryblokMutation, Delete_File_StoryblokMutationVariables>;
export const All_Job_CategoriesDocument = gql`
    query ALL_JOB_CATEGORIES {
  job_category(where: {parent: {name: {_eq: "category"}}}, order_by: [{name: asc}]) {
    id
    name
  }
}
    `;

/**
 * __useAll_Job_CategoriesQuery__
 *
 * To run a query within a React component, call `useAll_Job_CategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAll_Job_CategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAll_Job_CategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAll_Job_CategoriesQuery(baseOptions?: Apollo.QueryHookOptions<All_Job_CategoriesQuery, All_Job_CategoriesQueryVariables>) {
        return Apollo.useQuery<All_Job_CategoriesQuery, All_Job_CategoriesQueryVariables>(All_Job_CategoriesDocument, baseOptions);
      }
export function useAll_Job_CategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<All_Job_CategoriesQuery, All_Job_CategoriesQueryVariables>) {
          return Apollo.useLazyQuery<All_Job_CategoriesQuery, All_Job_CategoriesQueryVariables>(All_Job_CategoriesDocument, baseOptions);
        }
export type All_Job_CategoriesQueryHookResult = ReturnType<typeof useAll_Job_CategoriesQuery>;
export type All_Job_CategoriesLazyQueryHookResult = ReturnType<typeof useAll_Job_CategoriesLazyQuery>;
export type All_Job_CategoriesQueryResult = Apollo.QueryResult<All_Job_CategoriesQuery, All_Job_CategoriesQueryVariables>;
export const All_Job_TypesDocument = gql`
    query ALL_JOB_TYPES {
  job_category(where: {parent_id: {_eq: 8}}, order_by: [{name: asc}]) {
    id
    name
  }
}
    `;

/**
 * __useAll_Job_TypesQuery__
 *
 * To run a query within a React component, call `useAll_Job_TypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAll_Job_TypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAll_Job_TypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAll_Job_TypesQuery(baseOptions?: Apollo.QueryHookOptions<All_Job_TypesQuery, All_Job_TypesQueryVariables>) {
        return Apollo.useQuery<All_Job_TypesQuery, All_Job_TypesQueryVariables>(All_Job_TypesDocument, baseOptions);
      }
export function useAll_Job_TypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<All_Job_TypesQuery, All_Job_TypesQueryVariables>) {
          return Apollo.useLazyQuery<All_Job_TypesQuery, All_Job_TypesQueryVariables>(All_Job_TypesDocument, baseOptions);
        }
export type All_Job_TypesQueryHookResult = ReturnType<typeof useAll_Job_TypesQuery>;
export type All_Job_TypesLazyQueryHookResult = ReturnType<typeof useAll_Job_TypesLazyQuery>;
export type All_Job_TypesQueryResult = Apollo.QueryResult<All_Job_TypesQuery, All_Job_TypesQueryVariables>;
export const All_Job_Sub_CategoriesDocument = gql`
    query ALL_JOB_SUB_CATEGORIES($id: Int!) {
  job_category(where: {parent_id: {_eq: $id}}) {
    id
    name
  }
}
    `;

/**
 * __useAll_Job_Sub_CategoriesQuery__
 *
 * To run a query within a React component, call `useAll_Job_Sub_CategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAll_Job_Sub_CategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAll_Job_Sub_CategoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAll_Job_Sub_CategoriesQuery(baseOptions?: Apollo.QueryHookOptions<All_Job_Sub_CategoriesQuery, All_Job_Sub_CategoriesQueryVariables>) {
        return Apollo.useQuery<All_Job_Sub_CategoriesQuery, All_Job_Sub_CategoriesQueryVariables>(All_Job_Sub_CategoriesDocument, baseOptions);
      }
export function useAll_Job_Sub_CategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<All_Job_Sub_CategoriesQuery, All_Job_Sub_CategoriesQueryVariables>) {
          return Apollo.useLazyQuery<All_Job_Sub_CategoriesQuery, All_Job_Sub_CategoriesQueryVariables>(All_Job_Sub_CategoriesDocument, baseOptions);
        }
export type All_Job_Sub_CategoriesQueryHookResult = ReturnType<typeof useAll_Job_Sub_CategoriesQuery>;
export type All_Job_Sub_CategoriesLazyQueryHookResult = ReturnType<typeof useAll_Job_Sub_CategoriesLazyQuery>;
export type All_Job_Sub_CategoriesQueryResult = Apollo.QueryResult<All_Job_Sub_CategoriesQuery, All_Job_Sub_CategoriesQueryVariables>;
export const Update_UserDocument = gql`
    mutation UPDATE_USER($id: Int!, $_set: users_set_input) {
  update_users_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export type Update_UserMutationFn = Apollo.MutationFunction<Update_UserMutation, Update_UserMutationVariables>;

/**
 * __useUpdate_UserMutation__
 *
 * To run a mutation, you first call `useUpdate_UserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_UserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdate_UserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_UserMutation(baseOptions?: Apollo.MutationHookOptions<Update_UserMutation, Update_UserMutationVariables>) {
        return Apollo.useMutation<Update_UserMutation, Update_UserMutationVariables>(Update_UserDocument, baseOptions);
      }
export type Update_UserMutationHookResult = ReturnType<typeof useUpdate_UserMutation>;
export type Update_UserMutationResult = Apollo.MutationResult<Update_UserMutation>;
export type Update_UserMutationOptions = Apollo.BaseMutationOptions<Update_UserMutation, Update_UserMutationVariables>;
export const User_QueryDocument = gql`
    query USER_QUERY($id: Int!) {
  users(where: {id: {_eq: $id}}) {
    id
    email
    first_name
    last_name
    role
  }
}
    `;

/**
 * __useUser_QueryQuery__
 *
 * To run a query within a React component, call `useUser_QueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUser_QueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUser_QueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUser_QueryQuery(baseOptions?: Apollo.QueryHookOptions<User_QueryQuery, User_QueryQueryVariables>) {
        return Apollo.useQuery<User_QueryQuery, User_QueryQueryVariables>(User_QueryDocument, baseOptions);
      }
export function useUser_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<User_QueryQuery, User_QueryQueryVariables>) {
          return Apollo.useLazyQuery<User_QueryQuery, User_QueryQueryVariables>(User_QueryDocument, baseOptions);
        }
export type User_QueryQueryHookResult = ReturnType<typeof useUser_QueryQuery>;
export type User_QueryLazyQueryHookResult = ReturnType<typeof useUser_QueryLazyQuery>;
export type User_QueryQueryResult = Apollo.QueryResult<User_QueryQuery, User_QueryQueryVariables>;
export const User_By_PkDocument = gql`
    query USER_BY_PK($id: Int!) {
  users_by_pk(id: $id) {
    id
    first_name
    last_name
    email
  }
}
    `;

/**
 * __useUser_By_PkQuery__
 *
 * To run a query within a React component, call `useUser_By_PkQuery` and pass it any options that fit your needs.
 * When your component renders, `useUser_By_PkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUser_By_PkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUser_By_PkQuery(baseOptions?: Apollo.QueryHookOptions<User_By_PkQuery, User_By_PkQueryVariables>) {
        return Apollo.useQuery<User_By_PkQuery, User_By_PkQueryVariables>(User_By_PkDocument, baseOptions);
      }
export function useUser_By_PkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<User_By_PkQuery, User_By_PkQueryVariables>) {
          return Apollo.useLazyQuery<User_By_PkQuery, User_By_PkQueryVariables>(User_By_PkDocument, baseOptions);
        }
export type User_By_PkQueryHookResult = ReturnType<typeof useUser_By_PkQuery>;
export type User_By_PkLazyQueryHookResult = ReturnType<typeof useUser_By_PkLazyQuery>;
export type User_By_PkQueryResult = Apollo.QueryResult<User_By_PkQuery, User_By_PkQueryVariables>;

      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": []
  }
};
      export default result;
    